export const locale = {
  lang: 'es',
  EVENING: 'NOCHE',
  FULL_DAY: 'TODO EL DÍA',
  MORNING: 'MAÑANA',
  beforeDueDate: 'ANTES',
  afterDueDate: 'DESPUÉS',
  REMINDER_OR_LINK: 'Recordatorio o link directo ',
  GLOBAL: {
    NO: ' No',
    YES: ' Sí',
    CANCEL: 'Cancelar',
    TOTAL: 'Total',
    DELETED: ' Eliminar',
    ACTION_SUCCESSFUL: 'Acción realizada con éxito',
    ERROR: 'Error',
    TRY_AGAIN_LATER: 'Por favor, inténtalo de nuevo más tarde',
    SOMETHING_WENT_WRONG: 'Algo salió mal',
    ERRORS: {
      UNAUTHORIZED_TITLE: 'Acceso denegado',
      UNAUTHORIZED_DETAIL: 'No tienes permisos para realizar esta acción.',
      NETWORK_TITLE: 'Error de conexión',
      NETWORK_DETAIL: 'No se pudo conectar con el servidor. Inténtalo de nuevo.',
    },
  },
  LAYOUT: {
    ANNOUNCEMENT_BANNER: {
      HEADLINE: 'Nuevo canal disponible',
      SUB: 'Ahora puedes comunicarte con tus clientes por',
      SUB_HIGHLIGHT: 'WhatsApp',
      CTA: 'Descubrir',
      ARIA_CLOSE: 'Cerrar aviso',
    },
  },
  MENU: {
    OUTBOUNDCALL: 'Llamadas',
    CHAT_CONVERSATIONS: 'WhatsApp',
    PANEL: 'Panel',
    CUSTOMER_JOURNEY: 'Customer Journey',
    BEHAVIORAL_PILL: 'Píldora Conductual',
    OPERATIVA: 'Operativa',
    CLIENTS: 'Clientes',
    INSTANCES: 'Expedientes',
    OPERATIONS: 'Operaciones',
    PAYMENT_AGREEMENTS: 'Acuerdos de Pago',
    CAMPAIGNS_MANAGER: 'Gestor de Campañas',
    CAMPAIGNS: 'Campañas',
    PORTFOLIOS: 'Carteras',
    TEMPLATES: 'Plantillas',
    SEGMENTS: 'Segmentos',
    ADMINISTRATION: 'Administración',
    CONFIGURATION: 'Configuración',
    COLLECTOR_PROFILES: 'Perfiles de Cobro',
    BRANDS: 'Marcas',
    NOTIFICATION_CHANNELS: 'Canales de Notificación',
    FEEDBACK_OPTIONS: 'Opciones de Feedback',
    PAYMENT_METHODS: 'Métodos de Pago',
    USERS: 'Usuarios',
    TAX_ENTITIES: 'Entidades Fiscales',
    SERVICES: 'Servicios',
    REGIONAL_CONFIGURATION: 'Configuración Regional',
    DATA_SHARING: 'Compartir Datos',
    PHASES: 'Fases',
    AUTOMATIONS: 'Automatizaciones',
    KYC_DOCUMENTATION: 'Documentación KYC',
    KYC_DOCUMENTATION_PAYCOMET: 'Documentación KYC Paycomet',
  },
  DATA: {
    REPORTS: 'REPORTES',
    CHANNEL: {
      EMAIL: 'Email',
      PHONE: 'Teléfono',
      SMS: 'SMS',
      CERTIFIED_SMS: 'SMS certificado',
      CERTIFIED_EMAIL: 'Email certificado',
    },
    COMMON: {
      GENDER: {
        MALE: '♂ Hombre',
        FEMALE: '♀ Mujer',
        NOT_KNOWN: 'Prefiero no decirlo',
        NON_BINARY: 'No binario',
      },
      CHANNEL: {
        EMAIL: 'Email',
        PHONE: 'Teléfono',
      },
      DAYS_OF_WEEK: {
        MONDAY: 'Lunes',
        TUESDAY: 'Martes',
        WEDNESDAY: 'Miércoles',
        THURSDAY: 'Jueves',
        FRIDAY: 'Viernes',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo',
      },
      COUNTRIES: {
        ES: 'Español',
        ES_MX: 'Español (México)',
        EN: 'Inglés',
        CA: 'Catalán',
        CA_ES_VALENCIA: 'Valenciano',
        GL: 'Gallego',
        FR: 'Francés',
        NL: 'Neerlandés',
        PT: 'Portugués',
        DE: 'Alemán',
        MX: 'Español (México)',
        GB: 'Inglés',
        CAT: 'Catalán',
        IT: 'Italiano',
        EU: 'Euskera',
      },
      PAGINATOR: '{first} - {last} de {totalRecords} resultados',
      PROFILE: {
        HELLO: 'Hola,',
      },
      WORKFLOW_TYPE: {
        PILL: 'Píldora',
        DRIP: 'Continua',
      },
      SECTOR: {
        ENERGIA: 'Energía',
        FINANZAS: 'Finanzas',
        SEGUROS: 'Seguros',
        TELECOMUNICACIONES: 'Telecomunicaciones',
        GIMNASIOS: 'Gimnasios',
        TRASTEROS: 'Trasteros',
        UTILITIES: 'Utilities',
      },
      TREATMENT: {
        TU: 'Tú',
        USTED: 'Usted',
      },
      TONE: {
        BAJO: 'Baja',
        MEDIO: 'Medio',
        ALTO: 'Alto',
      },
      CAMPAIGN_TYPE: {
        ON_HOLD_PILL: 'En espera / Píldora',
        ON_HOLD_DRIP: 'En espera / Contínua',
        PENDING_PILL: 'Pendiente / Píldora',
        PENDING_DRIP: 'Pendiente / Contínua',
        IN_ALLEGATIONS_PILL: 'Alegaciones / Píldora',
        IN_ALLEGATIONS_DRIP: 'Alegaciones / Contínua',
        CHARGED_PILL: 'Cobrado / Píldora',
        CHARGED_DRIP: 'Cobrado / Contínua',
        AGREEMENT_PILL: 'Acuerdo de pago / Píldora',
        AGREEMENT_DRIP: 'Acuerdo de pago / Contínua',
        DISCARDED_PILL: 'Descartado / Píldora',
        DISCARDED_DRIP: 'Descartado / Contínua',
        OPENED_PILL: 'Abierto / Píldora',
        OPENED_DRIP: 'Abierto / Contínua',
        OPEN_PILL: 'Abierto / Píldora',
        OPEN_DRIP: 'Abierto / Contínua',
        CLOSED_PILL: 'Cerrado / Píldora',
        CLOSED_DRIP: 'Cerrado / Contínua',
        CREATED_PILL: 'Creado / Píldora',
        CREATED_DRIP: 'Creado / Contínua',
        CLOSE_PILL: 'Cerrado / Píldora',
        CLOSE_DRIP: 'Cerrado / Contínua',
        WORKED_PILL: 'Trabajado / Píldora',
        WORKED_DRIP: 'Trabajado / Contínua',
        SILENCED_PILL: 'Silenciado / Píldora',
        SILENCED_DRIP: 'Silenciado / Contínua',
        QUEUED_PILL: 'En cola / Píldora',
        QUEUED_DRIP: 'En cola / Contínua',
        GENERATING_PILL: 'Generando / Píldora',
        GENERATING_DRIP: 'Generando / Contínua',
        GENERATED_PILL: 'Generado / Píldora',
        GENERATED_DRIP: 'Generado / Contínua',
        FAILED_PILL: 'Fallo / Píldora',
        FAILED_DRIP: 'Fallo / Contínua',
        ARCHIVED_PILL: 'Archivado / Píldora',
        ARCHIVED_DRIP: 'Archivado / Contínua',
        DRAFT_PILL: 'Borrador / Píldora',
        DRAFT_DRIP: 'Borrador / Contínua',
        COMMITTED_PILL: 'Carga finalizada / Píldora',
        COMMITTED_DRIP: 'Carga finalizada / Contínua',
        PROCESSING_PILL: 'Procesando / Píldora',
        PROCESSING_DRIP: 'Procesando / Contínua',
        COMMITTING_PILL: 'Cargando / Píldora',
        COMMITTING_DRIP: 'Cargando / Contínua',
        INVALID_FILE_PILL: 'Archivo inválido / Píldora',
        INVALID_FILE_DRIP: 'Archivo inválido / Contínua',
        VALID_PILL: 'Válido / Píldora',
        VALID_DRIP: 'Válido / Contínua',
        NOT_VALID_PILL: 'No válido / Píldora',
        NOT_VALID_DRIP: 'No válido / Contínua',
        PAUSED_PILL: 'Pausado / Píldora',
        PAUSED_DRIP: 'Pausado / Contínua',
        PUBLISHED_PILL: 'Publicado / Píldora',
        PUBLISHED_DRIP: 'Publicado / Contínua',
        UNPUBLISHED_PILL: 'Archivado / Píldora',
        UNPUBLISHED_DRIP: 'Archivado / Contínua',
        RUNNING_PILL: 'Activo / Píldora',
        RUNNING_DRIP: 'Activo / Contínua',
        EXPIRED_PILL: 'Expirado / Píldora',
        EXPIRED_DRIP: 'Expirado / Contínua',
        PROPOSAL_PILL: 'Propuesta / Píldora',
        PROPOSAL_DRIP: 'Propuesta / Contínua',
        SIGNED_PILL: 'Firmado / Píldora',
        SIGNED_DRIP: 'Firmado / Contínua',
        FULFILLED_PILL: 'Completado / Píldora',
        FULFILLED_DRIP: 'Completado / Contínua',
        BROKEN_PILL: 'Roto / Píldora',
        BROKEN_DRIP: 'Roto / Contínua',
        STARTED_PILL: 'Iniciado / Píldora',
        STARTED_DRIP: 'Iniciado / Contínua',
        NOTIFYING_PILL: 'Notificando / Píldora',
        NOTIFYING_DRIP: 'Notificando / Contínua',
        BLACKLISTED_PILL: 'Lista negra / Píldora',
        BLACKLISTED_DRIP: 'Lista negra / Contínua',
      },
      TARGET: {
        AMISTOSO: 'Amistoso',
        RECORDATORIO: 'Recordatorio',
        AVISO_SUSPENSION_SERVICIOS: 'Aviso suspensión de servicios',
        CONFIRMACION_SUSPENSION_SERVICIOS: 'Confirmación suspensión de servicios',
        AVISO_BAJA_SERVICIO: 'Aviso baja definitiva del servicio',
        CONFIRMACION_BAJA_SERVICIO: 'Confirmación baja definitiva del servicio',
        AVISO_FIN_CONTRATO: 'Aviso finalización de contrato',
        CONFIRMACION_FIN_CONTRATO: 'Confirmación finalización de contrato',
        AVISO_INCLUSION_BBDD:
          'Aviso de inclusión en las bbdd públicas de deudores (asnef/badexcug)',
        AVISO_INCIDENCIAS_LEGALES: 'Aviso posibles incidencias legales',
        CONFIRMACION_INCIDENCIAS_LEGALES: 'Confirmación incidencias legales',
      },
      PLACEHOLDER: {
        short_name: '%nombre corto%',
        long_name: '%nombre largo%',
        tax_entity_society: '%nombre entidad fiscal%',
        tax_entity_vat_number: '%cif entidad fiscal%',
        case_amount: '%importe caso%',
        send_date: '%fecha de envío%',
        brand: '%marca%',
        pending_operations: '%operaciones pendientes%',
        customer_external_id: '%external id del cliente%',
        tin: '%nif cliente%',
        operation_title: '%título de la operación%',
        operation_external_id: '%external id de la operación%',
        customer_nif: '%nif cliente%',
        PERSONALIZADO: '$PERSONALIZADO$',
      },
      HUSO: {
        LABEL: 'Huso horario',
        BUTTON_TEXT: 'Asigna huso horario',
        HEADER: 'Seleccionar huso horario',
        TOOLTIP:
          'Ajusta la zona horaria para ver las horas exactas de pagos en otros países. Por ejemplo, si estás en España, puedes ver a qué hora se realizaron pagos en México o Perú.',
      },
      ASK: 'Pregunta',
      NURIA_CHAT: {
        TITLE: 'NurIA',
        CONNECTING: 'Conectando con NurIA…',
        SESSION_STARTED: 'La sesión ha comenzado.',
        STATUS_CONNECTING: 'conectando',
        STATUS_CONNECTED: 'conectado',
        PLACEHOLDER:
          'Escribe por ejemplo: "¿Los mensajes perdidos se reenvían solos o hay que hacer algo?"',
        EXPAND: 'Ampliar',
        COLLAPSE: 'Reducir',
        CLOSE: 'Cerrar',
        RATE_TOOLTIP: 'Valorar esta conversación',
        PER_MSG_QUESTION: '¿Fue útil esta respuesta?',
        PER_MSG_LIKE: 'Sí, fue útil',
        PER_MSG_DISLIKE: 'No fue útil',
        COMMENT_PLACEHOLDER: 'Añade un comentario (opcional)…',
        SEND_FEEDBACK: 'Enviar valoración',
        RATE_TITLE: 'Valora esta conversación',
        STAR: 'estrella',
        STARS: 'estrellas',
        FEEDBACK_SENT_TITLE: '¡Gracias!',
        FEEDBACK_SENT_SUBTITLE: 'Tu valoración ha sido enviada.',
      },
      GENERIC: {
        NOT_FOUND: 'No encontrado',
        IS: 'es',
        MORE: 'más',
        RESET_FILTERS: 'Limpiars filtros',
      },
      NAMES: {
        CAMPAIGN: 'campaña',
        PILL: 'píldora',
        COLLECTOR: 'perfil de cobro',
      },
      OWNER: {
        BUSINESS: 'Empresa',
        PRIVATE: 'Privado',
      },
      ACTIONS: {
        PUBLISH: 'Publicar ',
        DRAFT: 'Archivar ',
        PAUSED: 'Pausar ',
        SAVE: 'Guardar',
        DELETE: 'Eliminar',
        DRAFT_INFO: 'No hay cambios de estado disponibles',
        CANCEL: 'Cancelar',
        SEND: 'Enviar',
        DOWNLOAD: 'Descargar',
        CLONE: 'Clonar',
        SEARCH: 'Buscar',
        FILTERS: 'Filtros',
        SELECT_PLACEHOLDER: 'Selecciona {{placeholder}}',
        APPLY_FILTERS: 'Aplicar filtros',
        QUESTION: '¿Quieres ejecutar esta acción?',
        PARTIAL_PAYMENT: 'Pago parcial',
        INSTANCES_ACTIONS: 'Acciones de expedientes',
        CLOSE: 'Cerrar',
        CLEAR_FILTERS: 'Limpiar filtros',
        ADD: 'Añadir',
        SELECT_CASE_TOOLTIP: 'Selecciona al menos un expediente',
      },
      USER_MENU: {
        PROFILE: 'Perfil',
        LANGUAGE: 'Lenguaje',
        LANGUAGE_PLACEHOLDER: 'Lenguaje',
        LOG_OUT: 'Cerrar sesión',
      },
      SEARCH: {
        SEARCH_BUTTON: 'Buscar',
        RESET_BUTTON: 'Limpiar',
        PLACEHOLDER_DROPDOWN: 'Selecciona una opción',
      },
      FORM_BUTTONS: {
        SAVE: 'Guardar',
        CANCEL: 'Cancelar',
        SEND: 'Enviar',
        CONFIRM: 'Confirmar',
        EDIT: 'Editar',
        CLONE: 'Clonar',
      },
      TOAST: {
        SUCCESS: 'Èxito',
        ERROR: 'Error',
        SUCCESS_EMAIL: 'Recordatorio enviado correctamente a {{email}}',
        SUCCESS_SMS: 'Recordatorio enviado correctamente a {{sms}}',
        NO_NOTIFICATED: 'No se envío la notificación',
        CONFIRMED: 'Confirmado!',
        CONFIRMED_EXECUTION: 'Acción ejecutada correctamente',
        SCENARIOS: {
          LIST: {
            ERROR: 'Error al listar los elementos',
          },
        },
        COPIED: 'Copiado!',
        COPIED_TEXT: 'Texto {{text}} copiado correctamente',
        COPY_ID: 'Copía id',
      },
      PERMISSIONS: {
        activity: 'Actividad',
        administration: 'Administración',
        business_insight: 'Análisis Comercial',
        campaign_calendar_queries: 'Consultas de Calendario de Campaña',
        collector: 'Cobrador',
        conversations: 'Conversaciones',
        copy: 'Copiar',
        customer_case: 'Caso de Cliente',
        dashboard: 'Tablero',
        listing: 'Listado',
        operation_import: 'Importación de Operación',
        portfolio: 'Cartera',
        reports: 'Reportes',
        segment: 'Segmento',
        tag: 'Etiqueta',
        user_administration: 'Administración de Usuarios',
        user: 'Usuario',
        workflow: 'Flujo de Trabajo',
        operation: {
          export: 'Exportar operaciones',
        },
        customer: {
          export: 'Exportar clientes',
        },
        import: {
          commit: 'Ejecutar importación',
        },
      },
      FILTER: {
        RANGE_IMPORT: 'Filtra {{nameModule}} según el monto mínimo y máximo especificado.',
        RANGE_DATE: 'Filtra registros seleccionando una fecha de inicio y una fecha de fin..',
        COMPLEX_CAMPAIGN:
          'Filtra expedientes según si están o han estado en campañas seleccionadas, en estado actual o histórico.',
        CHIPS:
          'Busca por {{nameFilter}}. También puedes buscar varios elementos separados por coma. Ejemplo: {{ejemplos}}',
        MULTISELECT:
          'Busca y selecciona uno o varios {{nameFilter}}. El filtro permite múltiples selecciones; escribe para filtrar la lista y haz clic en las opciones deseadas.',
      },
      TIME: {
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        LAST_WEEK: 'Última semana',
        LAST_MONTH: 'Último mes',
        LAST_YEAR: 'Último año',
        DAYS: 'días',
        DAY: 'día',
        MONTH: 'mes',
        MONTHS: 'meses',
      },
      DAYS: 'días',
      GENDERS: {
        MALE: 'Hombre',
        FEMALE: 'Mujer',
        NOT_KNOW: 'Prefiero no decirlo',
        NOT_BINARY: 'No binario',
      },
      MONTHS: {
        JANUARY: 'Enero',
        FEBRUARY: 'Febrero',
        MARCH: 'Marzo',
        APRIL: 'Abril',
        MAY: 'Mayo',
        JUNE: 'Junio',
        JULY: 'Julio',
        AUGUST: 'Agosto',
        SEPTEMBER: 'Septiembre',
        OCTOBER: 'Octubre',
        NOVEMBER: 'Noviembre',
        DECEMBER: 'Diciembre',
      },
      LANGUAGES: {
        ES: 'Español',
        EN: 'Inglés',
        CA: 'Catalán',
        FR: 'Francés',
        CV: 'Valenciano',
      },
      PAYMENT_METHODS: {
        CASH: 'Efectivo',
        BANK_TRANSFER: 'Transferencia bancaria',
        OTHER: 'Otro',
        DIRECT_DEBIT: 'Domiciliación bancaria',
        CREDIT_CARD: 'Tarjeta de crédito',
        PAYMEFY: 'Paymefy',
        UNKNOWN: 'Método Desconocido',
      },
      STATUS: {
        on_hold: 'En espera',
        pending: 'Pendiente',
        blocked: 'Bloqueado',
        in_allegations: 'Alegaciones',
        charged: 'Cobrado',
        agreement: 'Acuerdo de pago',
        discarded: 'Descartado',
        opened: 'Abierto',
        open: 'Abierto',
        closed: 'Cerrado',
        created: 'Creado',
        close: 'Cerrado',
        worked: 'Trabajado',
        silenced: 'Silenciado',
        queued: 'En cola',
        generating: 'Generando',
        generated: 'Generado',
        failed: 'Fallo',
        archived: 'Archivado',
        draft: 'Borrador',
        committed: 'Carga finalizada',
        processing: 'Procesando',
        committing: 'Cargando',
        invalid_file: 'Archivo inválido',
        valid: 'Válido',
        not_valid: 'No válido',
        paused: 'Pausado',
        published: 'Publicado',
        unpublished: 'Archivado',
        running: 'Activo',
        expired: 'Expirado',
        proposal: 'Propuesta',
        signed: 'Firmado',
        fulfilled: 'Completado',
        broken: 'Roto',
        started: 'Iniciado',
        notifying: 'Notificando',
        blacklisted: 'Lista negra',
        calling: 'Llamando',
        completed: 'Completado',
        in_progress: 'En progreso',
      },
      TIME_OF_WEEK: {
        FULL_DAY: 'Todo el día',
        EVENING: 'La tarde',
        MORNING: 'La mañana',
      },
      CHARACTERS: 'Carácteres',
      FILTERS: {
        RANGE: {
          MIN: 'Mín',
          MAX: 'Máx',
        },
        CHIPS: {
          PLACEHOLDER: 'Entra {{label}}',
          ADD: 'Añadir',
        },
        NO_OPTIONS: 'No hay opciones disponibles',
        LOADING: 'Cargando filtro…',
      },
      FORM: {
        PLACEHOLDER_RANGE: 'Fecha inicio - Fecha fin',
        ERROR: {
          MIN_LENGTH: 'La longitud mínima requerida es de {{requiredLength}} caracteres.',
          MAX_LENGTH: 'La longitud máxima permitida es de {{requiredLength}} caracteres.',
          MIN: 'El valor mínimo permitido es {{min}}.',
          MAX: 'El valor máximo permitido es {{max}}.',
          MAX_CHAR: 'Máximo de {{maxChar}} caracteres permitidos. Has entrado {{actual}}.',
          MIN_ELEMENTS_IN_ARRAY: 'Se requieren al menos {{amount}} elementos.',
          REQUIRED: 'Este campo es obligatorio.',
          EMAIL: 'Introduce una dirección de correo electrónico válida.',
          PATTERN: 'Formato no válido.',
          EMPTY_VALUE: 'Este campo no puede estar vacío.',
          INVALID_DNI_NIF: 'Formato de DNI o NIF no válido.',
          INVALID_CP: 'Formato de código postal no válido.',
          MAX_SAFE_INTEGER: 'Se ha excedido el número máximo aceptado.',
          INVALID_ALPHA_DIGIT: 'Formato de alias no válido.',
          EMAIL_OR_PHONE: 'El email o el teléfono deben rellarse.',
          IBAN: 'Formato de IBAN no válido.',
          BIC: 'Formato de BIC no válido.',
          FUTURE_DATE: 'La fecha debe estar en el futuro.',
          MAX_IMPORT_ON_TOTAL_AMOUNT: 'El importe no puede exceder el total.',
          STARTS_WITH_AND_ENDS_WITH: 'El campo debe empezar y terminar con {{char}}.',
          RANGE_INVALID: 'El campo final no puede ser mayor que el campo inicial.',
          RANGE_NOT_COMPLETED: 'Los campos de inicio y fin deben estar ambos completos o vacíos.',
          ALL_OPTIONS_SELECTED: 'No se pueden seleccionar todas las opciones.',
          SELECT_RANGE_DATES: 'Selecciona un rango de fechas correcto',
          TOTAL_NEGATIVE: 'EL importe total de la operación no puede ser negativo',
          PHONE_WRONG: 'EL formato de algún teléfono es incorrecto',
          PHONE_CODE: 'El número de teléfono no es válido, ejemplo: +34000000000',
          HTTP: 'La URL debe comenzar con http:// o https://',
          URL_NOT_VALID: 'La URL no es válida, ejemplo: https://example.com',
          SELECT_CHILD: 'Selecciona un valor sin desglose',
          ALIAS: 'El ALIAS contiene caracteres no permitidos',
          RANGE_INCOMPLETE: 'Rango de fechas incompleto',
          RANGE_TOO_LONG: 'Rango de fechas demasiado largo, {{maxMonths}} meses máximo',
        },
      },
    },
    WEEK_DAYS: {
      MONDAY: 'Lunes',
      TUESDAY: 'Martes',
      WEDNESDAY: 'Miércoles',
      THURSDAY: 'Jueves',
      FRIDAY: 'Viernes',
      SATURDAY: 'Sábado',
      SUNDAY: 'Domingo',
    },
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    MENU: {
      SIDE: {
        DASHBOARD: 'panel',
        ANALYTICS: 'Analytics',
        CRM: {
          CRM: 'CRM',
          IMPORT_LINES: 'Listado de importaciones',
          EXPEDIENTS: 'Operaciones',
          CUSTOMERS: 'Clientes',
          PAYMENT_AGREEMENT: 'Acuerdos de pago',
          SEGMENTS: 'Segmentos',
          PORTFOLIOS: 'Carteras',
        },
        CAMPAIGN_MANAGER: {
          CAMPAIGN_MANAGER: 'Campaign Manager',
          CAMPAIGNS: 'Campañas',
          COLLECTION_CYCLE: 'Ciclos de cobro',
          WORKFLOW: 'Flujo automático',
          TEMPLATES: 'Plantillas',
        },
        ADMINISTRATION: {
          ADMINISTRATION: 'Administración',
          INVOICES: 'Facturas',
          USERS: 'Usuarios',
          COLLECTORS: 'Collectors',
          REGIONAL_CONFIG: 'Configuración regional',
          PAYMENT_SOLUTION: 'Soluciones de pago',
          BRANDS: 'Marcas',
          TAX_ENTITIES: 'Entidades fiscales',
          PAYMENT_METHODS: 'Métodos de pago',
          NOTIFICATION_CHANNELS: 'Canales de notificación',
          FEEDBACK_OPTIONS: 'Opciones de Feedback',
          SERVICES: 'Servicios',
          EVENT_HOOK: 'Métodos de seguimiento',
        },
      },
    },
    ADMIN: {
      TITLE: 'Administración',
      MODULES: {
        COPIES: {
          CHANNEL: 'Canal',
          LANGUAGE: 'Idioma',
          SEARCH: 'Búsqueda',
          GENERATE_IA: 'Generar con IA',
          WANT_DELETE: '¿Quieres eliminar {{name}}?',
          TEMPLATE_DELETE: 'Eliminar plantilla',
          TEMPLATE_DELETED: 'Plantilla elminada correctamente',
          CLONED: 'Plantilla clonada con éxito',
          CLONED_ERROR: 'No se pudo clonar la plantilla',
          CLONED_NAME: 'Añade un nombre para la nueva plantilla:',
          CLONED_HEADER: 'Clonar la plantilla',
          CLONED_NAME_NEW: 'Nombre:',
          NEW_TEMPLATE: 'Crear plantilla',
          ALL_CHANNELS: 'Todos los canales',
          SMS: 'SMS',
          SAVE_CHANGES: 'Guardar cambios',
          EMAIL: 'Correo electrónico',
          CERTIFIED_SMS: 'SMS Certificado',
          CERTIFIED_EMAIL: 'Correo Certificado',
          SEARCH_PLACEHOLDER: 'Buscar plantilla por nombre...',
          LANGUAGE_FILTER: 'Idioma',
          IN_USE: 'En uso',
          TEMPLATES_COUNT: 'plantillas',
          RESET_FILTERS: 'Limpiar filtros',
          NAME: 'Nombre',
          VERSION: 'Versión',
          LAST_UPDATE: 'Última actualización',
          REMINDER: 'Recordatorio',
          PAYMENT_AGREEMENT: 'Acuerdo de pago',
          ACTIONS: 'Acciones',
          NO_TEMPLATES: 'No hay plantillas para mostrar',
          TOOLTIP_EDIT: 'Editar plantilla',
          TOOLTIP_CLONE: 'Clonar plantilla',
          TOOLTIP_DELETE: 'Eliminar plantilla',
          CREATE_TEMPLATE: 'Crear plantilla',
          AUTOCOMPLETE_GPT: 'Autocompletar con Chat GPT',
          INFO_TEMPLATE: 'Info sobre plantillas',
          TOOLTIP_MUST_FIELDS: 'Por favor, completa los campos obligatórios',
          GENERATING_TEMPLATE: 'Generando plantilla...',
          CLEAN: 'Limpiar',
          INFO_SMS: 'Info SMS',
          TOOLTIP_ICON:
            'Recuerda que la longitud máxima de un SMS es de <b>160 caracteres</b>, mientras que los paylinks ocupan aproximadamente 35 caracteres en la posición final del texto. Para evitar duplicar el costo del SMS, es importante mantener el texto por debajo de los <b>125 caracteres</b>.',
          TOOLTIP_RECOMMENDATION:
            'Para controlar mejor los gastos de SMS, te recomendamos <b>usar los placeholders de manera limitada</b> en este canal. El contenido del mensaje puede variar, lo que podría resultar en el envío de dos SMS en lugar de uno si se supera el límite de caracteres.',
          SMS_CERTIFIED_INFO: {
            ICON: "Para configurar tus notificaciones correctamente, es esencial definir el tipo de SMS certificado que deseas enviar. Ten en cuenta que a cada tipo de SMS se le agregará la mención al final del SMS: '(SMS CERTIFICADO)' y el paylink.",
            COUNTER_INFO: 'Nuestro contador ya descuenta estos caracteres.',
            LENGTH_AND_COST:
              'En cuanto a la longitud y el control de costos, ofrecemos los siguientes tipos de SMS certificados:',
            TYPES: {
              MINI: 'Mini (108 caracteres)',
              STANDARD: 'Estándar (560 caracteres)',
              TWO_SMS: '2 SMS Certificados (1,784 caracteres)',
              THREE_SMS: '3 SMS Certificados (2,396 caracteres)',
            },
            SELECTION_INSTRUCTIONS:
              'Selecciona la longitud deseada y completa el campo de texto con el contenido y los placeholders que desees utilizar. Recuerda que el número de caracteres afecta el costo y la efectividad de tu comunicación.',
            RECOMMENDATION:
              'Elige el tipo de SMS certificado que mejor se adapte a tus necesidades de mensaje y presupuesto.',
          },
          FORM: {
            SECTOR: 'Sector',
            CASE: 'Asunto',
            TEXT: 'Texto',
            TEXT_BUTTON: 'Texto del botón',
            CLIENT_TREATMENT: 'Tratamiento al cliente',
            GOAL_MSG: 'Objetivo del mensaje',
            INTENSITY_MSG: 'Intensidad del mensaje',
            VARIABLES: 'Variables',
            OP_ADVANCED: 'Opciones avanzadas',
            NUMB_CHARACTERS: 'Número de caracteres',
            NAME: 'Nombre',
            PRE_HEADER: 'Pre encabezado',
            LANGUAGE: 'Idiomas',
            CHANNEL: 'Canal',
            ALIAS: 'Alias',
            TEMPLATE_MAIL: 'ID de plantilla de correo',
            TOOLTIP_PRE: 'Máximo 125 caracteres',
            TOOLTIP_ALIAS:
              'El campo ALIAS es opcional y sirve para asignarle un identificador único a una plantilla de cualquier canal.\n' +
              '\n' +
              '    Los caracteres que se admiten son:\n' +
              '    a b c d e f g h i j k l m n o p q r s t u v w x y z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z 0 1 2 3 4 5 6 7 8 9 - _ . ~ .\n' +
              '\n' +
              '    No se permiten espacios',
            // Form UI
            CONFIG: 'Configuración',
            CONTENT: 'Contenido',
            ACTIVE_CHANNEL: 'Canal activo',
            APPLIES_TO_ALL: 'Se aplica a todos los idiomas',
            NAME_HINT: 'Sólo visible en el panel — no aparece en el mensaje',
            LANGUAGE_HINT: 'Una pestaña por idioma, con su propio contenido',
            CHANNEL_HINT: 'Cambiarlo ajusta los campos y la vista previa',
            CHANNEL_PLACEHOLDER: 'Selecciona un canal...',
            ADD_LANG: 'Añadir...',
            CONTENT_HINT: 'Edita cada idioma en su pestaña',
            INCLUDE_PAYLINK: 'Incluir enlace de pago (Paylink)',
            CANCEL: 'Cancelar',
            PREVIEW: 'VISTA PREVIA · CÓMO LO VERÁ EL CLIENTE',
            BUTTON_HINT: 'Máx. 40 car. Enlaza al Paylink cuando está activado.',
            TOKEN_HINT:
              'Los %campos% se sustituyen por los datos reales de cada cliente al enviar.',
            REQUIRED_HINT: 'Los campos con * son obligatorios en todos los idiomas.',
            CERTIFIED: 'Certificado',
            CERTIFIED_FOOTER:
              'Si no esperaba este mensaje, ignórelo o contacte con el remitente. Envío certificado con acuse legal de entrega.',
            SEGMENTS: 'segmento(s)',
            SMS_SINGLE: 'SMS simple',
            SMS_CONCAT: 'Estándar',
            SMS_CURT: 'Corto',
            SMS_LLARG: 'Estándar',
            SMS_LINEBREAK_ERROR:
              'El texto del SMS no puede contener saltos de línea. Elimínalos antes de guardar.',
            SMS_RULE_CONCAT:
              'Si supera 160 chars → modo concatenado, 153 chars/bloque (mín. 2 bloques).',
            SMS_RULE_CURT: '≤ 160 chars = 1 SMS. El paylink suma 35 al contador.',
            SMS_RULE_LLARG: 'Si supera 160 chars → grupos de 4 SMS × 153 chars/bloque.',
            SMS_PAYLINK_LABEL: 'Paylink · se añade al final',
            SMS_PAYLINK_EXAMPLE: 'https://pay.empresa.com/XXXXXXXX',
            EMAIL_PAYLINK_BUTTON_HINT: 'El botón de acción enlaza al Paylink',
            SMS_EMPTY_BLOCK: 'Bloc buit',
            SMS_GROUP: 'Grup',
            CREATE_SUCCESS: 'Plantilla creada correctamente',
            CONFIRM_CREATE_SMS:
              '¿Estás seguro de que deseas crear la plantilla? Recuerda que esta plantilla enviará {{number}} SMS a cada cliente.',
          },
          USAGES_COLUMN: 'Usos',
          USAGES_NOT_USED: 'Sin usar',
          USAGES_BADGE: '{{count}} campaña(s)',
          USAGES_DRAWER_TITLE: 'Usos de la plantilla',
          USAGES_NODE: 'Nodo',
          USAGES_VIEW_ALL: 'Ver todas ({{count}})',
          USAGES_VIEW_LESS: 'Ver menos',
          USAGES_GO_TO_CAMPAIGN: 'Ir a la campaña',
          USAGES_VIEW_WORKFLOW: 'Ver flujo de trabajo',
          USAGES_IN_USE_NOTE: 'No se puede eliminar mientras esté en uso',
        },
        BRAND: {
          TITLE: 'Marcas',
          PAGES: {
            ADD: {
              TITLE: 'Crear marca',
            },
            EDIT: {
              TITLE: 'Editar marca',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                LOGO: 'LOGO',
                NAME: 'NOMBRE',
                COLLECTORS: 'PERFILES DE COBRO',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_RESULTS: 'No hay marcas que mostrar',
              },
            },
          },
        },
        USERS: {
          TITLE: 'Usuarios',
          PERMISSIONS: {
            EXPAND_ALL: 'Expandir todo',
            COLLAPSE_ALL: 'Colapsar todo',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear usuario',
            },
            EDIT: {
              TITLE: 'Editar usuario',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                SURNAME: 'APELLIDOS',
                ROLE: 'ROL',
                EMAIL: 'EMAIL',
                COLLECTORS: 'PERFILES DE COBRO',
                ACTIONS: 'ACCIONES',
                LANGUAGE: 'LENGUAJE',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_RESULTS: 'No hay usuarios que mostrar',
              },
            },
          },
        },
        PORTFOLIOS: {
          TITLE: 'Carteras',
          FORM: {
            NAME: 'Nombre',
            ALIAS: 'Alias',
            SEARCH: 'Búsqueda',
          },
          MESSAGE: {
            PORTFOLIO_CREATED: 'Cartera creada correctamente',
            PORTFOLIO_UPDATED: 'Cartera actualizada correctamente',
            PORTFOLIO_DELETED: 'Cartera eliminada correctamente',
            SUCCESS: 'Éxito',
            WANT_DELETE: '¿Quieres eliminar {{name}} ?',
            DELETE_PORTFOLIO: 'Eliminar cartera',
            YES: 'Eliminar',
            NO: 'No',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear cartera',
            },
            EDIT: {
              TITLE: 'Editar cartera',
            },
          },
          STATUS: {
            PENDIENTE: 'Pendiente',
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                ALIAS: 'ALIAS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
                CREATE: 'Crear cartera',
              },
              MORE: {
                NO_RESULTS: 'No hay carteras que mostrar',
              },
            },
          },
        },
        TAX_ENTITY: {
          TITLE: 'Entidades fiscales',
          FORM: {
            NAME: 'Nombre',
            ALIAS: 'Alias',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear Entidades fiscal',
            },
            EDIT: {
              TITLE: 'Editar Entidades fiscal',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                SOCIETY: 'RAZÓN SOCIAL',
                NIF: 'NIF',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_RESULTS: 'No hay Entidades fiscales que mostrar',
              },
            },
          },
        },
        SERVICE: {
          TITLE: 'Servicos',
          CATEGORY: {
            advertising: 'Publicidad',
            energy: 'Energía',
            financial_services: 'Servicios financieros',
            insurance: 'Seguros',
            lawyers: 'Abogados',
            others: 'Otros',
            real_estate_services: 'Servicios inmobiliarios',
            telecommunications: 'Telecomunicaciones',
            training: 'Formación',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear Servico',
            },
            EDIT: {
              TITLE: 'Editar Servico',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                CATEGORY: 'CATEGORÍA',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_RESULTS: 'No hay Servicos que mostrar',
              },
            },
          },
        },
        PARTIAL_PAYMENT_CONFIGS: {
          TITLE: 'Soluciones de pago',
          PAGES: {
            ADD: {
              TITLE: 'Crear configuración regional',
            },
            EDIT: {
              TITLE: 'Editar configuración regional',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_COLLECTORS: 'No hay perfiles de cobro asociados',
                NO_RESULTS: 'No hay Configuración de pagos parciales que mostrar',
              },
            },
          },
        },
        EVENT_HOOKS: {
          TITLE: 'Compartir Datos',
          PAGES: {
            ADD: {
              TITLE: 'Crear método de seguimiento',
            },
            EDIT: {
              TITLE: 'Editar método de seguimiento',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                TYPE: 'TIPO',
                URL: 'SEGUIMIENTO',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
                CONTEXT: 'CONTEXTOS',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_COLLECTORS: 'No hay perfiles de cobro asociados',
                NO_RESULTS: 'No hay métodos de seguimiento que mostrar',
              },
            },
          },
        },
        REGIONAL_CONFIGS: {
          TITLE: 'Configuración regional',
          PAGES: {
            ADD: {
              TITLE: 'Crear',
            },
            EDIT: {
              TITLE: 'Editar',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
                TIMETABLE: 'FRANJA HORARIA',
              },
              ACTIONS: {
                CREATE: 'Configuracion regional',
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_COLLECTORS: 'No hay perfiles de cobro asociados',
                NO_RESULTS: 'No hay configuraciones regionales que mostrar',
              },
            },
          },
        },
        PAYMENT_METHODS: {
          TITLE: 'Métodos de pago',
          TYPES: {
            RedsysPaymentGateway: 'Redsys',
            PaycometPaymentGateway: 'Paycomet',
            IngenicoPaymentGateway: 'Ingenico',
            MoneticoPaymentGateway: 'Monetico',
            RedsysBizumPaymentGateway: 'Bizum (Redsys)',
            PaycometMbwayPaymentGateway: 'MBWAY (Paycomet)',
            PaycometBizumPaymentGateway: 'Bizum (Paycomet)',
            PaycometMultibancoSIBSPaymentGateway: 'Paycomet (Multibanco)',
            InespayPaymentGateway: 'Inespay',
            MoneiBizumPaymentGateway: 'Bizum (Monei)',
            StripePaymentGateway: 'Stripe',
            AdyenPaymentGateway: 'Adyen',
            PayuPaymentGateway: 'PayU',
            MoneiPaymentGateway: 'Monei',
            PayNoPainPaymentGateway: 'PayNoPain',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear',
            },
            EDIT: {
              TITLE: 'Editar',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                TYPE: 'TIPO',
                DESCRIPTION: 'DESCRIPCIÓN',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                CREATE: 'Añadir',
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_COLLECTORS: 'No hay perfiles de cobro asociados',
                NO_RESULTS: 'No hay métodos de pago que mostrar',
              },
            },
          },
        },
        FILTERS: {
          SUMMARY_TITLE: 'Resumen de filtros',
          SUMMARY_DESC: 'Estos son los filtros que fueron aplicados en la campaña',
          NO_FILTERS: 'Sin filtros',
          CLOSE: 'Cerrar',
        },
        AUTOMATIONS: {
          START_DATE_FORMAT: '{{day}}, a las {{hours}}:{{minutes}}',
          EACH_MONTH: 'Cada mes',
          SEE_AUTOMATIONS: 'Ver automatizaciones',
          SEE_INSTANCES: 'Ver expedientes',
          NO_DATA: 'No hay automatizaciones configuradas',
          NO_DATA_DESC: 'Crea automatizaciones para poder visualizar la información aquí',
          DESTINATION_CAMPAIGN_LABEL: 'Campaña destino',
          DESTINATION_CAMPAIGN_HELP:
            'Selecciona la campaña a la que quieras que se asignen los expedientes filtrados',
          DESTINATION_CAMPAIGN_PLACEHOLDER: 'Escoge una campaña',
          COPY_CAMPAIGN_NAME: 'Copiar nombre de campaña',

          AUTOMATION_NAME_LABEL: 'Nombre de la automatización',
          AUTOMATION_NAME_HELP: 'El nombre que identifica esta automatización',
          AUTOMATION_NAME_PLACEHOLDER: 'Nombre automatización',

          TIMEZONE_LABEL: 'Huso horario',
          TIMEZONE_HELP: 'Selecciona el huso en el que quieras que se ejecute la automatización',
          TIMEZONE_PLACEHOLDER: 'Selecciona un huso horario',

          START_DAY_LABEL: 'Día de inicio',
          START_DAY_HELP: 'Selecciona la fecha en que iniciará la automatización',

          START_TIME_LABEL: 'Hora de inicio',
          START_TIME_HELP: 'Hora en la que comenzará la automatización',

          ERROR_START_IN_PAST:
            'La fecha y hora de inicio no pueden ser anteriores al momento actual.',
          ERROR_FINISH_BEFORE_START:
            'La fecha de finalización no puede ser menor que la fecha de inicio.',
          ERROR_NAME_MAXLENGTH: 'El nombre no puede tener más de 30 caracteres.',
          ERROR_CAMPAIGN_GROUP:
            'Por favor, selecciona una campaña específica (no un grupo de campañas).',

          VIEW_APPLIED_FILTERS: 'Ver filtros aplicados',

          REPEAT_MONTHLY_LABEL: 'Repetir mensualmente',
          REPEAT_UNTIL_DATE_LABEL: 'Finalizar en una fecha',
          FINISH_DATE_LABEL: 'Selecciona la fecha de finalización',

          CANCEL: 'Cancelar',
          CREATE_AUTOMATION: 'Crear automatización',
          TOOLTIP_CAMPAIGN: 'Ir a campaña',
        },
        COLLECTORS: {
          TITLE: 'Perfiles de cobro',
          PAGES: {},
          SAVE_SUCCESS_POPUP: {
            HEADER: 'Perfil de cobro guardado correctamente.',
            MESSAGE:
              'Este perfil de cobro no está vinculado actualmente a ninguna campaña.\nSi desea que el perfil de cobro reciba notificaciones, vincúlelo a un flujo de trabajo.',
            ACCEPT: 'Aceptar',
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                ALIAS: 'ALIAS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
                CREATE: 'Perfil de cobro',
              },
              MORE: {
                NO_RESULTS: 'No hay perfiles de cobro que mostrar',
              },
            },
          },
          PAYMENT_METHODS_TABLE: {
            UNASSIGN_DIALOG: {
              TITLE: 'Desasignar método de pago',
              WARNING:
                'Al desasignar un método de pago, los acuerdos activos o cobros tokenizados asociados seguirán funcionando. Para detener futuros cargos, asegúrate de cancelar el acuerdo correspondiente.',
              ACCEPT: 'Aceptar',
              CANCEL: 'Cancelar',
            },
          },
        },
        CHANNELS: {
          TITLE: 'Canales de notificación',
          ELEMENTS: {
            EmailChannelConfig: 'Email',
            SmsChannelConfig: 'SMS',
            CertifiedSmsChannelConfig: 'SMS certificado',
            CertifiedEmailChannelConfig: 'Email certificado',
          },
          PAGES: {
            ADD: {
              TITLE: 'Crear',
            },
            EDIT: {
              TITLE: 'Editar',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                TYPE: 'TIPO',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
                CREATE: 'Perfil de cobro',
              },
              MORE: {
                NO_RESULTS: 'No hay canales de notificación que mostrar',
              },
            },
          },
        },
        PHASES: {
          ADD: 'Añadir fase',
          EDIT: 'Editar fase',
        },
        FEEDBACK: {
          TITLE: 'Opciones de feedback',
          DUPLICATE_LANGUAGE: 'El idioma de traducción no puede ser repetido',
          ADD_TRANSLATION: 'Añadir traducción',
          ELEMENTS: {},
          PAGES: {
            ADD: {
              TITLE: 'Crear',
            },
            EDIT: {
              TITLE: 'Editar',
            },
          },
          LIST: {
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                CATEGORY: 'CATEGORÍA',
                TRANSLATE: 'TRADUCCIONES',
                COLLECTORS: 'PERFILES DE COBRO ASOCIADOS',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
                CREATE: 'Perfil de cobro',
              },
              MORE: {
                NO_RESULTS: 'No hay opciones de feedback que mostrar',
              },
            },
          },
        },
      },
    },
    MODULES: {
      AGENTS: {
        TITLE: 'Agentes IA',
      },
      INSPECTORS: {
        OFFER_PAYMENT_AGREEMENT: {
          TITLE: 'Acuerdo de pago',
          DESCRIPTION:
            'Define la cantidad de cuotas y la expiración (en días) de la oferta de acuerdo de pago.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen del acuerdo de pago',
            INSTALLMENTS_LABEL: 'Número de cuotas',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRES_IN: 'Expira en',
            EXPIRES_ON: 'Expira el',
          },

          INFO: {
            TITLE: 'Información del mensaje',
            INFO_CONTENT: `Se enviará una propuesta de pago parcial por valor mínimo de
                      <b>{{amount}}</b> EUR. Caducará en <b>{{days}}</b> días a partir del momento de envío.`,
          },

          CONFIG: {
            INSTALLMENTS_LABEL: 'Número de cuotas',
            INSTALLMENTS_HELP: 'Cantidad de cuotas en las que se dividirá el pago',

            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que la oferta expire',
            DAYS_SUFFIX: ' días',
          },
        },
        OFFER_PARTIAL_PAYMENT: {
          TITLE: 'Pago parcial',
          DESCRIPTION:
            'Define el importe mínimo y la expiración (en días) de la oferta de pago parcial.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen del pago parcial',
            MIN_AMOUNT_LABEL: 'Importe mínimo',
            MIN_PERCENTAGE_LABEL: 'Porcentaje mínimo',
            EXPIRATION_LABEL: 'Expiración de la oferta',
            EXPIRES_IN: 'Expira en',
          },

          INFO: {
            TITLE: 'Información del mensaje',
            INFO_CONTENT: `Se enviará una propuesta de pago parcial por valor mínimo de
                      <b>{{amount}} EUR o {{percentage}} %</b> del importe. Caducará en <b>{{days}}</b> días a partir del momento de envío.`,
          },

          CONFIG: {
            MIN_AMOUNT_LABEL: 'Importe mínimo',
            MIN_AMOUNT_HELP: 'Importe mínimo requerido para el pago parcial',
            MIN_PERCENTAGE_LABEL: 'Porcentaje mínimo',
            MIN_PERCENTAGE_HELP: 'Porcentaje mínimo de la deuda total para el pago parcial',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que la oferta expire',
            DAYS_SUFFIX: ' días',
          },
        },
        SMS: {
          TITLE: 'Enviar SMS',
          DESCRIPTION: 'Configura las opciones de envío de SMS para este nodo.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen del SMS',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRES_IN: 'Expira en',
          },

          INFO: {
            TITLE: 'Información del mensaje',
            DESCRIPTION:
              'Configura si el SMS se envía a todos los contactos y durante cuántos días permanece válido el enlace de pago.',
          },

          CONFIG: {
            TEMPLATE_LABEL: 'Plantilla',
            TEMPLATE_HELP: 'Selecciona la plantilla de SMS a enviar.',
            EXPIRATION_MODE_LABEL: 'Modo de expiración',
            EXPIRATION_MODE_DAYS: 'Días',
            EXPIRATION_MODE_DATE: 'Fecha específica',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_TO_ALL_HELP:
              'Si está activado, el SMS se enviará a todos los contactos asociados.',

            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que el enlace del SMS expire.',
            DAYS_SUFFIX: ' días',
            DATE_LABEL: 'Fecha de expiración',
            DATE_HELP: 'Fecha específica en la que el enlace del SMS expira.',
          },
        },
        SMS_CERTIFIED: {
          TITLE: 'Enviar SMS Certificado',
          DESCRIPTION: 'Configura las opciones de envío de SMS certificado para este nodo.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen del SMS Certificado',
            TEMPLATES_LABEL: 'Plantillas seleccionadas',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRES_IN: 'Expira en',
          },

          CONFIG: {
            TEMPLATE_LABEL: 'Plantillas',
            TEMPLATE_HELP: 'Selecciona una o más plantillas de SMS certificado a enviar.',
            TEMPLATE_PLACEHOLDER: 'Selecciona plantillas',
            EXPIRATION_MODE_LABEL: 'Modo de expiración',
            EXPIRATION_MODE_DAYS: 'Días',
            EXPIRATION_MODE_DATE: 'Fecha específica',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_TO_ALL_HELP:
              'Si está activado, el SMS se enviará a todos los contactos asociados.',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que el enlace del SMS expire.',
            DAYS_SUFFIX: ' días',
            DATE_LABEL: 'Fecha de expiración',
            DATE_HELP: 'Fecha específica en la que el enlace del SMS expira.',
          },
        },
        EMAIL_CERTIFIED: {
          TITLE: 'Enviar Email Certificado',
          DESCRIPTION: 'Configura las opciones de envío de email certificado para este nodo.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen del Email Certificado',
            TEMPLATES_LABEL: 'Plantillas seleccionadas',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_CC_LABEL: 'Enviar en CC a los contactos Secundarios',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRES_IN: 'Expira en',
            SENDER_LABEL: 'Remitente',
            SUBJECT_LABEL: 'Asunto',
          },

          CONFIG: {
            TEMPLATE_LABEL: 'Plantillas',
            TEMPLATE_HELP: 'Selecciona una o más plantillas de email certificado a enviar.',
            TEMPLATE_PLACEHOLDER: 'Selecciona plantillas',
            EXPIRATION_MODE_LABEL: 'Modo de expiración',
            EXPIRATION_MODE_DAYS: 'Días',
            EXPIRATION_MODE_DATE: 'Fecha específica',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_TO_ALL_HELP:
              'Si está activado, el email se enviará de manera individual a todos los contactos secundario.',
            SEND_CC_LABEL: 'Enviar en CC a los contactos Secundarios',
            SEND_CC_HELP:
              'Si está activado, el email se enviará al contacto Principal y se pondrá en copia (CC) a todos los contactos secundarios.',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que el enlace del email expire.',
            DAYS_SUFFIX: ' días',
            DATE_LABEL: 'Fecha de expiración',
            DATE_HELP: 'Fecha específica en la que el enlace del email expira.',
          },
        },
        CREATE_MASC: {
          TITLE: 'Crear MASC',
          DESCRIPTION: 'Configura la creación de email certificado (MASC) para este nodo.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            TITLE: 'Resumen del Email Certificado',
            SENDER_LABEL: 'Remitente',
            SUBJECT_LABEL: 'Asunto',
            SELECTED_EMAIL: 'E-mail seleccionado',
            REPLY_TO_LABEL: 'Direcciones de respuesta (Reply-To)',
            NO_REPLY_TO: 'Sin direcciones de respuesta',
          },
          CONFIG: {
            TEMPLATE_LABEL: 'Plantilla',
            TEMPLATE_HELP: 'Selecciona la plantilla de email certificado a usar.',
            EDIT_TEMPLATE: 'Editar plantilla seleccionada',
            REPLY_TO_LABEL: 'Emails de respuesta',
            REPLY_TO_HELP: 'Opcional. Añade una o más direcciones de respuesta (sin duplicados).',
            INVALID_EMAIL_FORMAT:
              'El formato del correo {{email}} no es válido para el nodo {{nodoType}}.',
          },
        },
        MAKE_OUTBOUND_CALL: {
          TITLE: 'Llamada Saliente',
          DESCRIPTION: 'Configura las opciones de llamada saliente para este nodo.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          CONFIG: {
            AGENT_SECTION: {
              TITLE: 'Agente asignado',
              SUBTITLE: 'Selecciona un agente para la llamada saliente.',
              DROPDOWN_LABEL: 'Agentes',
              INFO: {
                PROVIDER: 'Proveedor',
                EXTERNAL_ID: 'ID Externo',
                NAME: 'Nombre',
                VOICE_ID: 'ID de Voz',
                PROMPT_URL: 'URL de Prompt',
                CONTEXT: 'Contexto',
                CUSTOM_FIELDS: 'Campos personalizados',
                CALL_INTERVALS: 'Franjas horarias',
              },
            },
            CONTACT_ALL: {
              LABEL: '¿Contactar a todos los números registrados en el expediente?',
            },
            RETRY_FAIL_CALLS: {
              LABEL: '¿Quieres reintentar llamadas fallidas?',
              SECTION_TITLE: 'Franjas horarias para reintentos:',
              RETRY_LABEL: 'Reintento {{number}}',
              FROM: 'Desde',
              TO: 'Hasta',
            },
            ACTIONS: {
              TITLE: 'Acciones según respuesta',
              SUBTITLE: 'Define acciones automáticas basadas en el resultado de la llamada.',
              ADD_BUTTON: 'Añadir acción',
              IF_THIS_HAPPENS: 'Si ocurre esto',
              SYSTEM_ACTION: 'El sistema realizará esta acción:',
              SAVE_RULE: 'Guardar',
              OPTIONS: {
                FEEDBACK: 'Feedback',
                ASSIGN_CAMPAIGN: 'Asignar campaña',
              },
              SELECT_CAMPAIGN: 'Selecciones campañas',
            },
            VALIDATIONS: {
              INVALID_TIME_ORDER:
                'La hora de fin para {{label}} debe ser posterior a la de inicio.',
              OVERLAPPING_RETRY_RANGE:
                'La franja de reintento {{labelA}} se solapa con {{labelB}}.',
            },
            CALL_SETTINGS: {
              NAME_LABEL: 'Nombre de la llamada',
              NAME_PLACEHOLDER: 'Introduce un nombre para esta llamada',
              CONTEXT_LABEL: 'Contexto',
              CONTEXT_PLACEHOLDER: 'Introduce el contexto para el agente...',
              CUSTOM_FIELDS_LABEL: 'Campos personalizados',
              CUSTOM_FIELDS_SUBTITLE:
                'Añade datos clave-valor personalizados para pasar al agente.',
              CUSTOM_FIELDS_KEY_PLACEHOLDER: 'Clave',
              CUSTOM_FIELDS_VALUE_PLACEHOLDER: 'Valor',
              ADD_FIELD: 'Añadir campo',
            },
          },
          PREVIEW: {
            TITLE: 'Resumen de configuración de llamada',
            SUBTITLE: 'Vista general del agente y ajustes de reintento.',
            AGENT_SECTION_LABEL: 'Agente',
            CALL_SECTION_LABEL: 'Configuración de llamada',
            AGENT: 'Agente',
            CONTACT_ALL: 'Contactar a todos',
            RETRY: 'Reintentar llamadas fallidas',
            RETRY_SLOT: 'Reintento {{number}}: {{from}} - {{to}}',
            ACTIONS: 'Acciones',
            YES: 'Sí',
            NO: 'No',
            RETRY_SLOTS_TITLE: 'Franjas de reintento configuradas',
            RETRY_SLOTS_SUBTITLE: 'Franjas configuradas para reintentos de llamadas fallidas.',
            RETRY_LABEL: 'Reintento {{number}}',
            CONTEXT: 'Contexto',
            CUSTOM_FIELDS: 'Campos personalizados',
            CUSTOM_FIELDS_EMPTY: 'Sin campos personalizados configurados',
            CALL_INTERVALS: 'Franjas horarias',
            CALL_INTERVALS_EMPTY: 'Sin franjas horarias configuradas',
          },
        },
        START_CHAT_CONVERSATION: {
          TITLE: 'Iniciar conversación de chat',
          DESCRIPTION:
            'Inicia una conversación de chat con el cliente a través de un agente configurado.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          CONFIG: {
            AGENT_LABEL: 'Agente de chat',
            AGENT_HELP: 'Selecciona el agente de chat que gestionará la conversación.',
            AGENT_PLACEHOLDER: 'Selecciona un agente',
            ALL_CONTACTS_LABEL: '¿Contactar a todos los números registrados en el expediente?',
          },
          PREVIEW: {
            AGENT_INFO: 'Información del agente',
            AGENT_NAME: 'Nombre del agente',
            CONTEXT: 'Contexto',
            SHOW_MORE: '+ más',
            SHOW_LESS: '- menos',
            EXTERNAL_ID: 'ID externo',
            ALL_CONTACTS: 'Contactar a todos',
            NO_AGENT: 'Ningún agente seleccionado. Configúralo en la pestaña de Configuración.',
            SUMMARY_TEXT: 'Se iniciará una conversación de chat con el agente {{agentName}}.',
            YES: 'Sí',
            NO: 'No',
          },
        },
        CONDITIONAL: {
          TITLE: 'Condicional de Notificación',
          DESCRIPTION: 'Configure una rama lógica basada en el estado de una notificación previa.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          CONFIG: {
            TARGET_NODE_LABEL: 'Nodo objetivo',
            TARGET_NODE_TOOLTIP: 'La condición se aplicará según el nodo objetivo seleccionado',
            TARGET_NODE_HELP:
              'Selecciona el nodo de Email o SMS cuyo estado de entrega quieres evaluar',
            STATUSES_LABEL: 'Estado de entrega',
            STATUSES_HELP:
              'Selecciona qué estado de entrega debe cumplirse para continuar por esta rama',
            CASES_LABEL: 'Casos (Solo lectura)',
            TRUE_CASE: 'Verdadero',
            FALSE_CASE: 'Falso',
            STATUS_RECEIVED: 'Recibido',
            STATUS_RECEIVED_DESC: 'El mensaje fue entregado correctamente',
            STATUS_READ: 'Leído',
            STATUS_READ_DESC: 'El destinatario abrió/leyó el mensaje',
            STATUS_ERROR: 'Error',
            STATUS_ERROR_DESC: 'Hubo un error en el envío',
            VIEW_MESSAGE: 'Ver mensaje',
            HIDE_MESSAGE: 'Ocultar mensaje',
          },
          PREVIEW: {
            SUMMARY_TEXT:
              'Si el estado de {{nodeName}} es {{statuses}}, entonces sigue el camino "{{truePath}}", de lo contrario "{{falsePath}}".',
            TITLE: 'Resumen Lógico',
            MESSAGE_LABEL: 'Mensaje de Notificación',
          },
        },
        EMAIL: {
          TITLE: 'Enviar Email',
          DESCRIPTION: 'Configura las opciones de envío de Email para este nodo.',

          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },

          PREVIEW: {
            TITLE: 'Resumen de Email',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_CC_LABEL: 'Enviar en CC a los contactos Secundarios',
            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRES_IN: 'Expira en',
            SENDER_LABEL: 'Remitente',
            SUBJECT_LABEL: 'Asunto',
            SELECTED_EMAIL: 'E-mail seleccionado',
            FOOTER: 'Email de Paymefy',
          },

          INFO: {
            TITLE: 'Información del mensaje',
            DESCRIPTION:
              'Configura si el email se envía a todos los contactos y cuántos días permanece válido el paylink.',
          },

          CONFIG: {
            TEMPLATE_LABEL: 'Plantilla',
            TEMPLATE_HELP: 'Selecciona la plantilla de Email a enviar.',
            TEMPLATE_PLACEHOLDER: 'Selecciona una plantilla',
            EXPIRATION_MODE_LABEL: 'Modo de expiración',
            EXPIRATION_MODE_DAYS: 'Días',
            EXPIRATION_MODE_DATE: 'Fecha específica',
            SEND_TO_ALL_LABEL: 'Enviar a todos los contactos',
            SEND_TO_ALL_HELP:
              'Si está activado, el email se enviará de manera individual a todos los contactos secundario.',
            SEND_CC_LABEL: 'Enviar en CC a los contactos Secundarios',
            SEND_CC_HELP:
              'Si está activado, el email se enviará al contacto Principal y se pondrá en copia (CC) a todos los contactos secundarios.',

            EXPIRATION_LABEL: 'Expiración del mensaje',
            EXPIRATION_HELP: 'Cantidad de días hasta que el enlace del email expire.',
            DAYS_SUFFIX: ' días',
            DATE_LABEL: 'Fecha de expiración',
            DATE_HELP: 'Fecha específica en la que el enlace del email expira.',
            EDIT_TEMPLATE: 'Editar plantilla seleccionada',
          },
        },
        ASSIGN_CAMPAIGN: {
          TITLE: 'Asignar Campaña',
          DESCRIPTION: 'Selecciona la campaña a la que se redirigirá.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          CONFIG: {
            TARGET_CAMPAIGN_LABEL: 'Campaña objetivo',
            TARGET_CAMPAIGN_HELP:
              'Selecciona la campaña a la que se asignará el el expediente al llegar a este nodo',
            CAMPAIGN_DETAILS: 'Detalles de la campaña',
            NAME: 'Nombre',
            TYPE: 'Tipo',
            STATUS: 'Estado',
            PHASE: 'Fase',
            START_DAYS: 'Inicio: {{days}} días',
            FINISH_DAYS: 'Fin: {{days}} días',
            NODES_TOTAL: 'Nodos totales',
            NODES_SMS: 'Nodos SMS',
            NODES_EMAIL: 'Nodos Email',
          },
          PREVIEW: {
            SUMMARY_TEXT: 'Se asignará a la campaña "{{campaignName}}".',
            VIEW_CAMPAIGN: 'Ver campaña',
            CAMPAIGN_INFO: 'Información de la campaña',
          },
        },
        SEGMENT: {
          TITLE: 'Segmento',
          DESCRIPTION: 'Configura las opciones de selección de segmentos para este nodo.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            TITLE: 'Resumen del segmento',
            FILTERS_TITLE: 'Filtros',
            NO_FILTERS: 'Sin filtros configurados para este segmento',
            EMPTY: 'Selecciona un segmento para ver la vista previa',
          },
          CONFIG: {
            SEGMENT_LABEL: 'Segmento',
            SEGMENT_PLACEHOLDER: 'Selecciona un segmento',
          },
          BADGE_DEFAULT: 'Por defecto',
          BADGE_IN_USE: 'En uso',
          SEARCH_PLACEHOLDER: 'Buscar segmentos...',
          NO_SEGMENTS: 'No se encontraron segmentos',
        },
        WAIT_DAYS: {
          TITLE: 'Esperar Días',
          DESCRIPTION:
            'Configura cuántos días de espera y la franja horaria para seguir al siguiente nodo',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            WAIT_DAYS_LABEL: 'Duración de Espera',
            TIME_OF_DAY_LABEL: 'Franja Horaria',
            CUSTOM_TIME_RANGE_LABEL: 'Franja Horaria Personalizada',
            REGIONAL_CONFIG_LABEL: 'Horarios',
            NO_CONFIG_INFO: 'No hay información de configuración regional disponible',
            SUMMARY_MESSAGE:
              'Se va a pasar al siguiente nodo después de <b>{{waitDays}}</b> días, durante la franja horaria de <b>{{timeRange}}</b>',
          },
          CONFIG: {
            WAIT_DAYS_LABEL: 'Número de Días',
            WAIT_DAYS_HELP: 'El número de días a esperar antes de pasar al siguiente nodo (0-365)',
            WAIT_DAYS_PLACEHOLDER: 'Ingresa número de días',
            PART_DAY_LABEL: 'Franja Horaria',
            PART_DAY_HELP: 'Selecciona en qué franja del día para pasar al siguiente nodo',
            PART_DAY_PLACEHOLDER: 'Selecciona una franja horaria',
            CUSTOMIZE_TIME_RANGE_LABEL: '¿Personalizar franja horaria?',
            CUSTOMIZE_TIME_RANGE_HELP:
              'Permite establecer una franja horaria personalizada para esta espera',
            START_TIME_LABEL: 'Hora de Inicio',
            FINISH_TIME_LABEL: 'Hora de Fin',
            TIME_PLACEHOLDER: 'Selecciona la hora',
            INVALID_TIME_ORDER: 'La hora de inicio debe ser anterior a la hora de fin',
            COLLECTORS_LABEL: 'Cobradores',
            TIMETABLE_LABEL: 'Horario',
          },
        },
        WAIT_DAY_OF_MONTH: {
          TITLE: 'Esperar al Día del Mes',
          DESCRIPTION:
            'Detiene la ejecución al siguiente nodo hasta llegar al día del mes seleccionado',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            DAY_OF_MONTH_LABEL: 'Día del mes',
            TIME_OF_DAY_LABEL: 'Franja horaria',
            LAST_DAY: 'Último día del mes',
            SUMMARY_MESSAGE_LAST:
              'Se va a pasar al siguiente nodo el día <b>último</b> del mes, durante la franja horaria de <b>{{partDay}}</b>',
            SUMMARY_MESSAGE_NUMERIC:
              'Se va a pasar al siguiente nodo el día <b>{{day}}</b> del mes, durante la franja horaria de <b>{{partDay}}</b>',
          },
          CONFIG: {
            PART_DAY_LABEL: 'Franja horaria',
            PART_DAY_HELP: 'Selecciona la franja horaria',
            PART_DAY_PLACEHOLDER: 'Seleccionar franja horaria',
            DAY_OF_MONTH_LABEL: 'Día de lanzamiento',
            DAY_OF_MONTH_HELP: 'Selecciona qué día del mes se lanzará al siguiente nodo.',
            DAY_OF_MONTH_PLACEHOLDER: 'Seleccionar día',
            LAST_DAY_OPTION: 'Último día del mes',
          },
        },
        WAIT_DAYS_FOR_DUE_DATE: {
          TITLE: 'Esperar por Vencimiento',
          DESCRIPTION:
            'Configura el tiempo de espera para el siguiente nodo en base a la fecha de vencimiento de la factura.',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            WAIT_DAYS_LABEL: 'Días de espera',
            TIME_OF_DAY_LABEL: 'Franja horaria',
            DIRECTION_LABEL: 'Dirección',
            BEFORE: 'ANTES',
            AFTER: 'DESPUÉS',
            SUMMARY_MESSAGE:
              'Se va a pasar al siguiente nodo <b>{{antesODespues}} de {{waitDays}}</b> días, durante la franja horaria de <b>{{partDay}}</b>',
          },
          CONFIG: {
            PART_DAY_LABEL: 'Franja horaria',
            PART_DAY_HELP: 'Selecciona en qué momento del día pasa al siguiente nodo.',
            PART_DAY_PLACEHOLDER: 'Seleccionar parte del día',
            WAIT_DAYS_LABEL: 'Días de espera',
            WAIT_DAYS_HELP: 'Cantidad de días a esperar.',
            WAIT_DAYS_PLACEHOLDER: '0',
            DIRECTION_LABEL: 'Antes o Después',
            DIRECTION_HELP: 'Elige si pasar al siguiente nodo es antes o después del vencimiento.',
            DIRECTION_BEFORE: 'Antes del vencimiento',
            DIRECTION_AFTER: 'Después del vencimiento',
          },
        },
        WAIT_DAY_OF_WEEK: {
          TITLE: 'Esperar Día de la Semana',
          DESCRIPTION:
            'Configura qué día de la semana y franja horaria para pasar al siguiente nodo',
          TABS: {
            PREVIEW: 'Vista previa',
            CONFIG: 'Configuración',
          },
          PREVIEW: {
            TIME_OF_DAY_LABEL: 'Franja Horaria',
            DAY_OF_WEEK_LABEL: 'Día de la Semana',
            SUMMARY_MESSAGE:
              'Se va a pasar al siguiente nodo después del <b>{{dayOfWeek}}</b>, durante la franja horaria de <b>{{partDay}}</b>',
          },
          CONFIG: {
            PART_DAY_LABEL: 'Franja Horaria',
            PART_DAY_HELP: 'Selecciona en qué franja del día se debe pasar al siguiente nodo',
            PART_DAY_PLACEHOLDER: 'Selecciona una franja horaria',
            DAY_OF_WEEK_LABEL: 'Día de la Semana',
            DAY_OF_WEEK_HELP: 'Selecciona el día de la semana para pasar al siguiente nodo',
            DAY_OF_WEEK_PLACEHOLDER: 'Selecciona un día',
          },
        },
      },
      PAYMENTS: {
        PAYMENTS: 'Pagos',
        LINK_NOT_FOUND_TITLE: 'Pago no encontrado',
        LINK_NOT_FOUND_MSG: 'No se ha encontrado el pago del enlace compartido',

        FILTERS: {
          ID: 'Id de pago',
          AMOUNT: 'Importe',
          DATE: 'Fecha',
          COLLECTOR: 'Perfil de cobro',
          METHOD: 'Pasarela',
          CUSTOMER: 'Cliente',
          NUM_OPERATIONS: 'Núm. Operaciones',
          DETAILS: 'Detalles',
          PAYMENT: 'Pago',
          REFUND: 'Reembolso',

          METHODS: 'Pasarela de pagos',
          COLLECTOR_IDS: 'Perfiles de cobro',
          CUSTOMER_EXTERNAL_IDS: 'IDs de llamada',
          OPERATION_EXTERNAL_IDS: 'Ids de operación',
          PAYMENTS_EXTERNAL_IDS: 'Ids de pagos',
          PAYMENT_GATEWAY: 'Pasarelas de Pagos',
          PAYMENT_METHODS: 'Métodos de pago',
          EXTERNAL_IDS: 'Teléfonos de cliente',
          DATE_INTERVAL: 'Fecha de pago',
          ONLY_PAYMEFY: 'Mostrar sólo pagos en Paymefy',
          TYPES: 'Tipos de pago',
        },

        TABLE: {
          ID: 'Id de pago',
          AMOUNT: 'Importe',
          DATE: 'Fecha',
          COLLECTOR: 'Perfil de cobro',
          METHOD: 'Pasarela de pago',
          CUSTOMER: 'Cliente',
          NUM_OPERATIONS: 'Núm. Operaciones',
          DETAILS: 'Detalles',
          NO_RESULTS: 'No se encontraron resultados',
        },

        ACTIONS: {
          VIEW_DETAILS: 'Ver detalles',
          COPY_EXTERNAL_ID: 'Copia external id del pago',
        },

        PAGINATION: {
          TOTAL_RESULTS: 'Resultados totales',
          TOTAL_AMOUNTS: 'Importe total de pagos',
          RESULTS_PER_PAGE: 'Resultados por página',
        },

        EMPTY: {
          TITLE: 'No hay datos',
          DESCRIPTION: 'No existen pagos que coincidan con los filtros seleccionados.',
        },

        DETAILS: {
          HEADER: {
            PAYMENT_FOR: 'Pago - {{customerName}}',
            PAYMENT_DATE: 'Fecha de pago',
          },
          AMOUNT: {
            LABEL: 'Importe del pago',
          },
          PAYMENT_DETAILS: 'Detalles del pago',
          PAYMENT_ID: 'ID del pago',
          CONCEPT: 'Concepto',
          METHOD: 'Método',
          TYPE_OF_PAYMENT: 'Tipo de pago',
          DATE: 'Fecha de pago',
          COLLECTOR: 'Collector',
          CUSTOMER: 'Cliente',
          CUSTOMER_NAME: 'Nombre',
          CUSTOMER_ID: 'ID Cliente',
          VIEW_CUSTOMER: 'Ver ficha del cliente',
          OPERATIONS: 'Operaciones',
          TOTAL_OPERATIONS: 'Total de operaciones',
          OPERATION: 'Operación #{{id}}',
          PAID_AMOUNT: 'Importe pagado',
          VIEW_OPERATION: 'Ver operación',
          CLOSE: 'Cerrar',
          EXTERNAL_PAYMENT_NOTE: 'Pago externo a Paymefy',
          UNKNOWN_PAYMENT: 'Desconocido',
          NO_VALUE: 'Sin valor',
          TITLE: 'Pago de {{ name }}',
          REGISTERED_ON: 'Registrado el',
          RECONCILED: 'Conciliado',
          ORIGIN: 'Origen',
          PAYMEFY_ORIGIN: 'Vía Paymefy',
          EXTERNAL_ORIGIN: 'Externo',
          OPERATIONS_IMPUTED: 'Operaciones imputadas',
          TOTAL_LABEL: 'Total:',
          PAID_STATUS: 'Pagada',
          OPERATION_AMOUNT: 'Importe de la operación',
          OPERATION_CASE: 'Expediente',
          IMPUTATION_DATE: 'Fecha de imputación',
          EDIT_PAYMENT: 'Editar pago',
          COPY_LINK_TOOLTIP: 'Copiar enlace',
          LINK_COPIED_TITLE: 'Copiado',
          LINK_COPIED_MSG: 'Enlace copiado al portapapeles',
        },
      },
      OUTBOUNDCALL: {
        TITLE: 'Llamadas',
        TAGS: 'Tags',
        AGENT: 'Agente',
        CUSTOMER: 'Cliente',
        PHONE_NUMBER: 'Número de teléfono',
        STATUS: 'Estado',
        CONVERSATION_RESULT: 'Resultado de la conversación',
        TRANSCRIPTION: 'Detalles',
        AUDIO_ACTIONS: 'Acciones de audio',
        CREATED_AT: 'Fecha de creación',
        DETAILS: 'Detalles',
        CALL_ID: 'ID externo',
        DURATION: 'Duración',
        DATETIME: 'Fecha y hora',
        RESUME: 'Resumen de al llamada',
        NO_DATA: 'No hay llamadas realizadas',
        NO_DATA_DESC: 'Deben existir llamadas para poder visualizar la información',
        TRANSFERRED: 'Transferido?',
        RESULT_CONV: 'Resultado de la conversación',
        CLOSED_BY: 'Cerrado por',
        DIALOG_TITLE: 'Llamada de',
        TRANSCRIPTION_PANEL: 'Transcripción',
        RECORDING_LABEL: 'Grabación ·',
        DOWNLOAD_AUDIO: 'Descargar audio',
        CLOSE: 'Cerrar',
        VIEW_OPERATION: 'Ver cliente',
        AI_NOTE: 'Resumen generado por IA. Puede contener imprecisiones.',
        LINK_NOT_FOUND_TITLE: 'Llamada no encontrada',
        LINK_NOT_FOUND_MSG: 'No se ha encontrado la llamada del enlace compartido',
        COPY_LINK_TOOLTIP: 'Copiar enlace',
        COPY_LINK_TITLE: 'Copiado',
        COPY_LINK_MSG: 'Enlace copiado al portapapeles',
      },
      CHAT_CONVERSATIONS: {
        CUSTOMER: 'Cliente',
        PHONE_NUMBER: 'Número de teléfono',
        STATUS: 'Estado',
        CREATED_AT: 'Inicio de conversación',
        LAST_CONVERSATION_DATE: 'Última actividad',
        AGENT: 'Agente',
        EXTERNAL_IDS: 'IDs de conversación',
        NO_DATA: 'No hay conversaciones',
        NO_DATA_DESC: 'Las conversaciones de chat aparecerán aquí una vez creadas',
        COPY_EXTERNAL_ID_TOOLTIP: 'Copiar ID externo de la conversación',
        NO_AGENT_INFO: 'Sin información',
        EMPTY_STATE_TITLE: 'Sin resultados',
        EMPTY_STATE_DESC: 'No se encontraron conversaciones con los filtros aplicados.',
        CLEAR_FILTERS: 'Limpiar filtros',
        TOTAL_RESULTS: 'Resultados totales:',
        RESULTS_PER_PAGE: 'Resultados por página:',
        COPY_TOAST_TITLE: 'Copiado',
        COPY_TOAST_MSG: 'ID {{id}} copiado al portapapeles',
        REPLIED: 'Respondido',
        LINK_NOT_FOUND_TITLE: 'Conversación no encontrada',
        LINK_NOT_FOUND_MSG: 'No se ha encontrado la conversación del enlace compartido',
        DETAIL: {
          TITLE: 'Conversación',
          GENERAL: 'Información general',
          NAME: 'Caso de cliente',
          AGENT_ID: 'ID agente',
          AGENT_PHONE: 'ID teléfono agente',
          BLOCK_REASON: 'Motivo de bloqueo',
          INBOUND: 'Conversaciones entrantes',
          MAIN_CONV: 'Conversación principal',
          TRANSCRIPTION: 'Transcripción',
          ROLE_SYSTEM: 'Sistema',
          ROLE_CUSTOMER: 'Cliente',
          NO_TRANSCRIPTION: 'Sin transcripción disponible',
          OPEN_TOOLTIP: 'Ver conversación',
          OPEN_BTN: 'Ver detalles',
          COPY: 'Copiar',
          OPEN_CUSTOMER: 'Ir al cliente',
          COPY_LINK_TOOLTIP: 'Copiar enlace',
          LINK_COPIED_MSG: 'Enlace copiado al portapapeles',
        },
      },
      BEHAVIORAL_PILL: {
        TITLE: 'Píldora conductual',
        MESSAGES: {
          NO_DATA: 'Sin datos',
          COMPARE_LAST_MONTH: 'Comparado con {{recoveredLastMonth}} del mes anterior',
          COMPARE_NO_DATA: 'Comparado con - Sin datos - del mes anterior',
          RECOVERY: 'Recobro de {{ currentMonth}}',
          ABANDONED_EMAIL: 'Email abandonado',
          PILL: 'Píldora',
          PILL_ADD: '+ Añadir píldora',
          ABANDONED_GANGWAY: 'Pasarela de pago abandonada ',
          ABANDONED_PAYMENT_PAGE: 'Pagina de pago abandonada ',
          SELECT_PILL: 'Escoge una píldora para asignar ',
          SELECT_PILL_ASSIGN: 'Selecciona la píldora a asignar',
          ASSIGN_PILL: 'Asignar píldora',
          SHOW_PILL: 'Mostrar píldora',
          DELETE_CONFIRMATION: '¿Quieres eliminar la píldora {{pillName}}?',
          DELETE_HEADER: 'Eliminar Pago Parcial',
          ACCEPT_DELETE: 'Eliminar píldora',
          REJECT_DELETE: 'Cancelar',
          ACTION_FAILED: 'La acción no pudo completarse',
          NO_SELECTED: 'Píldora no seleccionada',
        },
        TOOLTIP: {
          ADD_PILL_SELECTED: 'Selecciona la píldora a asignar',
          ABANDONED_EMAIL:
            'Se lanza la píldora a los usuarios que no hicieron click al botón pagar al cabo de 30 minutos de abrir el email',
          ABANDONED_PAYMENT_PAGE:
            'Se lanza la píldora a los usuarios que no hicieron click a pagar 10 minutos después de visitar la página de pago ',
          ABANDONED_GANGWAY:
            'Se lanza la píldora a los usuarios que no completaron el pago 5 minutos después de entrar en la pasarela de pago',
        },
      },
      CUSTOMER_JOURNEY: {
        ERRORS: {
          NO_DATA: 'No hay datos disponibles',
          NO_DATA_AUTO: 'No hay automatizaciones configuradas',
          SHOULD_CONFIG: 'La información del recorrido del cliente debe configurarse',
          PHASES: 'Error en la configuración de fases',
          PHASES_OVERLAP:
            'Existen fases superpuestas o huecos entre fases, por favor revise su configuración',
          CAMPAIGNS_WITH_DAYS_BUT_NO_PHASE:
            'Estas campañas tienen días asignados a una fase, pero esa fase no existe',
        },
        BUTTONS: {
          MIN: 'Minimizar',
          MAX: 'Maximizar',
          CAMPAIGNS_NO_POSITION: 'Campañas no posicionadas',
        },
        MESSAGES: {
          REDIRECT_CREATE: '¿Desea redirigir a la creación de campañas?',
          CREATION_PHASE: 'Creando flujo de fases ',
          CREATION_CAMPAIGN: ' Redirigir para crear campaña ',
          DAYS: 'Días',
          CAMPAIGN_NAME: 'Nombre de la campaña',
          COLLECTORS_PROFILE: 'Perfil de cobradores',
          SEGMENTS: 'Segmentos ',
          SELF_CURE_RATE: 'Tasa de autocuración ',
          RECOVERY_RATE: 'Tasa de recuperación',
          RECOVERY: 'Recuperación',
          RECOVERY_RATE_TOOLTIP: 'Promedio de tasa de recuperación durante los últimos 6 meses',
          RECOVERY_RATE_PERCENT: 'Porcentaje de tasa de recuperación',
          SEGMENTS_TOOLTIP: 'Segmentos involucrados en la campaña',
          PAYMENTS_RESOLVED_PAYMEFY:
            'Pagos totales resueltos a través de Paymefy dividido por los pagos totales recibidos',
          SEGMENTS_LABEL: 'Segmentos',
          CAMPAIGN_TYPE: 'Tipo de campaña ',
          CONTINUOUS: 'Continua',
          CAMPAIGN_NODES: 'Nodos de la campaña',
          CAMPAIGN_NODES_COUNT: 'Cantidad de nodos',
          RECOVERY_RATE_LABEL: 'Tasa de recuperación',
          OPERATIONS_SENT: 'Operaciones notificadas',
          OPERATIONS_PAID: 'Operaciones pagadas',
          CLIENTS_CONTACTED: 'Clientes contactados',
          NOTIFICATIONS_SENT: 'Notificaciones enviadas',
          AVERAGE_6_MONTH: 'Promedio de los últimos 6 meses',
          PAYMEFY_RECOVERY_TOTAL: 'Total recuperado por Paymefy',
          EXTERNAL_RECOVERY_TOTAL: 'Total recuperado por otros medios',
          SHOW_WORKFLOW: 'Mostrar flujo de trabajo',
          NO_DATA: 'Sin datos',
          LAST_MONTH_OPERATIONS: 'Operaciones del último mes',
          LAST_MONTH_NOTIFICATIONS: 'Notificaciones del último mes',
          LAST_MONTH_AVG_PAYMEFY_AMOUNT: 'Monto promedio de Paymefy por cliente el mes pasado',
          LAST_MONTH_AVG_EXTERNAL_AMOUNT: 'Monto promedio externo por cliente el mes pasado',
          SHOW: 'Mostrar',
          CANCEL: 'Cancelar',
          CREATE_CAMPAIGN_WITH: 'Crear campaña con la fase {{phaseName}}',
        },
      },
      IMPORTS: {
        TITLE: 'Importaciones',
        BUTTONS: {
          IMPORT: 'Importar',
          DOWNLOAD: 'Descargar plantillas',
        },
        TOOLTIP: {
          DOWNLOAD:
            'Descarga plantilla base para construir tu propio archivo de importación de manera sencilla.',
        },
      },
      CALENDAR: {
        TITLE: 'Calendario',
        FORM: {
          COLLECTION_PROFILE: 'PERFIL DE COBRO',
        },
      },
      BUSINESS_INSIGHTS: {
        TITLE: 'Business Insights',
      },
      LAYOUT: {
        ACTIVITY: {
          TITLE: 'Resumen de actividades',
          LABEL: {
            ACTIVITIES: 'Actividades',
          },
          OPTIONS: {
            PAYLINK_NOTIFICATION_SENT: 'Notificaciones',
            PAYMENT_ORDER_CAPTURED: 'Pagos',
            FEEDBACK_SENT: 'Feedbacks',
          },
          MESSAGES: {
            API: 'Has enviado una notificación para {{customerName}} ({{externalId}}) desde {{source}}',
            CAMPAIGN:
              'Has enviado una notificación a {{customerName}} ({{externalId}}) desde {{source}}',
            PAYMENT_AGREEMENT: 'Has enviado un acuerdo de pago a {{customerName}} ({{externalId}})',
            REMINDER: 'Has enviado un enlace de pago a {{customerName}} ({{externalId}})',
            DEFAULT: 'Has enviado una notificación a {{customerName}} ({{externalId}})',
            PAYMENT_RECEIVED:
              'Has recibido un pago por importe de {{amount}} de {{customerName}} ({{externalId}})',
            FROM: 'desde {{source}}',
            FEEDBACK: '{{customerName}} ({{externalId}}) te ha dejado feedback',
          },
        },
      },
      SHARED: {
        COMPONENTS: {
          SEND_REMINDER: {
            TITLE: 'Enviar recordatorio',
            INTRO:
              'Selecciona los canales por los que enviar el recordatorio. Puedes elegir uno o varios.',
            CHANNELS_LABEL: 'Canales',
            SEND_BTN: 'Enviar recordatorio',
            CANCEL: 'Cancelar',
            DESCRIPTION: 'Enviar recordatorio',
            PHONE_SEND_MSG: 'Enviarás un recordatorio al siguiente teléfono: ',
            EMAIL_SEND_MSG: 'Enviarás un recordatorio al siguiente email: ',
            MONTH: 'mes',
            MONTHS: 'meses',
            PAYMENT_PROPOSAL_EXPIRATION:
              'La propuesta de acuerdo de pago caducará en <b>{{ hours }} días</b> a partir del momento del envío.',
            DESCRIPTION_MSG:
              'Enviarás un acuerdo de pago preaprobado a <b>{{ customerName }}</b> por valor total de <b>{{ totalAmount }}</b>',
            FIRST_PAYMENT:
              'Se cargarán <b>{{ firstPayment }}</b> en el momento del primer pago, las cuotas restantes se cargarán automáticamente cada mes durante <b>{{ nMonths }} {{ monthText }}</b>, al canal de pago <b>{{ sms }} {{ email }}</b>',
            EXACT_DATES:
              'El cliente podrá ver las fechas exactas de cada cobro antes del primer pago.',
            INSTALLMENTS_TABLE_HEADER: {
              INSTALLMENT: 'Cuota',
              AMOUNT: 'Importe',
            },
            FORM: {
              ACTIONS: {
                SEND: 'Enviar',
                CONFIRM: 'Confirmar',
                CONFIRM_MESSAGE: '¿Quieres enviar el recordatorio?',
              },
              CHANNEL: {
                LABEL: 'Seleccionar canales',
              },
            },
          },
          SEND_PAYMENT_AGREEMENT: {
            TITLE: 'Enviar acuerdo de pago',
            DESCRIPTION: 'Enviar acuerdo de pago',
            PHONE_SEND_MSG: 'Enviarás un acuerdo de pago al teléfono: ',
            EMAIL_SEND_MSG: 'Enviarás un acuerdo de pago al email: ',
            SUCCESS: 'Acuerdo de pago enviado correctamente',
            ERROR: 'Error al enviar el acuerdo de pago',
            HEADER_SUCCESS: 'Acción realizada',
            HEADER_ERROR: 'Error',
            FOR: 'Para',
            CASE_LABEL: 'expediente',
            CUOTA: 'cuota',
            CUOTAS: 'cuotas',
            DAY: 'DÍA',
            DAYS: 'DÍAS',
            SECTION_CONFIG: 'Configuración',
            SECTION_PLAN: 'Plan de cobro',
            TOTAL_AMOUNT: 'Importe total a recobrar',
            VALIDITY: 'Validez de la propuesta',
            MONTHLY_ESTIMATE: 'Cuota mensual estimada:',
            EXPIRES_HELP: 'Si el cliente no acepta antes de esta fecha, la propuesta caduca.',
            CUSTOMIZE: 'Personalizar',
            CANCEL: 'Cancelar',
            SEND_AGREEMENT: 'Enviar acuerdo',
            TABLE_NUM: '#',
            TABLE_DATE: 'Fecha estimada',
            TABLE_AMOUNT: 'Importe',
            TABLE_FIRST_PAYMENT: 'Primer cobro',
            SUMMARY:
              'Se enviará un acuerdo de pago a <strong>{{ customerName }}</strong> por <strong>{{ totalAmount }}</strong> en <strong>{{ instalmentText }}</strong>{{ instalmentDetail }}, vía <strong>{{ channel }}</strong>. Si no se acepta antes del <strong>{{ expirationDate }}</strong>, la propuesta caducará.',
            FORM: {
              ACTIONS: {
                SEND: 'Enviar',
                CONFIRM: 'Confirmar',
                CONFIRM_MESSAGE: '¿Quieres enviar el acuerdo de pago?',
              },
              CHANNEL: {
                LABEL: 'Canal de envío',
                INSTALMENTS: 'Número de cuotas',
                EXPIRES_72H: 'Caduca el',
              },
            },
          },
          PARTIAL_PAYMENT: {
            SMS: 'SMS',
            EMAIL: 'Correo electrónico',
            MINIMUM_AMOUNT: 'Importe mínimo',
            MINIMUM_PERCENTAGE: 'Importe mínimo %',
            SUCCESS_TITLE: 'Oferta de Pago Parcial Enviada',
            SUCCESS_MESSAGE: '¡La oferta se ha enviado con éxito!',
            ERROR_TITLE: 'Error',
            ERROR_MESSAGE:
              'No se pudo enviar la oferta de pago parcial. Es posible que ya se haya enviado.',
            TITLE: 'Enviar pago parcial',
            SEND_BTN: 'Enviar pago parcial',
            CANCEL: 'Cancelar',
            FOR: 'Para',
            CASE_LABEL: 'expediente',
            SECTION_CONFIG: 'Configuración',
            KPI_TOTAL_DEBT: 'Total adeudado',
            TOTAL_DEBT: 'debe un total de',
            SEND_PROPOSAL_MINIMUM:
              'le enviarás una propuesta de pago parcial por importe mínimo de',
            SEND_PROPOSAL_PERCENTAGE:
              'le enviarás una propuesta de pago parcial por importe mínimo de',
            EXPIRES_72H: 'Caducará en 72 horas a partir del momento del envío',
            EQUIV_PCT_HINT: 'Equivale al <strong>{{ pct }}%</strong> del total adeudado.',
            EQUIV_EUR_HINT:
              'Equivale a <strong>{{ amount }} {{ currency }}</strong> del total adeudado.',
            SUMMARY:
              'Se enviará una propuesta de pago parcial a <strong>{{ customerName }}</strong> por un importe mínimo de <strong>{{ amount }}</strong>, vía <strong>{{ channel }}</strong>.',
            FORM: {
              MIN_AMOUNT: 'Importe mínimo',
              MIN_AMOUNT_PERCENT: 'Importe mínimo en %',
              CHANNEL: 'Canal de envío',
              TEMPLATE: 'Plantilla',
              TEMPLATE_PLACEHOLDER: 'Seleccionar plantilla',
            },
          },
          WAIT_NODES: {
            VIEW_REGIONAL_CONFIG: 'Ver configuración regional',
          },
          NODE_DRAG_DROP: {
            UNDERSTOOD: 'Entendido',
          },
        },
      },
      CREATE_CUSTOMER_MODAL: {
        TITLE: 'Crea un nuevo cliente',
        SUBTITLE: 'Completa los datos del cliente para añadirlo a la operación.',
        SECTION_DATA: 'Datos del cliente',
        EXTERNAL_ID_LABEL: 'ID Cliente',
        EXTERNAL_ID_PLACEHOLDER: 'Ej. CLI-2026-088',
        NAME_LABEL: 'Nombre de pila (sin apellidos)',
        NAME_PLACEHOLDER: 'Nombre corto',
        LONG_NAME_LABEL: 'Nombre y apellidos',
        LONG_NAME_PLACEHOLDER: 'Nombre completo',
        EMAIL_LABEL: 'Email',
        EMAIL_PLACEHOLDER: 'Introduce emails',
        PHONE_LABEL: 'Teléfono',
        PHONE_PLACEHOLDER: 'Introduce teléfonos',
        LANGUAGE_LABEL: 'Lenguaje',
        LANGUAGE_PLACEHOLDER: 'Selecciona un idioma',
        SUBMIT_BTN: 'Crear cliente',
      },
      CUSTOMER_LOOKUP: {
        ID_LABEL: 'ID del Cliente',
        PLACEHOLDER: 'Introduce el ID del cliente a buscar',
        HINT: 'Busca un id external de cliente y añadelo',
        SEARCHING: 'Buscando...',
        SEARCH: 'Buscar',
        CUSTOMER_FOUND: 'Cliente encontrado:',
        ADD_CUSTOMER: 'Agregar cliente',
        ALREADY_ADDED: 'Este cliente ya ha sido añadido a la operación.',
        NOT_FOUND: 'Cliente no encontrado',
        CREATE_WITH_ID: 'Crear cliente con id',
        CLEAR_SEARCH: 'Borrar búsqueda',
      },
      COUNTRY_PREFIX_SELECTOR: {
        PLACEHOLDER: 'Selecciona prefijo',
        SELECT_COUNTRY: 'Selecciona un país',
        REQUIRED: 'El prefijo de país es obligatorio.',
      },
      KYC_DOCUMENTATION: {
        PAYCOMET: {
          TITLE: 'Documentación KYC Paycomet',
          DESCRIPTION:
            'Gestiona los documentos requeridos por Paycomet para completar el proceso de verificación de identidad.',
          NO_IBANS_TITLE: 'No hay IBANs de Paycomet configurados',
          NO_IBANS_DESC:
            'Tu tenant no tiene IBANs activos de Paycomet en este momento. Para habilitar esta funcionalidad, configura al menos una pasarela de pago Paycomet con un IBAN válido.',
          SELECT_IBAN: 'Selecciona un IBAN',
          BANK_ACCOUNT: 'Cuenta bancaria (IBAN)',
          TABLE: {
            HEADERS: {
              DOCUMENT: 'Documento',
              STATUS: 'Estado',
              CREATED_AT: 'Creado',
              LAST_UPDATE: 'Última actualización',
              FILE: 'Archivo',
              ACTIONS: 'Acciones',
            },
            NO_FILE: 'Sin archivo',
            NO_RESULTS: 'No hay documentos disponibles.',
          },
          ACTIONS: {
            UPLOAD: 'Subir',
            REPLACE: 'Reemplazar',
            TOOLTIP_UPLOAD: 'Subir documento',
            TOOLTIP_REPLACE_REJECTED: 'Reemplazar archivo rechazado',
            TOOLTIP_REPLACE: 'Reemplazar archivo',
            TOOLTIP_DOWNLOAD: 'Descargar documento',
          },
          BREADCRUMB: {
            CONFIGURATIONS: 'Configuraciones',
            KYC: 'Documentación KYC',
            PAYCOMET: 'Paycomet',
          },
          UPLOAD_SIDEBAR: {
            SELECT_PDF: 'Seleccionar PDF',
            DROP_HERE: 'o arrastra el archivo aquí',
            CLICK_TO_CHANGE: 'Haz clic para cambiar el archivo',
            UPLOADING: 'Subiendo archivo…',
            CURRENT_FILE: 'Archivo actual',
            UPLOADED_AT: 'Subido el {{date}}',
            DOWNLOAD_CURRENT: 'Descargar archivo actual',
          },
          DOC_STATUS: {
            NOT_UPLOADED: 'No subido',
            PENDING: 'Pendiente',
            PROCESSED: 'Procesado',
            REJECTED: 'Rechazado',
          },
          TABS: {
            DOCUMENTS: 'Documentos',
            PAYOUTS: 'Payouts',
          },
          DOC_ERROR_MSG: 'El documento "{{name}}" tiene un error. Revisa y reemplaza el archivo.',
          DOWNLOAD_ERROR_TITLE: 'Error al descargar',
          DOWNLOAD_ERROR_DETAIL: 'No se pudo obtener el enlace de descarga. Inténtalo de nuevo.',
          PAYOUTS: {
            ERRORS_BANNER: 'Algunos payouts tienen errores, revisa que la documentación de KYC esté completa y sin errores. ({{count}} afectados)',
            FILTER_LABEL: 'Filtrar por estado:',
            ERROR_DOCS_TOOLTIP: 'Ver códigos de error de Paycomet',
            ERROR_DOCS_LINK: 'Ver códigos',
            RESET_FILTERS: 'Limpiar filtros',
            COPY_TOOLTIP: 'Copiar al portapapeles',
            COPY_SUCCESS: 'Copiado',
            NO_REFERENCE: 'Sin referencia',
            STATUS: {
              PROCESSED: 'Procesado',
              PENDING: 'Pendiente',
              DISCARDED: 'Descartado',
              CANCELLED: 'Cancelado',
            },
            TABLE: {
              PAYMENT_ORDER_ID: 'Payment order ID',
              STATUS: 'Estado',
              CREATED_AT: 'Creado',
              PROCESSED_AT: 'Procesado',
              ERROR: 'Error',
              AMOUNT: 'Importe',
              PAYIN_ORDER_ID: 'Payin order ID',
              REFERENCE: 'Referencia de pago',
              NO_RESULTS: 'No se encontraron payouts.',
            },
            PAGINATION: {
              TOTAL: '{{total}} resultados en total',
              PREV: 'Anterior',
              NEXT: 'Siguiente',
            },
          },
        },
      },
      CONFIGURATION: {
        SUBTITLE:
          'Administra las preferencias de tu cuenta, los métodos de pago y el cumplimiento legal de tu infraestructura.',
        TABS: {
          PAGOS: 'Pagos',
          API_KEYS: 'Claves API',
          WEBHOOKS: 'Webhooks',
          EMAIL_ALERTS: 'Avisos de email',
        },
        DESARROLLADORES: {
          TITLE: 'Herramientas de desarrollador',
          DESCRIPTION:
            'Gestiona las claves API, webhooks y avisos de email para tus integraciones.',
          SUBTITLE: 'Configura tus integraciones y canales de notificación.',
        },
        USUARIOS: {
          TITLE: 'Usuarios',
          DESCRIPTION: 'Crea y gestiona los usuarios que pueden acceder a este tenant.',
          FORM_TITLE: 'Crear usuario',
          FORM_SUBTITLE: 'El nuevo usuario recibirá un email para establecer su contraseña.',
          EDIT_FORM_TITLE: 'Editar usuario',
          EDIT_FORM_SUBTITLE: 'Actualiza los datos, el rol y los perfiles de cobro de este usuario.',
          ADVISORY_TITLE: 'Se enviará un email de invitación',
          ADVISORY_BODY:
            'El nuevo usuario recibirá un email en la dirección indicada para establecer su contraseña antes de poder iniciar sesión.',
          NAME_LABEL: 'Nombre',
          NAME_PLACEHOLDER: 'Introduce el nombre',
          SURNAME_LABEL: 'Apellidos',
          SURNAME_PLACEHOLDER: 'Introduce los apellidos',
          EMAIL_LABEL: 'Email',
          EMAIL_PLACEHOLDER: 'Introduce el email',
          LANGUAGE_LABEL: 'Idioma',
          LANGUAGE_ES: 'Español',
          LANGUAGE_EN: 'Inglés',
          ROLE_LABEL: 'Rol',
          ROLE_PLACEHOLDER: 'Selecciona un rol',
          COLLECTORS_LABEL: 'Perfiles de cobro',
          COLLECTORS_PLACEHOLDER: 'Selecciona perfiles de cobro',
          COLLECTORS_EMPTY: 'No hay perfiles de cobro disponibles.',
          COLLECTORS_SELECT_ALL: 'Seleccionar todos',
          COLLECTORS_REMOVE: 'Eliminar',
          SUBMIT: 'Crear usuario',
          SAVE_CHANGES: 'Guardar cambios',
          CREATE_SUCCESS_TITLE: 'Usuario creado',
          CREATE_SUCCESS_BODY: 'Se ha enviado un email de invitación al nuevo usuario.',
          UPDATE_SUCCESS_TITLE: 'Usuario actualizado',
          UPDATE_SUCCESS_BODY: 'Se han guardado los datos del usuario.',
          DELETE_SUCCESS_TITLE: 'Usuario eliminado',
          DELETE_SUCCESS_BODY: 'El usuario ya no tiene acceso a este tenant.',
          DELETE_CONFIRM_HEADER: 'Eliminar usuario',
          DELETE_CONFIRM_MESSAGE: '¿Seguro que quieres eliminar a {{name}}? Esta acción no se puede deshacer.',
          DELETE_CONFIRM_ACCEPT: 'Eliminar',
          DELETE_CONFIRM_REJECT: 'Cancelar',
          GO_BACK: 'Volver',
          CREATE_ANOTHER: 'Crear otro usuario',
          NOT_AUTHORIZED_TITLE: 'Solo administradores',
          NOT_AUTHORIZED_SUBTITLE: 'Necesitas permisos de administrador para gestionar usuarios.',
          LIST_TITLE: 'Usuarios',
          LIST_SUBTITLE: 'Todos los usuarios que pueden acceder a este tenant.',
          LIST_LOADING: 'Cargando usuarios…',
          LIST_EMPTY_TITLE: 'Todavía no hay usuarios',
          LIST_EMPTY_SUBTITLE: 'Crea el primer usuario para dar acceso a este tenant.',
          CREATE_NEW_USER: 'Crear nuevo usuario',
          TABLE: {
            NAME: 'Nombre',
            EMAIL: 'Email',
            ROLE: 'Rol',
            COLLECTORS: 'Perfiles de cobro',
            LANGUAGE: 'Idioma',
            MORE_COLLECTORS: '+{{count}} más',
            ACTIONS: 'Acciones',
            EDIT_TOOLTIP: 'Editar usuario',
            DELETE_TOOLTIP: 'Eliminar usuario',
          },
          ERRORS: {
            TITLE: 'Error',
            LOAD_FAILED: 'No se han podido cargar los roles. Inténtalo de nuevo.',
            CREATE_FAILED: 'No se ha podido crear el usuario. Inténtalo de nuevo.',
            UPDATE_FAILED: 'No se ha podido actualizar el usuario. Inténtalo de nuevo.',
            DELETE_FAILED: 'No se ha podido eliminar el usuario. Inténtalo de nuevo.',
          },
        },
        PAGOS: {
          TITLE: 'Pagos',
          DESCRIPTION:
            'Gestiona tus pasarelas de pago, la documentación KYC y los requisitos de cumplimiento de tu proveedor de pagos.',
        },
        API_KEYS: {
          TITLE: 'Claves API',
          DESCRIPTION:
            'Una API key te permite conectar con nuestra API y usar sus funcionalidades. Puedes crear varias keys con distintos niveles de acceso. <a href="https://paymefy.stoplight.io/docs/paymefy-public-api/a455b013d6d9d-public-api" target="_blank" rel="noopener">Consulta la documentación</a>.',
          ADD_BUTTON: 'Crear clave',
          DELETE_LABEL: 'Eliminar',
          TABLE: {
            NAME: 'Nombre',
            CREATED: 'Creada',
          },
          EMPTY: 'Todavía no hay claves API.',
          FOOTER:
            'Las claves API otorgan acceso completo a la API de Paymefy en nombre de tu tenant. Mantenlas en secreto — <strong>nunca las expongas en código del lado del cliente</strong>.',
          CREATE_MODAL: {
            TITLE: 'Crear clave API',
            NAME_LABEL: 'Nombre',
            NAME_PLACEHOLDER: 'Ej. Integración de producción',
            CANCEL: 'Cancelar',
            SUBMIT: 'Crear clave',
            SUBMITTING: 'Creando…',
          },
          KEY_MODAL: {
            TITLE: 'Tu nueva clave API',
            WARNING:
              'Copia esta clave ahora — no podrás volver a verla después de cerrar este diálogo.',
            COPY: 'Copiar clave',
            DONE: 'Listo, la he guardado',
          },
          DELETE_CONFIRM: {
            TITLE: 'Revocar clave API',
            MESSAGE:
              'Esta acción no se puede deshacer. Cualquier integración que use esta clave dejará de funcionar de forma inmediata.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Revocar clave',
          },
          TOAST: {
            COPY_SUCCESS: {
              SUMMARY: 'Clave copiada',
              DETAIL: 'La clave API se ha copiado al portapapeles.',
            },
            LOAD_ERROR: { SUMMARY: 'Claves API', DETAIL: 'No se pudieron cargar las claves API.' },
            CREATE_ERROR: { SUMMARY: 'Error al crear', DETAIL: 'No se pudo crear la clave API.' },
            DELETE_SUCCESS: {
              SUMMARY: 'Clave revocada',
              DETAIL: 'La clave API se ha revocado correctamente.',
            },
            DELETE_ERROR: {
              SUMMARY: 'Error al revocar',
              DETAIL: 'No se pudo revocar la clave API.',
            },
          },
        },
        EMAIL_ALERTS: {
          TITLE: 'Avisos de email',
          DESCRIPTION:
            'Asigna uno o varios correos a cada tipo de evento. Cada combinación puede limitarse a uno o varios perfiles de cobro.',
          ADD_BUTTON: 'Añadir email',
          EMPTY: 'No hay avisos de email configurados.',
          FOOTER:
            'Los avisos de email se envían a las direcciones configuradas cuando ocurren los eventos suscritos.',
          COLLECTORS: {
            LABEL: 'Perfiles de cobro',
            EMPTY: 'Sin perfiles de cobro asignados.',
          },
          CONTEXTS: {
            LABEL: 'Eventos suscritos',
            EMPTY: 'Sin eventos configurados.',
          },
          DELETE_CONFIRM: {
            TITLE: 'Eliminar aviso de email',
            MESSAGE:
              'Esta acción no se puede deshacer. La dirección dejará de recibir notificaciones de forma inmediata.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Eliminar',
          },
          EDIT_MODAL: {
            TITLE: 'Editar aviso de email',
            SUBMIT: 'Guardar cambios',
          },
          CREATE_MODAL: {
            TITLE: 'Añadir aviso de email',
            EMAIL_LABEL: 'Dirección de correo',
            EMAIL_PLACEHOLDER: 'ejemplo@dominio.com',
            COLLECTORS_LABEL: 'Perfiles de cobro',
            COLLECTORS_SELECTED: '{{selected}} de {{total}} seleccionados',
            SELECT_ALL_COLLECTORS: 'Seleccionar todos',
            CLEAR_COLLECTORS: 'Limpiar selección',
            COLLECTORS_EMPTY: 'No hay perfiles de cobro disponibles.',
            CONTEXTS_LABEL: 'Eventos a suscribirse',
            CANCEL: 'Cancelar',
            SUBMIT: 'Añadir aviso',
            SUBMITTING: 'Añadiendo…',
          },
        },
        WEBHOOKS: {
          TITLE: 'Webhooks',
          DESCRIPTION:
            'Crea y gestiona webhooks para recibir notificaciones en tiempo real en tu sistema externo. Cada endpoint puede asociarse a uno o varios perfiles de cobro. <a href="https://paymefy.stoplight.io/docs/paymefy-public-api/tp0hqj5fcf6ap-webhooks" target="_blank" rel="noopener">Consulta la documentación</a>.',
          ADD_BUTTON: 'Añadir endpoint',
          EMPTY: 'No hay webhooks configurados.',
          DELETE_LABEL: 'Eliminar',
          FOOTER:
            'Los webhooks se asignan a tu <strong>workspace</strong> y pueden gestionarlos los usuarios con el permiso «Gestión de webhooks» y los administradores.',
          SIGNING_SECRET: {
            TITLE: 'Secreto de firma',
            DESCRIPTION: 'Usa este secreto para verificar que las llamadas llegan desde Paymefy.',
          },
          COLLECTORS: {
            LABEL: 'Perfiles de cobro',
            EMPTY: 'Sin perfiles de cobro asignados.',
          },
          CONTEXTS: {
            LABEL: 'Eventos suscritos',
            EMPTY: 'Sin eventos configurados.',
          },
          REGENERATE_CONFIRM: {
            TITLE: 'Regenerar secreto de firma',
            MESSAGE:
              'El secreto actual quedará invalidado de forma inmediata. Cualquier sistema que verifique firmas de webhook con el secreto antiguo dejará de funcionar hasta que se actualice.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Regenerar secreto',
          },
          DELETE_CONFIRM: {
            TITLE: 'Eliminar endpoint',
            MESSAGE:
              'Esta acción no se puede deshacer. El endpoint dejará de recibir eventos de forma inmediata.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Eliminar endpoint',
          },
          TOAST: {
            LOAD_ERROR: { SUMMARY: 'Webhooks', DETAIL: 'No se pudieron cargar los webhooks.' },
            CREATE_SUCCESS: {
              SUMMARY: 'Endpoint creado',
              DETAIL: 'El endpoint se ha creado correctamente.',
            },
            CREATE_ERROR: { SUMMARY: 'Error al crear', DETAIL: 'No se pudo crear el endpoint.' },
            UPDATE_SUCCESS: {
              SUMMARY: 'Endpoint actualizado',
              DETAIL: 'El endpoint se ha actualizado correctamente.',
            },
            UPDATE_ERROR: {
              SUMMARY: 'Error al actualizar',
              DETAIL: 'No se pudo actualizar el endpoint.',
            },
            DELETE_SUCCESS: {
              SUMMARY: 'Endpoint eliminado',
              DETAIL: 'El endpoint se ha eliminado correctamente.',
            },
            DELETE_ERROR: {
              SUMMARY: 'Error al eliminar',
              DETAIL: 'No se pudo eliminar el endpoint.',
            },
            SECRET_COPY_SUCCESS: {
              SUMMARY: 'Secreto copiado',
              DETAIL: 'El secreto de firma se ha copiado al portapapeles.',
            },
            SECRET_LOAD_ERROR: {
              SUMMARY: 'Secreto de firma',
              DETAIL: 'No se pudo cargar el secreto de firma.',
            },
            REGENERATE_SUCCESS: {
              SUMMARY: 'Secreto regenerado',
              DETAIL: 'El secreto de firma se ha regenerado correctamente.',
            },
            REGENERATE_ERROR: {
              SUMMARY: 'Error al regenerar',
              DETAIL: 'No se pudo regenerar el secreto de firma.',
            },
          },
          EDIT_MODAL: {
            TITLE: 'Editar endpoint',
            SUBMIT: 'Guardar cambios',
          },
          CREATE_MODAL: {
            TITLE: 'Añadir endpoint',
            TYPE_LABEL: 'Tipo',
            TYPE_WEB: 'Web (URL)',
            TYPE_EMAIL: 'Email',
            URL_LABEL: 'URL del endpoint',
            URL_PLACEHOLDER: 'https://',
            EMAIL_LABEL: 'Dirección de correo',
            EMAIL_PLACEHOLDER: 'ejemplo@dominio.com',
            COLLECTORS_LABEL: 'Perfiles de cobro',
            COLLECTORS_SELECTED: '{{selected}} de {{total}} seleccionados',
            SELECT_ALL_COLLECTORS: 'Seleccionar todos',
            CLEAR_COLLECTORS: 'Limpiar selección',
            COLLECTORS_EMPTY: 'No hay perfiles de cobro disponibles.',
            CONTEXTS_LABEL: 'Eventos a suscribirse',
            CANCEL: 'Cancelar',
            SUBMIT: 'Crear endpoint',
            SUBMITTING: 'Creando…',
          },
        },
      },
      NOT_FOUND: {
        TITLE: 'Oops! Página no encontrada',
        DESCRIPTION:
          'No hemos encontrado lo que buscabas. Es posible que la página haya sido movida o eliminada.',
        BACK_TO_DASHBOARD: 'Volver al Dashboard',
      },
      PROFILE: {
        TITLE: 'Información Personal',
        DESCRIPTION: 'Actualiza tus datos personales',
        INFO: 'Información personal',
        INFO_UPDATE: 'Actualiza tus datos personales',
        FORM: {
          NAME: 'NOMBRE',
          SURNAME: 'APELLIDOS',
          EMAIL: 'EMAIL',
          ROLE: 'ROL',
          LANGUAGE: 'LENGUAJE',
        },
        TOAST: {
          SUCCESS: 'Usuario Actualizado',
          ERROR: 'Error al actualizar el usuario',
          ERROR_HEADER: 'Error',
          SUCCESS_HEADER: 'Acción realizada',
        },
      },
      LISTING: {
        BC: {
          NOTIFICATIONS: 'Notificaciones enviadas',
          CONTACT_ERRORS: 'Errores contactabilidad',
          ABANDONED_PAYMENTS: 'Abandonos pasarela de pago',
          PAYMENTS: 'Listado de pagos',
          OP_NOTIFIED: 'Operaciones notificadas',
          FEEDBACK: 'Feedbacks',
          OUTBANDCALL: 'Llamadas externas',
          BLOCKED_PHONES: 'Móviles bloqueados y teléfonos no notificables para SMS',
          LEGAL_CLAIMS: 'Demandas legales',
          MASCS: 'MASCS',
        },
        TOOLTIP: {
          CONTACT_ERRORS:
            'El rango de fecha seleccionado corresponde a la fecha del primer intento de entrega de la notificación.',
          ABANDONED_PAYMENTS:
            'El rango de fecha seleccionado corresponde a la fecha y hora de los clics al botón de pago que no han terminado en pago completado.',
          NOTIFICATION:
            'El rango de fecha seleccionado corresponde a la fecha de envío de la notificación.',
          PAYMENTS:
            'El rango de fecha seleccionado corresponde a la fecha y hora de confirmación del pago por parte de la pasarela de pago.',
          BLOCKEDPHONES:
            'El rango de fecha seleccionado corresponde a la fecha y hora de los móviles y teléfonos no notificables.',
        },
        TYPES: {
          ABANDONED_PAYMENTS: 'Abandonos_pasarela_pago_',
          NOTIFICATION: 'Notificaciones_',
          CONTACT_ERRORS: 'Errores_contactabilidad_',
          PAYMENTS: 'Pagos_',
        },
        LABELS: {
          ABANDONED_PAYMENT: 'Abandonos pasarela de pago',
          NOTIFICATION: 'Notificaciones',
          CONTACT_ERROR: 'Errores de contactabilidad',
          PAYMENTS: 'Pagos',
        },
        TITLE: 'Listados',
        GENERATE: {
          TITLE: 'Generar un listado',
          GENERATE: 'Generar listado',
          FORM: {
            COLLECTOR: 'PERFIL DE COBRO',
            TIME_RANGE: 'RANGO DE TIEMPO',
          },
        },
        TYPE: {
          ABANDONED_PAYMENT: {
            TITLE: 'Listados generados',
            LIST: {
              TABLE: {
                NO_RESULTS: 'No hay abandonos pasarela de pago que mostrar',
                HEADERS: {
                  ID: 'ID',
                  NAME: 'NOMBRE LISTADO',
                  DATE_CREATED: 'FECHA DE CREACIÓN',
                  TIME_RANGE: 'RANGO DE TIEMPO',
                  N_RESULTS: 'RESULTADOS',
                  STATUS: 'ESTADO',
                  COLLECTORS: 'PERFILES DE COBRO',
                  ACTIONS: 'ACCIONES',
                },
              },
            },
          },
          NOTIFICATION_LIST: {
            TITLE: 'Listados generados',
            LIST: {
              TABLE: {
                NO_RESULTS: 'No hay notificaciones que mostrar',
                HEADERS: {
                  ID: 'ID',
                  NAME: 'NOMBRE LISTADO',
                  DATE_CREATED: 'FECHA DE CREACIÓN',
                  TIME_RANGE: 'RANGO DE TIEMPO',
                  N_RESULTS: 'RESULTADOS',
                  STATUS: 'ESTADO',
                  COLLECTORS: 'PERFILES DE COBRO',
                  ACTIONS: 'ACCIONES',
                },
              },
            },
          },
          CONTACT_ERROR: {
            TITLE: 'Listados generados',
            LIST: {
              TABLE: {
                NO_RESULTS: 'No hay errores de contactabilidad que mostrar',
                HEADERS: {
                  ID: 'ID',
                  NAME: 'NOMBRE LISTADO',
                  DATE_CREATED: 'FECHA DE CREACIÓN',
                  TIME_RANGE: 'RANGO DE TIEMPO',
                  N_RESULTS: 'RESULTADOS',
                  STATUS: 'ESTADO',
                  COLLECTORS: 'PERFILES DE COBRO',
                  ACTIONS: 'ACCIONES',
                },
              },
            },
          },
        },
      },
      INSTANCES: {
        TITLE: 'Expedientes',
        CONFIG: {
          OPEN: 'El expediente aún tiene cobros pendientes y puede recibir notificaciones por email, SMS o llamadas.',
          CLOSED:
            'El expediente no tiene cobros pendientes y deja de recibir cualquier tipo de notificación',
          SILENCED: 'Expediente silenciado',
        },
        STATUS_CAMPAIGN: {
          InCampaign: 'En campaña',
          NotInCampaign: 'No esta en campaña',
          HasBeenInCampaign: 'Ha estado en campaña',
          HasNotBeenInCampaign: 'No ha estado en campaña',
        },
        MASSIVE_SELECTION: {
          SELECTED: {
            SELECTED_COUNT:
              'Has seleccionado {{countOp}} operaciones agrupadas en {{count}} expedientes',
            FILTERS: 'Filtros',
            NO_FILTERS: 'No hay filtros aplicados',
            COLLECTORS_COUNT: 'Perfiles de cobro: {{count}} núm.',
            CAMPAIGNS_COUNT: 'Campañas: {{count}} núm.',
            STATUS: 'Estado',
            AMOUNT_RANGE: 'Importe pendiente: {{min}} a {{max}} {{currency}}',
            MORE_ITEMS: '+{{count}} más',
            STATUS_ACTIVE: 'Activo',
            STATUS_INACTIVE: 'Inactivo',
            SINGLE: 'Has seleccionado',
            OPERATIONS: 'operaciones',
            GROUPED_IN: 'agrupadas en',
            ALL_SELECTED: 'Seleccionar todos los {{ totalResults }} expedientes',
            ASSIGN_PILL: 'Asignar a píldora',
            ASSIGN_CAMPAIGN: 'Asignar a campaña',
            UNASSIGN_CAMPAIGN: 'Desasignar de campaña',
            SHOW_CAMPAIGN: 'Mostrar campaña',
            SEND_MASSIVE_PILL: 'Asignar expedientes a campaña masivamente',
            UNASSIGN_MASSIVE: 'Desasignar expedientes de campaña masivamente',
            ARE_YOU_SURE:
              '¿Estás seguro de que deseas proceder con esta acción? Comprueba los datos siguientes antes de proceder con esta acción:',
            CANCEL: 'Cancelar',
            CAMPAIGN_FIELD_LABEL: 'Campaña destino',
            CAMPAIGN_PLACEHOLDER: 'Selecciona una campaña',
            EMPTY_HINT: 'Selecciona una campaña para ver el resumen de asignación.',
            EXPEDIENTE: 'expediente',
            EXPEDIENTES: 'expedientes',
            OP_AGRUPADA: 'operación agrupada',
            OPS_AGRUPADAS: 'operaciones agrupadas',
            AGRUPADA: 'agrupada',
            AGRUPADAS: 'agrupadas',
            SUMMARY_ASSIGN:
              'Vas a asignar <strong>{{ ops }} {{ operaciones }}</strong> {{ agrupadas }} en <strong>{{ count }} {{ expedientes }}</strong> a la campaña <strong>{{ campaign }}</strong>. La asignación es reversible desde la lista de expedientes.',
            SUMMARY_UNASSIGN:
              'Vas a desasignar <strong>{{ ops }} {{ operaciones }}</strong> {{ agrupadas }} en <strong>{{ count }} {{ expedientes }}</strong> de la campaña <strong>{{ campaign }}</strong>.',
            ASSIGN_MASSIVE_BTN: 'Asignar {{ count }} expedientes',
            UNASSIGN_MASSIVE_BTN: 'Desasignar {{ count }} expedientes',
          },
          MASSIVE_SELECTED: {
            DELETE: 'Eliminar selección masiva',
          },
        },
        FORM: {
          LABELS: {
            COLLECTOR_IDS: 'Perfiles de Cobros',
            STATUSES: 'Estado Expedientes',
            WORKFLOW_IDS: 'Campañas',
            HAS_PASSED: '¿Ha pasado por alguna campaña?',
            MIN_PENDING_AMOUNT: 'Importe Pendiente Mínimo',
            MAX_PENDING_AMOUNT: 'Importe Pendiente Máximo',
            PENDING_AMOUNT: 'Importe Pendiente',
            SEARCH: 'Búsqueda',
            SEGMENT_ID: 'Segmentos',
            CUSTOMER_EXTERNAL: 'Ids de clientes',
            OPERATION_EXTERNAL: 'Ids de operaciones',
          },
          PLACEHOLDERS: {
            SELECT_OPTION: 'Selecciona una opción',
          },
        },
        ELEMENTS: {
          STATUS: {
            ACTIVE: 'Activo',
          },
        },
        LIST: {
          FORM: {
            SEARCH_TOOLTIP_OP: `Busca por External ID de operación.

            También puedes buscar varios elementos separados por coma.

            Ejemplo: Op1234, Op1235, Op1236`,
            SEARCH_TOOLTIP_CUSTOMER: `Busca por External ID de cliente.

            También puedes buscar varios elementos separados por coma.

            Ejemplo: C1234, C1235, C1236`,
            SEARCH_TOOLTIP_TYPE: `Busca por {{message}}.

            También puedes buscar varios elementos separados por coma.

            Ejemplo: C1234, C1235, C1236`,
            RANGE_TOOLTIP: `Busca por rango de fechas. Fecha inicio y Fecha fin.`,
          },
          TITLE: 'Listado de expedientes',
          KPI: {
            TOOLTIP_PENDING: 'Importes pendientes por pagar',
            TOOLTIP_NUM_OP: 'Número de operaciones según los filtros aplicados',
            TOOLTIP_NUM_CUS: 'Número de clientes según los filtros aplicados',
            NUM_CLIENTE: 'Número de clientes',
            PENDING_AMOUNT: 'Importes pendientes',
            NUM_OP: 'Número de operaciones',
            DATA_NUM_CLIENT: '{{count}} con {{number}} expedientes',
            DATA_NUM_OP: '{{count}} en {{number}} expedientes',
            OP_META: 'en {{number}} expedientes',
            CLIENT_META: 'con {{number}} expedientes',
          },
          TABLE: {
            NO_RESULTS: 'No hay expedientes que mostrar',
            NO_OPERATIONS: 'No hay operaciones que mostrar',
            TOTAL_RESULTS: 'Resultados totales',
            RESULTS_PER_PAGE: 'Resultados por página',
            PARTIAL_PAYMENT: 'Pago parcial',
            HEADERS: {
              STATUS: 'ESTADO',
              CUSTOMER_NAME: 'NOMBRE Y APELLIDOS CLIENTE',
              CUSTOMER: 'ID CLIENTE',
              COLLECTOR: 'PERFIL DE COBRO',
              PORTFOLIO: 'CARTERA',
              CAMPAIGN: 'CAMPAÑA ACTUAL',
              N_OPERATIONS: 'Nº DE OPERACIONES',
              TOTAL_AMOUNT: 'IMPORTE TOTAL',
              PENDING_AMOUNT: 'IMPORTE PENDIENTE',
              DATE: 'FECHA CREACIÓN',
              ACTIONS: 'ACCIONES',
              SUBHEADERS: {
                STATUS: 'ESTADO',
                ID_OPERATION: 'ID OPERACIÓN',
                TITLE: 'TÍTULO',
                AMOUNT: 'IMPORTE',
                DUE_DATE: 'FECHA DE VENCIMIENTO',
              },
            },
          },
        },
      },
      CAMPAINGS: {
        TITLE: 'Campañas',
        CAMPAING: 'Campaña',
        CAMPAING_NAME: 'Nombre de la campaña',
        CAMPAING_TYPE: 'Tipo de campaña',
        NO_ACTIONS: 'No hay acciones disponibles',
        STATUS_ACTIONS: {
          PROCESSING: 'Procesando...',
          PROCESSING_ACTION: 'Procesando acción...',
          ACTIVE: 'Activa',
          INACTIVE: 'Inactiva',
          DRAFT: 'Borrador',
          PAUSED: 'Pausada',
          TOOLTIP_ACTIVATE: 'Haz click para activar campaña',
          TOOLTIP_PAUSE: 'Haz click para pausar campaña',
          COLLECTOR_TOOLTIP_ACTIVATE: 'Haz click para activar collector',
          COLLECTOR_TOOLTIP_PAUSE: 'Haz click para pausar collector',
          PAUSE_CONFIRM_HEADER: '¿Pausar campaña [{{name}}]?',
          PAUSE_CONFIRM_ACCEPT: 'Pausar',
          ACCEPT: 'Aceptar',
        },
        CALENDAR: 'Calendario',
        CAMPAIGN_GENERATOR: 'Generar campaña',
        ERROR: {
          TITLE: 'Error',
          UNKNOWN: 'Ocurrió un error desconocido',
          ID_NOT_FOUND: 'ID de campaña no encontrado',
        },
        PROGRESS: {
          TITLE: 'Progreso',
          CREATING: 'Creando la campaña...',
        },
        SUCCESS: {
          TITLE: 'Éxito',
          CREATED: 'Campaña creada correctamente',
        },
        STEPPER: {
          CAMPAIGN: 'Campaña',
          SEGMENTATION: 'Segmentación',
          STRATEGY: 'Estrategia',
          CHECK: 'Revisar',
        },
        WORKFLOWS: {
          WAIT: {
            INFO_WAIT_DAYS_FOR_DUE_DATE:
              'Las notificaciones configuradas a continuación se enviarán por <b>{{ partDay }}</b>, <b>{{ waitDays }}</b> días <b>{{ beforeOrAfter }}</b> del vencimiento de la factura. Si el cliente tiene más de una factura se prioriza la fecha del vencimiento de la factura más antigua.',
            INFO_WAIT_DAYS:
              'Las notificaciones configuradas a continuación se enviarán por <b>{{ partDay }}</b>, dentro de <b>{{ waitDays }}</b> días.',
            INFO_WAIT_DAY_OF_WEEK:
              'Las notificaciones configuradas a continuación se enviarán por <b>{{ partDay }}</b>, el <b>{{ dayOfWeek }}</b>.',
            INFO_WAIT_DAY_OF_MONTH:
              'Las notificaciones configuradas a continuación se enviarán por <b>{{ partDay }}</b>, el día <b>{{ dayOfMonth }}</b> de este mes.',
          },
          EDIT_WORKFLOW: 'Editar flujo de trabajo',
          REDIRECT_COLLECTOR: 'Ir a perfiles de cobro',
          MONITOR_COLLECTOR: 'Monitor de perfiles de cobro',
          SAVE_CHANGES: 'Guardar cambios',
          MINIMIZE_PANEL: 'Minimizar panel',
          MAXIMIZE_PANEL: 'Maximizar panel de información',
          INFO_CAMPAIGN: 'Info de campaña',
          SHOW_DETAILS: 'Mostrar detalles',
          WORKFLOW_TAB: 'Workflow',
          CANCEL_EDIT: 'Cancelar edición',
          SAVE_WORKFLOW: 'Guardar cambios de workflow',
          SAVE_CHANGES_WITH_ADVERT: 'Guardar cambios con advertencias',
          BEFORE_SAVE: 'Antes de guardar, ten en cuenta que:',
          THERE_IS_ERRORS: 'Hay errores en la configuración del nodo',
          ARE_YOU_SURE: '¿Estás seguro de que deseas guardar los cambios así?',
          CANCEL: 'Cancelar',
          HAS_TO_SOLVE: 'Los siguientes errores deben resolverse:',
          SUMMARY_MISS_CONFIG: 'Aviso de configuración de canales de notificación',
          CHANNEL_NOT_CONFIGURED:
            'Este canal no está configurado para uno o varios perfiles de cobro.',
          ALERT_MISSING_CONFIG:
            'Estás a punto de agregar un nodo de notificación {{canal}} que no está configurado para todos los perfiles de cobro. Es posible que algunos clientes no reciban la notificación.',
          MESSAGE_MISSING_CONFIG:
            'Hay un/os nodo/s que usa un canal de notificación que no está configurado en todos los perfiles de cobro. La notificación podría no enviarse. Para asegurar su envío, añade este canal al perfil correspondiente.',
          MISSING_INFO: 'Falta información en:',
          UNPUBLISHED_READONLY_TITLE: 'Campaña archivada',
          UNPUBLISHED_READONLY_WORKFLOW_BODY:
            'Esta campaña está archivada. El workflow no puede editarse, tampoco los criterios de entrada de la campaña.',
          UNPUBLISHED_READONLY_INFO_BODY:
            'Esta campaña está archivada. La información general y los criterios de entrada no pueden editarse.',

          NODE_FORM: {
            CUSTOM_FIELD: 'CustomFields utilizados',
            AGENT_ID: 'Agente asignado',
            TIME_SLOT: 'Franja horaria de envío',
            TIME_SLOT_MORNING: 'Mañana',
            TIME_SLOT_EVENING: 'Tarde',
            TIME_SLOT_FULL_DAY: 'Todo el día',
            WAIT_DAYS: 'Días',
            WAIT_DAYS_PLACEHOLDER: 'Introduce los días de espera',
            DAY_OF_WEEK: 'Día de la semana',
            SELECT_OPTION: 'Selecciona una opción',
            DAY_OF_MONTH: 'Día del mes',
            TEMPLATES: 'Plantillas',
            MESSAGE: 'Mensajes',
            VOICE: 'Voz',
            STATUS: 'Estado',
            PERCENTAGE: 'Porcentaje del experimento',
            SEGMENTS: 'Segmentos',
            MINIMUM_AMOUNT: 'Monto mínimo',
            MINIMUM_AMOUNT_TAN: 'Monto mínimo en %',
            SEND_ALL_CONTACTS:
              'Envía este mensaje a todas las direcciones de canal disponibles para cada cliente',
            RECEIVED: 'Recibido',
            ASSIGN_CAMPAIGN: 'Asignar a campaña',
            BEFORE_AFTER: 'Antes o después del vencimiento',
            NUMBER_FEE: 'Número de cuotas',
            DURATION_DAYS: 'Duración en días',
            EXPIRATION: 'El acuerdo de pago expira en (días)',
            EXPIRATION_PARTIAL: 'El pago parcial expira en (días)',
            EXPIRATION_AT: 'Día de expiración',
            BEFORE: 'Antes',
            AFTER: 'Después',
            EXPIRATION_DAYS: 'Días de vencimiento',
            READ: 'Leído',
            ERROR: 'Error',
            DAYS: {
              MONDAY: 'Lunes',
              TUESDAY: 'Martes',
              WEDNESDAY: 'Miércoles',
              THURSDAY: 'Jueves',
              FRIDAY: 'Viernes',
              SATURDAY: 'Sábado',
              SUNDAY: 'Domingo',
            },
          },
          NODE_TYPE: {
            WAITS: 'Esperas',
            NOTIFICATIONS: 'Notificaciones',
            CONDITIONAL: 'Condicional',
            FLEX_OPTIONS: 'Opciones de flexibilidad',
            CALL_OPTIONS: 'Opciones de llamada',
            LEGAL_CLAIM: 'Demanda legal',
            END: 'Final',
            OFFER_PAYMENT_AGREEMENT_LINE1: 'Acuerdo',
            OFFER_PAYMENT_AGREEMENT_LINE2: 'de pago',
            OFFER_PARTIAL_LINE_1: 'Pago',
            OFFER_PARTIAL_LINE_2: 'parcial',
          },
          CALENDAR: {
            EVENT_TITLE: 'Título',
            EVENT_DESCRIPTION: 'Descripción',
            EVENT_START_DATE: 'Fecha de inicio',
            EVENT_END_DATE: 'Fecha final',
            EVENT_TYPE: 'Tipo',
            NEW_EVENT: 'Nuevo evento',
            EDIT_EVENT: 'Editar evento',
            DISPLAY_EVENT: 'Evento',
            DESCRIPTION_LABEL: 'Descripción',
            START_DATE_LABEL: 'Inicio',
            END_DATE_LABEL: 'Final',
            TYPE_LABEL: 'Tipo',
          },
          VALIDATIONS: {
            INVALID_LENGTH_OF_NODES: 'Deben haber mínimo 3 nodos en el diagrama',
            NOT_CONNECTED_TO_END:
              'Hay una rama del diagrama no conectada a un nodo tipo finalización',
            INVALID_NUMBER_OF_START_NODES: 'Número incorrecto de nodos tipo inicio',
            NO_END_NODE: 'No existen nodos de tipo finalización',
            NO_PARENT_NODE: 'Hay nodos tipo evento que no tienen un nodo padre conectado',
            NO_CHILD_NODE: 'Hay nodos tipo evento que no tienen un nodo hijo conectado',
            DUPLICATE_NODE_IDS: 'Existen nodos duplicados',
            NO_COPY_IDS: 'Debe haber plantillas seleccionadas para el nodo {{nodoType}}',
            NO_TARGET_IDS: 'Debe seleccionar una campaña objetivo para el nodo {{nodoType}}',
            NO_TARGET_NODE: 'Debe seleccionar un nodo objetivo para el nodo {{nodoType}}',
            NO_STATUS: 'Debe seleccionar al menos un estado para el nodo {{nodoType}}',
            NO_SEGMENTS: 'Debe seleccionar al menos un segmento para el nodo {{nodoType}}',
            NO_MIN_AMOUNT: 'Debe añadir un importe mínimo para el nodo {{nodoType}}',
            EXCEEDED_PERCENTAGE: 'El porcentaje debe mantenerse entre 1 y 99',
            EXCEEDED_CADUCITY: 'La caducidad debe mantenerse entre 1 y 90 días',
            EXCEEDED_INSTALMENTS: 'El número de cuotas debe mantenerse entre 2 y 24',
            NO_EXPIRATION: 'Debe añadir un día de caducidad para el nodo {{nodoType}}',
            NO_PART_DAY: 'Debe añadir días de espera para el nodo {{nodoType}}',
            NO_DAY_OF_MONTH: 'Debe seleccionar día del mes para el nodo {{nodoType}}',
            NO_WAIT_DAYS: 'Debe añadir días de espera para el nodo {{nodoType}}',
            NO_BEFORE_AFTER:
              'Debe seleccionar antes o después del vencimiento para el nodo {{nodoType}}',
            ERROR_DAY_BEFORE_AFTER:
              'Hay error en los días configurados en relación al campo Antes o Después, puede que el valor sea incorrecto para el nodo {{nodoType}}',
            NO_DAY_OF_WEEK: 'Debe seleccionar un día de la semana para el nodo {{nodoType}}',
            NO_CASE_CONDITIONAL:
              'Debe haber seleccionado y configurado un caso falso o verdadero para el nodo {{nodoType}}',
            NO_VOICE_ID: 'Debe añadir un código de voz para el nodo {{nodoType}}',
            NODE_MISSING_PARENT: 'El nodo no tiene ningún nodo padre conectado',
            NODE_MISSING_CHILD: 'El nodo no tiene ningún nodo hijo conectado',
            CONDITIONAL_MISSING_BRANCH:
              'El nodo condicional debe tener las dos ramas conectadas (verdadero y falso)',
          },
          VALIDATION_DIALOG: {
            HEADER_WARN: 'Advertencias antes de guardar',
            HEADER_ERROR: 'Errores — no se puede guardar',
            ISSUE: 'problema',
            ISSUES: 'problemas',
            SECTION_WORKFLOW: 'Estructura del workflow',
            SECTION_NODES: 'Configuración de nodos',
            BTN_CLOSE: 'Cerrar',
            BTN_SAVE_ANYWAY: 'Guardar de todos modos',
          },
        },
        SEGMENTS: {
          CONDITIONS: {
            FIELD: 'Campo {{field}} con valor: {{value}}',
            CUSTOM_FIELD: 'Campos personalizados',
            CUSTOMER_CASE_OVERDUE_DAYS: 'Antigüedad de la deuda',
            PORTFOLIO_IDS: 'Carteras',
            CUSTOMER_AGE: 'Edad del cliente',
            CUSTOMER_GENDER: 'Género',
            CUSTOMER_CASE_PENDING_AMOUNT: 'Importe Pendiente',
            COLLECTOR_IDS: 'Perfiles de cobro',
            CUSTOMER_IS_COMPANY: 'Titularidad',
            BUSINESS: 'Empresa',
            OP_PENDING: 'operaciones pendientes',
            AGE: 'años',
            OVERDUE_DAYS: 'días de deuda',
            FROM: 'Desde ',
            FROM_TO: 'Desde {{from}} a {{to}} {{key}}',
            OR: 'O bien,',
            UNTIL: 'hasta ',
            PRIVATE: 'Privado',
            FILTER_NOT_VALID: 'Filtro no válido',
            NUMB_OPERATIONS: 'Importe pendiente',
          },
          CONDITION_NAME_NOT_FOUND: 'No se encontró el nombre para la clave especificada.',
          NO_SEGMENTS_WIZARD:
            'No has seleccionado ningún segmento específico. Esto significa que TODOS LOS NUEVOS EXPEDIENTES de los perfiles de cobro [listado de perfiles de cobro seleccionados en el paso anterior] podrían incluirse en esta campaña. ¿Estás seguro de que deseas continuar?',
          MODAL: {
            HEADER: 'Crear un nuevo segmento',
            SAVE: 'Guardar cambios',
            LOADING: 'Cargando...',
            ADD_NEW: 'Añadir nuevo',
            INCLUDE_SEGMENTS: 'Incluir segmentos',
            SAVE_SEGMENTS: 'Guardar segmento',
            COLLECTOR_PROFILE: 'Perfil de Cobro',
            PORTFOLIO: 'Cartera',
            MIN_PENDING_AMOUNT: 'Importe Pendiente Mínimo',
            MAX_PENDING_AMOUNT: 'Importe Pendiente Máximo',
            MIN_OVERDUE_DAYS: 'Antigüedad de Deuda Mínima',
            MAX_OVERDUE_DAYS: 'Antigüedad de Deuda Máxima',
            MIN_PAYABLE_OPERATIONS: 'Número Operaciones Pendientes Mínima',
            MAX_PAYABLE_OPERATIONS: 'Número Operaciones Pendientes Máxima',
            MIN_AGE: 'Edad Mínima',
            MAX_AGE: 'Edad Máxima',
            OWNERSHIP: 'Titularidad',
            GENDER: 'Género',
            NAME_SEGMENT: 'Nombre de segmento',
            VALUE: 'Valor',
            THE_SEGMENT: 'El segmento: ',
            SECTION_GENERAL: 'General',
            SECTION_AMOUNTS: 'Importes',
            SECTION_DELAYS: 'Días de demora',
            SECTION_OPERATIONS: 'Operaciones',
            SECTION_AGE: 'Edad',
            SECTION_CUSTOM_FIELD: 'Campo personalizado',
            LIVE_PREVIEW: 'Vista previa',
            VAR_FIELD: 'Campo variable',
            CUSTOM_FIELD: 'tiene el campo variable {{field}} cuyo valor es {{value}}',
            COLLECTOR_IDS: 'tiene el/los perfil/es de cobro: {{collectors}}',
            PORTFOLIO_IDS: 'se ha seleccionado la(s) cartera(s): {{portfolios}}',
            CUSTOMER_CASE_PENDING_AMOUNT:
              'el importe pendiente es entre {{minAmount}} {{minCurrency}} y {{maxAmount}} {{maxCurrency}}',
            CUSTOMER_CASE_OVERDUE_DAYS:
              'la antigüedad de la deuda es entre {{minDays}} días y {{maxDays}} días',
            CUSTOMER_CASE_NUMBER_OF_PAYABLE_OPERATIONS:
              'el número de operaciones es entre {{minOperations}} y {{maxOperations}}',
            CUSTOMER_AGE: 'la edad del cliente está entre {{minAge}} años y {{maxAge}} años',
            CUSTOMER_IS_COMPANY: 'el titular es {{ownership}}',
            CUSTOMER_GENDER: 'el género es {{genders}}',
            DEFAULT: '{{type}}: {{value}}',
            START_FILLING: 'Empieza a rellenar el formulario para ver la info',
            CONDITIONAL: 'Y',
            INFO_TOOLTIP_VAR_FIELD:
              'Campo tipo CustomField dominio del cliente definido en el fichero de importación',
            VALIDATION: {
              MAX_FIELD_REQUIRED:
                'El campo máximo es obligatorio si el campo mínimo tiene un valor.',
              MIN_FIELD_REQUIRED:
                'El campo mínimo es obligatorio si el campo máximo tiene un valor.',
              SAME_VALUE_NOT_ALLOWED: 'No puede ser el mismo valor.',
              MIN_GREATER_THAN_MAX: 'El valor mínimo no puede ser mayor que el valor máximo.',
              MAX_LESS_THAN_MIN: 'El valor máximo no puede ser menor que el valor mínimo.',
              BOTH_FIELDS_FILLED: 'Los dos campos deben estar llenos',
            },
          },
          TOAST: {
            ERROR: {
              TITLE: 'Error',
              MESSAGE: 'Revisa la información del segmento',
            },
            SUCCESS: {
              TITLE: 'Segmento creado',
              MESSAGE: 'El segmento {{name}} se ha creado correctamente',
            },
          },
          SUCCESS: {
            TITLE: 'Campaña Actualizada',
            MESSAGE: 'La campaña se ha actualizado correctamente.',
          },
          ERROR: {
            TITLE: 'Error al Actualizar',
            MESSAGE: 'No se ha podido actualizar la campaña.',
          },
          EDIT: {
            HEADER: 'Editar Información de la Campaña',
          },
          SELECT_SEGMENT: 'Selecciona al menos un segmento',
          NO_OPTIONS: 'No hay opciones de segmentación',
          LOADING_SEGMENTS: 'Cargando segmentos',
          EDIT_SEGMENTS: 'Editar segmentos',
        },
        TYPE: {
          PILL: 'Píldora',
          DRIP: 'Continua',
        },
        STATUS: {
          ACTIVE: 'activa',
          PAUSED: 'pausada',
          DRAFT: 'borrador',
          PUBLISHED: 'publicada',
          UNPUBLISHED: 'archivada',
          NO_WORKFLOW: 'Recordatorio o link directo',
        },
        GENERIC_INFO: {
          NO_NAME: 'Nombre no disponible',
          EDIT_INFORMATION: 'Editar información',
          NO_TRIGGER: 'Sin disparadores',
          START_DAYS: '{{days}} días desde el inicio',
          FINISH_DAYS: '{{days}} días',
          NO_PHASE: 'Sin fase',
          EDIT_CAMPAIGN_INFORMATION: 'Editar información de la campaña',
          ENTER_CRITERION: 'Criterio de entrada de la campaña',
          ENTER_CRITERIA: {
            SAVE_CRITERIA: 'Guardar criterios de entrada',
            TOOLTIP_EDIT: 'Editar criterios de entrada',
            PAYMENT_PROFILES: 'Perfiles de cobro',
            NO_PAYMENT_PROFILES: 'No hay perfiles de cobro disponibles.',
            ACTIVE_CASES: 'Expedientes activos: {{caseCount}}',
            OR: 'O bien,',
            ADDITIONALLY: 'Además',
            SEGMENTS: 'Segmentos',
            NO_SEGMENTS: 'No hay segmentos disponibles.',
            FILTERS: 'Filtros: {{filterCount}}',
            CONDITION_NAME: '{{conditionName}}',
            CONDITION_VALUE: '{{conditionValue}}',
            VIEW_COLLECTOR: 'Ver otros perfiles de cobro',
            HIDDE_COLLECTOR: 'Ocultar perfiles de cobro',
            HIDDE_SEGMENTS: 'Ocultar segmentos',
            VIEW_SEGMENTS: 'Ver otros segmentos',
            ACTIVE_PROFILE: 'Perfil activo',
            ACTIVE_PROFILES: 'Perfil de cobro activos',
            ACTIVE_PROFILES_TOOLTIP:
              'Los expedientes que cumplan con los criterios de entrada de estos perfiles de cobro se incorporarán automáticamente a la campaña y serán registrados como expedientes activos',
            DISCARDED_PROFILES: 'Perfil de cobro descartados',
            DISCARDED_PROFILES_TOOLTIP:
              'No entrarán nuevos expedientes en estos perfiles de cobro. Seguirán visibles mientras haya expedientes activos en campaña y se ocultarán automáticamente cuando todos finalicen.',
          },
          TYPE: {
            PILL: 'Campaña tipo Píldora',
            CONTINUOUS: 'Campaña tipo Contínua',
            PILL_SIMPLE: 'Píldora',
            DRIP_SIMPLE: 'Contínua',
          },
          INPUTS: {
            SMS_COUNT: 'Recuento de SMS',
            EMAIL_COUNT: 'Recuento de Emails',
            APPROX_DURATION: 'Duración aprox.',
            NUMBER_NODES: 'Número de nodos',
            STATUS: 'Estado',
            TYPE: 'Tipo de campaña',
            ALIAS: 'Alias',
            ALIAS_PLACEHOLDER: 'Introduce el alias (opcional)',
            ALIAS_TOOLTIP:
              'El campo ALIAS es opcional y se utiliza para asignar un identificador único a la campaña.\n\nLos caracteres que se admiten son:\na b c d e f g h i j k l m n o p q r s t u v w x y z\nA B C D E F G H I J K L M N O P Q R S T U V W X Y Z\n0 1 2 3 4 5 6 7 8 9 - _ . ~\n\nNo se permiten espacios.',
            NAME: {
              LABEL: 'Nombre de la campaña',
              PLACEHOLDER: 'Nombre de la campaña',
            },
            PHASES: {
              LABEL: 'Fase',
              PLACEHOLDER: 'Selecciona una fase',
            },
            COLLECTORS: {
              LABEL: 'Perfiles de cobro',
              PLACEHOLDER: 'Selecciona perfiles de cobro',
            },
            START: {
              LABEL: 'Inicio de fase',
              ADDON: 'días',
            },
            FINISH: {
              LABEL: 'Fin de fase',
              ADDON: 'días',
            },
            TRIGGERS: {
              LABEL: 'Comportamiento',
              PLACEHOLDER: 'Selecciona un evento',
            },
          },
          ERRORS: {
            PHASE_START_TOO_EARLY:
              'El valor de Inicio no puede ser menor que el inicio más temprano permitido por las fases configuradas.',
            PHASE_END_TOO_LATE:
              'El valor de Fin no puede ser mayor que el fin más tardío permitido por las fases configuradas.',
            SAME_PHASE_VALUE: 'Los valores no pueden ser el mismo.',
            RANGE_INVALID: 'El valor Inicio no puede ser mayor que el valor Fin.',
          },
          BUTTONS: {
            SAVE: 'Guardar cambios',
          },
          TOAST: {
            SUCCESS: {
              UPDATED: {
                TITLE: 'Campaña actualizada',
                MESSAGE: 'La campaña se ha actualizado correctamente',
              },
            },
            ERROR: {
              UPDATED: {
                TITLE: 'Error por la campaña actualizada',
                MESSAGE: 'No se ha podido actualizar la campaña',
              },
            },
          },
          MODAL: {
            HEADER: 'Editar información de la campaña',
            SUBTITLE: 'Nombre, alias y fase de la campaña.',
          },
          PHASE_RANGE: 'Rango de la fase',
        },
        NEW: 'Nueva campaña',
        CLONE: {
          ACTIONS: {
            CLONE: 'Clonar',
          },
          FORM: {
            NAME: 'NUEVO NOMBRE',
          },
        },
        ELEMENTS: {
          NODES: {
            ACTIVE_CASES: {
              N_CASES: '📁 → {{count}} expedientes',
              NO_CASES: 'Sin expedientes',
            },
            TYPES: {
              EVENT: 'Evento',
              ACTIVITY: 'Actividad',
              CONDITION: 'Condición',
            },
            NAMING: {
              waitDays: 'Esperar días',
              waitDayOfWeek: 'Esperar días semana',
              waitDaysForDueDate: 'Esperar vencimiento',
              waitDayOfMonth: 'Esperar días mes',
              sendSMS: 'SMS',
              sendCertifiedSMS: 'SMS certificado',
              sendEmail: 'Email',
              sendCertifiedEmail: 'Email certificado',
              paylinkNotificationStatus: 'Sí (notificación)',
              customerCaseSegments: 'Sí (segmento)',
              offerPartialPayment: 'Pago parcial',
              offerPaymentAgreement: 'Acuerdo de pago',
              createLegalClaim: 'Demanda legal',
              createMasc: 'MASC',
              assignCampaign: 'Asignar a campaña',
              makeOutboundCall: 'Llamada saliente',
              startChatConversation: 'Iniciar chat',
              start: 'Inicio',
              experiment: 'Experimento',
              end: 'Fin',
              email_plus: 'Correo electrónico +',
              email_plus_certified: 'Correo electrónico certificado +',
              sms_plus_certified: 'SMS certificado +',
              sms_plus: 'SMS +',
            },
            PARAMETERS: {
              RETRY_TIME_RANGES_LABEL: 'Franjas horarias para reintentos:',
              MESSAGE_INFO:
                ' Si se selecciona un Día de expiración, este tendrá prioridad sobre el números de días de expiración. Para usar el campo "el paylink expira en (dias)"\n' +
                '               , deja el campo de Día de expiración vacío.',
              INFORMATION: 'Información',
              INITIAL_TIME_ERROR: 'La hora inicial debe ser menor que la final.',
              OVERLAP_ERROR: 'Esta franja se superpone con otra franja seleccionada.',

              ACTIONS_BY_RESPONSE: 'Acciones según respuesta:',
              ADD_AUTOMATIC_RULE: 'Añadir regla automática',

              SITUATION_LABEL: 'Si ocurre esta situación:',
              SITUATION_PLACEHOLDER: 'Situación (texto)',

              SYSTEM_ACTION_LABEL: 'El sistema realizará esta acción:',
              SELECT_ACTION_PLACEHOLDER: 'Seleccione acción',
              INFOTOOLTIP_ADD_VALUES:
                'Utiliza la tecla enter o coma para añadir los valores al campo',
              SELECT_CAMPAIGNS_LABEL: 'Seleccione campañas:',
              SELECT_CAMPAIGN_PLACEHOLDER: 'Seleccione campaña',
              RETRY: 'Reintento {{number}}',

              CONTACT_ALL_LABEL: '¿Contactar a todos los números registrados en el expediente?',
              RETRY_FAIL_CALLS_LABEL: '¿Quieres reintentar llamadas fallidas?',
              SAVE_RULE: 'Guardar regla',
              TARGET_NODE: 'Nodo Objetivo',
              SELECT_NODE: 'Selecciona un nodo objetivo',
              SUBJECT: 'Asunto',
              PRE_HEADER: 'Pre Header',
              MESSAGE: 'Mensaje',
              BUTTON_TEXT: 'Texto del botón',
              COPY_MESSAGE: 'Copiar mensaje',
              PARTIAL_PAYMENT_PROPOSAL:
                'Se enviará una propuesta de pago parcial por valor mínimo de',
              EXPIRATION_DAYS: 'Caducará en',
              NUMBER_OF_INSTALLMENTS: 'Se enviará una propuesta de acuerdo de pago de',
              INSTALLMENTS: 'cuotas',
              FROM_NOW: ' a partir del momento de envío.',
              DAYS_UNTIL: 'Días hasta la expiración:',
              NUMBER_INSTALMENTS: 'Número de cuotas:',
              INSTALMENTS_IN: 'cuotas en',
              MINIMUM_AMOUNT: 'Monto mínimo:',
              MINIMUM_PERCENTAGE: 'Porcentaje mínimo:',
              EXPERIMENT:
                'El <b>{{percentage}} %</b> de los expedientes seguirá la rama ✔ para el experimento, mientras que el resto seguirá la rama ✘',
              CUSTOMER_PAYMENT_DATES:
                'El cliente podrá ver las fechas exactas de cada cobro antes del primer pago.',
              CONFIGURATION: 'Configuración',
              SELECT_TARGET_NODE: 'Selecciona un nodo objetivo',
              NODE_OBJECTIVE: 'Nodo objetivo',
              EXACT_DAY:
                'El cliente podrá ver las fechas exactas de cada cobro antes del primer pago.',
              FROM_DAY:
                'a partir del momento de envío. Se cargará la primera cuota en el momento del primer pago, las\n' +
                '                     cuotas restantes se cargaran automáticamente cada mes durante',
              FEE: 'cuotas.',
              EMAIL: {
                SUBJECT: 'Asunto',
                PRE_HEADER: 'Pre Header',
                MESSAGE: 'Mensaje',
              },
              SMS: {
                MESSAGE: 'Mensaje',
              },
              OFFER_PARTIAL_PAYMENT: {
                INFO: `Se enviará una propuesta de pago parcial por valor mínimo de
                      <b>{{amount}}</b> EUR. Caducará en <b>{{days}}</b> días a partir del momento de envío.`,
                INFO_CONTENT: `Se enviará una propuesta de pago parcial por valor mínimo de
                      <b>{{amount}}</b> EUR. Caducará en <b>{{days}}</b> días a partir del momento de envío.`,
              },
              OFFER_PAYMENT_AGREEMENT: {
                INFO: `Se enviará una propuesta de acuerdo de pago de
                      <b>{{instalments}}</b> cuotas. Caducará en
                      <b>{{days}}</b> {{days === 1 ? 'día' : 'días'}} a partir del momento de envío.
                      Se cargará la primera cuota en el momento del primer pago,
                      las cuotas restantes se cargarán automáticamente cada mes durante
                      <b>{{instalments}}</b> {{instalments === 1 ? 'mes' : 'meses'}}.
                      El cliente podrá ver las fechas exactas de cada cobro antes del primer pago.`,
              },
              PART_DAY: {
                OF: 'Envío durante: ',
                MORNING: 'Mañana',
                EVENING: 'Noche',
                FULL_DAY: 'Todo el día',
              },
              KEYS: {
                name: 'Nombre',
                waitDays: 'Días de espera',
                partDay: 'Parte del día',
                dayOfWeek: 'Día de la semana',
                dayOfMonth: 'Día del mes',
                daysForDueDate: 'Días para la fecha de vencimiento',
                copyIds: 'Copiar IDs',
                copyId: 'Copiar ID',
                targetNodeId: 'ID del nodo objetivo',
                statuses: 'Estados',
              },
              NAME: {
                start: 'Inicio',
                end: 'Fin',
                waitDays: 'Días de espera: ',
                waitDayOfWeek: 'Día de la semana: ',
                waitDayOfMonth: 'Día del mes: ',
                waitDaysForDueDate: 'Días para la fecha de vencimiento: ',
                sendSMS: 'Enviar SMS',
                sendEmail: 'Enviar Email',
                sendCertifiedSMS: 'Enviar SMS certificado',
                sendCertifiedEmail: 'Enviar Email certificado',
                paylinkNotificationStatus: 'Estado de la notificación',
                assignCampaign: 'Asignar campaña',
              },
              ACTIONS: {
                LABEL: 'Acciones según respuesta:',
                ADD_RULE: 'Añadir regla automática',
                CONDITION_LABEL: 'Si ocurre esta situación:',
                CONDITION_PLACEHOLDER: 'Situación (texto)',
                ACTION_LABEL: 'El sistema realizará esta acción:',
                ACTION_PLACEHOLDER: 'Seleccione acción',
                SELECT_CAMPAIGN_LABEL: 'Seleccione campañas:',
                SELECT_CAMPAIGN_PLACEHOLDER: 'Seleccione campaña',
                SAVE_RULE: 'Guardar regla',
                WHEN_OCCURS: 'Cuando ocurra:',
                SYSTEM_WILL_DO: 'El sistema hará:',
              },
            },
          },
        },
        LIST: {
          TITLE: 'Listado de campañas',
          NEW: 'Nueva campaña',
          EDIT: 'Editar campaña',
          WORKFLOW_TYPES: {
            DRIP: 'Campaña Contínua',
            PILL: 'Campaña Píldora',
          },
          NO_BEHAVIOUR: 'Sin comportamiento',
          NO_ALIAS: 'Sin alias',
          VIEW_LAST_EXECUTIONS: 'Ver últimas ejecuciones',
          VIEW_FILTERS: 'Ver filtros aplicados',
          NO_FILTERS: 'Sin filtros',
          TABLE: {
            NO_CAMPAIGNS_MESSAGE: 'No existen campañas actualmente',
            TYPES: {
              ACTIVE: 'Activas',
              DRAFT: 'Borrador',
              DRAFTS: 'Borradores',
              UNPUBLISHED: 'Archivadas',
              PUBLISHED: 'Publicadas',
              PILLS: 'Píldoras',
            },
            TOOLTIPS: {
              SHOW_COLLECTORS: 'Ver perfiles de cobro',
            },
            HEADERS_PILLS: {
              NAME: 'NOMBRE DE LA PÍLDORA',
              ALIAS: 'ALIAS',
              PILLS_SEND: 'PÍLDORAS ENVIADAS',
              BEHAVIOUR: 'COMPORTAMIENTO',
              COLLECTORS: 'PERFIL DE COBRO',
              ACTIVE_CASES: 'CASOS ACTIVOS',
              CUSTOMER_CASES_COUNT: 'EXPEDIENTES ACTIVOS',
              ACTIONS: 'ACCIONES',
              SUBHEADERS: {
                CUSTOMER_CASES_NOTIFIED: 'EXPEDIENTES IMPACTADOS',
                TOOLTIPS: {
                  CREATED:
                    'Las instancias están siendo creandas, este proceso puede tardar unos minutos.',
                },
                STATUS: 'ESTADO',
                TIME: 'FECHA Y HORA',
                CLIENT_NAME: 'NOMBRE DEL CLIENTE',
                N_INSTANCES: 'Nº DE EXPEDIENTES',
              },
            },
            HEADERS: {
              PRIORITY: 'PRIORIDAD',
              CAMPAIGN_NAME: 'NOMBRE DE LA CAMPAÑA',
              ALIAS: 'ALIAS',
              COLLECTORS: 'PERFILES DE COBRO',
              SEGMENTS: 'SEGMENTOS',
              ACTIVE_CASES: 'EXPEDIENTES ACTIVOS',
              STATUS: 'ESTADO',
              CUSTOMER_CASES_COUNT: 'EXPEDIENTES ACTIVOS',
              ACTIONS: 'ACCIONES',
            },
            SEGMENTS: {
              NONE: 'Sin segmentos seleccionados',
            },
            MORE: {
              PRIORITY_TOOLTIP:
                'En el caso de que varias campañas continuas compartan segmentos la prioridad decidirá a qué campaña se asignan los nuevos expedientes. Si las campañas no comparten segmentos la prioridad no tiene efecto.',
              NO_RESULTS: 'No hay campañas que mostrar',
              NO_PILLS_RESULTS: 'No hay píldoras que mostrar',
              NO_PILLS_SUBTABLE_RESULTS: 'No hay instancias que mostrar',
            },
            EMPTY: {
              SUBTITLE: 'Prueba ajustando los filtros o crea una nueva campaña.',
            },
          },
          EMPTY: {
            SUBTITLE: 'Prueba ajustando los filtros o crea una nueva campaña.',
          },
        },
        WIZARD: {
          GENERAL_DATA: 'Datos generales',
          CAMPAIGN_NAMING: 'Nombre campaña',
          COLLECTORS: 'Perfiles de cobro',
          CAMPAIGN_TYPE: 'Tipo de campaña',
          PURPOSE: 'Propósito',
          SUCCESS: 'Éxito',
          TRIGGERS: 'Comportamiento',
          PHASE_ACTIONS: 'Acción en fases',
          PHASE_ACTIONS_DESCRIPTION: '{{phaseStart}} días a {{phaseEnd}} días',
          SEGMENTATION: 'Segmentación',
          NODES: 'Nodos',
          NOT_APPLICABLE: 'No aplica',
          WARNINGS_BEFORE_SAVING: 'Antes de guardar, ten en cuenta que:',
          NODE_CONFIGURATION_ERRORS: 'Hay errores en la configuración de los nodos',
          SURE_TO_SAVE_CHANGES: '¿Seguro que quieres guardar los cambios así?',
          ERRORS_TO_PUBLISH: 'Hay que solucionar los siguientes errores para publicar la campaña:',
          ERROR_LIST: 'Hay los siguientes errores:',
          SAVE_DRAFT: 'Guardar Borrador',
          SAVE_CHANGES_WARNING: 'Guardar cambios con advertencia',
          NAME: 'Nombre de la campaña',
          CAMPAIGN_NAME: 'Ingrese el nombre de la campaña',
          ALIAS: 'Alias',
          ALIAS_PLACEHOLDER: 'Introduce el alias (opcional)',
          ALIAS_TOOLTIP:
            'El campo ALIAS es opcional y se utiliza para asignar un identificador único a la campaña.\n\nLos caracteres que se admiten son:\na b c d e f g h i j k l m n o p q r s t u v w x y z\nA B C D E F G H I J K L M N O P Q R S T U V W X Y Z\n0 1 2 3 4 5 6 7 8 9 - _ . ~\n\nNo se permiten espacios.',
          PROFILE: 'Perfil de cobro',
          ACTION_EVENT: 'Evento de acción',
          SELECT_EVENT: 'Selecciona un evento',
          PHASE: 'Fase',
          SELECT_PHASE: 'Selecciona una fase',
          PHASE_START: 'Inicio de fase',
          LOADING_SEGMENTS: 'Cargando segmentos',
          SELECT_OR_CREATE_SEGMENT: 'Selecciona un segmento o crea uno nuevo.',
          CONTINUE: 'Continuar',
          CREATE_NEW_SEGMENT: 'Crear un nuevo segmento',
          OR: 'O',
          INCLUDE: 'Incluye:',
          SEGMENTS_SELECTED: 'Segmentos seleccionados',
          INFO_SEGMENTS:
            'Un registro solo será incluido si cumple todos los criterios de al menos uno de estos segmentos. No es necesario cumplir más de un segmento para ser parte de la campaña.',
          CREATED_SEGMENT: 'Segmento creado',
          INCLUDE_SEGMENT: 'Incluir segmentos',
          CREATED_SEGMENT_CORRECTLY: 'El segmento {{name}}} se ha creado correctamente',
          PHASE_END: 'Fin de fase',
          BEHAVIOR: 'Comportamiento',
          ACTION: {
            BACK: 'Atrás',
            NEXT: 'Siguiente',
          },
          ERRORS: {
            PHASE_START_TOO_EARLY:
              'El valor de Inicio no puede ser menor que el inicio más temprano permitido por las fases configuradas.',
            PHASE_END_TOO_LATE:
              'El valor de Fin no puede ser mayor que el fin más tardío permitido por las fases configuradas.',
            SAME_PHASE_VALUE: 'Los valores no pueden ser el mismo.',
            RANGE_INVALID: 'El valor Inicio no puede ser mayor que el valor Fin.',
          },
        },
        MONITORING: {
          TITLE: 'Compartir Datos ',
          //...
        },
        EDIT: {
          SUCCESS: 'Éxito!',
          PRIORITY_CHANGED: 'El orden ha cambiado',
          CAMPAIGN_STATE_CHANGED: 'El estado ha cambiado a estado',
          ERROR: 'Error',
          PAUSED: 'Pausado',
          PUBLISHED: 'Publicado',
          UNPUBLISHED: 'Archivado',
          CAMPAIGN_PAUSE: 'La campaña ha sido pausada',
          COLLECTOR_ACTION_SUCCESS: 'El perfil de cobro ha sido cambiado de estado correctamente',
          CAMPAIGN_UNPUBLISHED: 'La campaña ha sido archivada',
          WORKFLOW_DUPLICATE_TRIGGER: 'Ya existe otro flujo con el mismo disparador: {{trigger}}',
          CAMPAIGN_PUBLISHED: 'La campaña ha sido publicada',
          CAMPAIGN_UPDATED: 'Campaña actualizada',
          CAMPAIGN_BEEN_UPDATED: 'Campaña actualizada',
          ERROR_SHOWN: 'Ocurrió un error inesperado',
          RESUME_COLLECTOR_ERROR: 'No se pudo reanudar el collector',
          RESUME_COLLECTOR_SUCCESS: 'El perfil de cobro se reanudó correctamente',
          PAUSE_COLLECTOR_ERROR: 'No se pudo pausar el collector',
          PAUSE_COLLECTOR_SUCCESS: 'El perfil de cobro se pausó correctamente',
          UNPUBLISH_COLLECTOR_ERROR: 'No se pudo archivar el collector',
          UNPUBLISH_COLLECTOR_SUCCESS: 'El perfil de cobro se archivó correctamente',
          TITLE: 'Editar campaña',
          DELETE_DRAFT_MESSAGE:
            '¿Estás seguro quieres eliminar el borrador? En eliminar la campaña, esta dejará de ser visible en toda la aplicación.',
          DELETE_DRAFT_HEADER: 'Eliminar borrador {{campaignName}}',
          DELETE_DRAFT_ACCEPT_LABEL: 'Eliminar',
          DELETE_DRAFT_ACCEPT_ICON: 'pi pi-trash',
          DELETE_DRAFT_ACCEPT_BUTTON_CLASS: 'p-button-danger',
          DELETE_DRAFT_REJECT_BUTTON_CLASS: 'p-button-text',
          DELETE_DRAFT_SUCCESS_MESSAGE: 'Campaña {{campaignName}} eliminada correctamente',
          DELETE_DRAFT_ERROR_MESSAGE:
            'La campaña {{campaignName}} no puede ser eliminada porque tiene expedientes notificándose',
          CLONE_CAMPAIGN_MESSAGE: 'Campaña {{campaignName}} clonada',
          CLONE_CAMPAIGN_HEADER: '¿Quieres clonar la campaña "{{campaignName}}"?',
          CLONE_CAMPAIGN_SUCCESS_MESSAGE: 'Campaña {{campaignName}} clonada correctamente',
        },
        COPIES: {
          TITLE: 'Plantillas',
          ELEMENTS: {},
          ADD: {
            TITLE: 'Crear plantilla',
            //...
          },
          EDIT: {
            TITLE: 'Editar Plantilla',
            TEMPLATE_UPDATED: '{{name}} ha sido editada exitosamente',
            SUCCESS_MESSAGE: '¡Éxito!',
            SAVE_TEMPLATE: 'Guardar Plantilla',
            SAVE_AUTOTEMPLATE: 'Guardar Plantilla',
            QUESTION_EDIT:
              '¿Estás seguro de que deseas guardar la plantilla? Recuerda que esta plantilla enviará {{number}} SMS a cada cliente.',
          },
        },
      },
      COPIES: {
        TITLE: 'Plantillas',
        ELEMENTS: {},
        ADD: {
          TITLE: 'Crear plantilla',
          //...
        },
        EDIT: {
          TITLE: 'Editar Plantilla',
          TEMPLATE_UPDATED: '{{name}} ha sido editada exitosamente',
          SUCCESS_MESSAGE: '¡Éxito!',
          SAVE_TEMPLATE: 'Guardar Plantilla',
          SAVE_AUTOTEMPLATE: 'Guardar Plantilla',
          QUESTION_EDIT:
            '¿Estás seguro de que deseas guardar la plantilla? Recuerda que esta plantilla enviará {{number}} SMS a cada cliente.',
        },
      },

      CUSTOMERS: {
        TITLE: 'Clientes',
        ELEMENTS: {},
        MODAL: {
          DELETE_CONFIRM_HEADER: '<p class="font-normal">Eliminar <b>{{count}}</b> clientes</p>',
          DELETE_CONFIRM_MESSAGE: '¿Seguro que quieres eliminar {{count}} clientes?',
          DELETE_SUCCESS: '{{count}} clientes eliminados',
          DELETE_FAILED: 'Hubo un error al eliminar a {{count}} clientes',
          DELETE_SINGLE_CONFIRM_HEADER:
            '<p class="font-normal">Eliminar cliente: <b>{{longName}} ({{externalId}})</b></p>',
          DELETE_SINGLE_CONFIRM_MESSAGE: '¿Seguro que quieres eliminar a {{longName}}?',
          DELETE_SINGLE_SUCCESS: '{{longName}} eliminado',
          DELETE_SINGLE_FAILED: 'Hubo un error al eliminar a {{longName}}',
          REJECT_LABEL: 'No',
          ACCEPT_LABEL: 'Sí',
          SELECT_ALL: 'Seleccionar todos los clientes',
          DELETE_SELECTION: 'Eliminar selección',
        },
        MASSIVE_SELECTION: {
          SELECTED: {
            SINGLE: 'Has seleccionado',
            CUSTOMERS: 'clientes',
            ALL_SELECTED: 'Seleccionar todos los {{ totalResults }} clientes',
          },
          MASSIVE_SELECTED: {
            DELETE: 'Eliminar selección masiva',
          },
        },
        PAGES: {
          SECTIONS: {
            INFO: 'Información',
            CONTACTS: 'Contactos',
            EMAILS: 'Correos electrónicos',
            PHONE_LIST: 'Lista de teléfonos',
            EMAIL_LIST: 'Lista de correos',
            NO_PHONE_CONTACTS: 'Este usuario no tiene teléfonos de contacto',
            NO_EMAIL_CONTACTS: 'Este usuario no tiene correos de contacto',
            COPY_TEXT: 'Copiar texto',
            NOTIFYING: 'Notificando',
            BLACKLISTED: 'En la lista negra',
            LOCALIZATION: 'Localización',
            TOOLTIP_EDIT_INFO: 'Editar información del cliente',
            TOOLTIP_CREATE_CONTACT: 'Crear contacto',
            TOOLTIP_EDIT_CONTACT: 'Editar contacto',
            TOOLTIP_EDIT_LOCALIZATION: 'Editar localización',
            TOOLTIP_COPY: 'Copiar texto',
            NAME: 'Nombre y apellidos',
            DNI: 'DNI',
            OWNERSHIP: 'Propiedad',
            SHORT_NAME: 'Nombre de pila',
            BIRTH_DATE: 'Fecha de nacimiento',
            GENDER: 'Género',
            CONTACT_LANGUAGE: 'Idioma de contacto',
            BUSINESS: 'Empresa',
            PRIVATE: 'Privado',
            COPIED: 'Copiado',
            COPIED_SUCCESSFULLY: 'Texto copiado correctamente',
            ADDRESS: 'Dirección',
            ZIP_CODE: 'Código postal',
            CITY: 'Ciudad',
            COUNTRY: 'País',
            TOAST_CONTACT: 'Contacto creado',
            TOAST_LIST_CONTACT: 'Lista de contactos actualizada',
            TOAST_LOCALIZATION: '¡Localización de {{name}} actualizada!',
            FORMS: {
              TITLE_INFO: 'Editar información',
              TITLE_ADD_NEW_CONTACT: 'Agregar nuevo contacto',
              TITLE_EDIT_CONTACT: 'Editar contactos',
              TITLE_EDIT_LOCALIZATION: 'Editar localización',
              ID_CLIENT: 'ID Cliente',
              SHORT_NAME: 'Nombre de pila (sin apellidos)',
              FULL_NAME: 'Nombre y apellidos',
              NIE: 'DNI/NIE/CIF',
              OWNERSHIP: 'DNI/NIE/CIF',
              BIRTH_DATE: 'Fecha de nacimiento',
              CONTACT_LANGUAGE: 'Idioma de contacto',
              GENDER: 'Género',
              NEW_EMAIL: 'Nuevo correo electrónico',
              EDIT: 'Editar info cliente',
              TYPE: 'Tipo',
              NEW_TELEPHONE: 'Nuevo número de teléfono',
              CREATE_CONTACT: 'Crear contacto',
              DIRECTION: 'Dirección',
              ZIP_CODE: 'Código postal',
              TOWN: 'Población',
              COUNTRY: 'País',
              TOOLTIP_SHORTNAME:
                'Se utiliza para comunicaciones en que se quiera ser más informal, o en canales en los que se quiera minimizar el número de caracteres utilizado.',
              TOOLTIP_LONGNAME:
                'Se utiliza por defecto en las comunicaciones y se muestra en la página de pagos, listados de la plataforma, etc.',
            },
          },
          LIST: {
            TITLE: 'Listado de clientes',
          },
          CUSTOMER_LIST: {
            TITLE: 'Listado de clientes',
            NEW: 'Nuevo cliente',
            EDIT: 'Editar cliente',
            DELETE_BUTTON: 'Eliminar {{selected}}',
            COPY_EXTERNAL_ID: 'Copia id externo del cliente',
            EMPTY_STATE: {
              TITLE: 'Sin resultados',
              DESCRIPTION: 'No se encontraron clientes con los filtros aplicados.',
              CLEAR_FILTERS: 'Limpiar filtros',
            },
            FORM: {
              CALL_TIME: 'Fecha de llamada',
              CONVERSATIONS_RESULTS: 'Resultados de conversación',
              NIF: 'DNI/NIE/NIF',
              EXTERNAL_ID: 'Id cliente',
              COLLECTOR: 'PERFIL DE COBRO',
              SEARCH: 'BÚSQUEDA',
              PHONES: 'Teléfono de cliente',
              NAME: 'Nombre de cliente',
              NO_EXIST_CUSTOMERS: 'No existen clientes para esta búsqueda',
              SEARCH_TOOLTIP: `Busca entre ID Cliente, Nombre completo, DNI y datos de contacto (teléfono y correo electrónico) resultados parecidos.

              También puedes buscar varios elementos separados por coma.

              Ejemplo: María Garcia, Antonio Rodriguez, Carmen Gonzalez`,
            },
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE Y APELLIDO DE CLIENTE',
                DNI: 'DNI/NIE/NIF',
                EXTERNAL_ID: 'ID CLIENTE',
                COLLECTOR: 'PERFIL DE COBRO',
                TOTAL_AMOUNT: 'IMPORTE TOTAL',
                PENDING_AMOUNT: 'IMPORTE PENDIENTE',
                DATE: 'FECHA DE ACTUALIZACIÓN',
                ACTIONS: 'ACCIONES',
              },
              MORE: {
                NO_RESULTS: 'No hay clientes que mostrar',
                NO_ID: 'Sin info de ID',
                NO_PENDING: 'Sin importe pendiente',
              },
              PAGINATION: {
                TOTAL_RESULTS: 'Resultados totales',
                RESULTS_PER_PAGE: 'Resultados por página',
              },
            },
          },
          CUSTOMER_FILE: {
            TITLE: 'Detalle cliente',
            TABS: {
              INFO: 'Info',
              CASES: 'Expedientes',
              PAYMENTS: 'Pagos',
              ACTIVITIES: 'Actividades',
            },
            SECTIONS: {
              SUPERIOR_INFO: {
                TOTAL_AMOUNT: 'Importe original',
                NO_PAYMENT_PENDING: '✔ Sin pagos pendientes',
                CONTACTABILITY_TOOLTIP:
                  'Se analiza la efectividad de entrega de mensajes por SMS y correos para prever si el contacto recibirá los futuros mensajes, siendo -10 no contactable y +10 alta contactabilidad',
                TOTAL_AMOUNT_TOOLTIP:
                  'Suma total de los importes pendiente de las operaciones asociadas a este cliente',
                PENDING_AMOUNT: 'Importe pendiente',
                PENDING_AMOUNT_TOOLTIP:
                  'Suma de los importes de las operaciones originalment registradas para el cliente.',
                AVERAGE_PAYMENT_TIME: 'Tiempo medio de pago',
                AVERAGE_PAYMENT_TIME_TOOLTIP:
                  'Tiempo medio entre la fecha de vencimiento y la fecha de pago de las operaciones asociadas al cliente.',
                CONTACTABILITY: 'Contactabilidad',
                NO_PAYMENTS: 'No hay pagos',
              },
              CONTACT: {
                NOTIFICABLE_PHONE: 'Este teléfono está siendo notificado',
                NOTIFICABLE_EMAIL: 'Este email está siendo notificado',
              },
              CASES: {
                TITLE: 'Expedientes',
                NO_CASES: 'No hay expedientes relacionados que mostrar',
                NO_CASES_TITLE: 'Este cliente no tiene expedientes asignados',
                NO_CASES_SUBTITLE: 'Los expedientes aparecerán aquí una vez creados y asignados',
                NO_OPERATIONS: 'No hay operaciones que mostrar',
                PARTIAL_PAYMENT: 'Pago parcial',
                UNASSIGN_CAMPAIGN: {
                  MENU_LABEL: 'Desasignar campaña',
                  DIALOG_HEADER: 'Desasignar expediente de campaña',
                  NO_ACTIVE_CAMPAIGN: 'Sin campaña activa',
                  MODAL: {
                    SUBTITLE:
                      'Selecciona las campañas de las que quieres desasignar este expediente.',
                    ACTIVE_CHIP: 'Activa',
                    NODE_POSITION: 'Posición del expediente:',
                    STARTED_AT: 'Iniciado:',
                    UNASSIGN_BTN: 'Desasignar',
                    CONFIRM_ONE:
                      '¿Desasignar el expediente de 1 campaña? Esta acción no se puede deshacer.',
                    CONFIRM_MANY:
                      '¿Desasignar el expediente de {{count}} campañas? Esta acción no se puede deshacer.',
                    ACCEPT_LABEL: 'Sí, desasignar',
                    SUCCESS: 'Instancia desasignada correctamente.',
                  },
                },
                FORWARD_WORKFLOW: {
                  MENU_LABEL: 'Avanzar nodo',
                  DIALOG_HEADER: 'Avanzar nodo de la campaña',
                  NO_SCHEDULER: 'Sin nodos pendientes de scheduler',
                  MODAL: {
                    SUBTITLE:
                      'Selecciona las campañas para que los expedientes avanzen al siguiente nodo.',
                    NODE_ID: 'ID del nodo:',
                    STARTED_AT: 'Iniciado:',
                    NODE_POSITION: 'Posición:',
                    SCHEDULE: 'Programado:',
                    SHOW_CAMPAIGN: 'Mostrar campaña',
                    FORWARD_BTN: 'Avanzar nodo',
                    SELECTION_COUNT: '{{selected}} de {{total}} campañas seleccionadas',
                    SELECT_ALL: 'Seleccionar todas',
                    INFO_BANNER:
                      'Cada expediente avanza dentro de la campaña en la que se encuentra actualmente.',
                    CONFIRM_ONE:
                      '¿Avanzar 1 expediente al siguiente nodo? Se omitirá el tiempo de espera restante.',
                    CONFIRM_MANY:
                      '¿Avanzar {{count}} expedientes al siguiente nodo? Se omitirá el tiempo de espera restante.',
                    ACCEPT_LABEL: 'Sí, avanzar',
                    SUCCESS: 'Expediente avanzado al siguiente nodo correctamente.',
                    OUTBOUND_SEQUENCE: {
                      NEXT_CALL: 'Próxima llamada:',
                      PENDING_ATTEMPTS: 'Reintentos pendientes:',
                    },
                  },
                },
                TABLE: {
                  HEADERS: {
                    STATUS: 'Estado',
                    PORTFOLIO: 'Cartera',
                    COLLECTOR: 'Perfil de cobro',
                    TOTAL_AMOUNT: 'Importe total',
                    PENDING_AMOUNT: 'Importe pendiente',
                    CAMPAIGN: 'Campaña actual',
                    TOOLTIP_CAMPAIGN: 'Campaña contínua actual que ha impactado este expediente',
                  },
                  SUBHEADERS: {
                    STATUS: 'Estado',
                    ID_OPERATION: 'ID operación',
                    TITLE: 'Título',
                    AMOUNT: 'Importe',
                    DUE_DATE: 'Fecha de vencimiento',
                    COLLECTOR: 'Perfil de cobro',
                    ACTIONS: 'Acciones',
                  },
                  TOOLTIP: {
                    PARTIAL_PAYMENT: 'Pago parcial',
                    CHANGE_STATUS: 'Cambiar estado',
                    REGISTER_PAYMENT: 'Registrar pago',
                  },
                },
                META: {
                  PENDING_LABEL: 'Pendiente',
                  TOTAL_LABEL: 'total',
                  SETTLED_LABEL: 'liquidado',
                  CAMPAIGN_LABEL: 'Campaña',
                  NODE_LABEL: 'nodo',
                  IN_CAMPAIGN_SINCE: 'En campaña desde',
                  OPERATIONS_LABEL: 'operaciones',
                  PENDING_OPS_LABEL: 'pendientes',
                  PAID_LABEL: 'Pagado',
                  OPERATIONS_EYEBROW: 'Operaciones',
                  TOTAL_OPERATIONS: 'Total operaciones',
                  COPY_ID_TOOLTIP: 'Copiar ID',
                  COPY_ID_TITLE: 'Copiado',
                  COPY_ID_DETAIL: 'Id {{id}} copiado correctamente',
                  VIEW_CAMPAIGN_TOOLTIP: 'Ver campaña',
                  NO_CAMPAIGN: 'No hay campaña impactada',
                },
              },
              PAYMENTS: {
                TITLE: 'Pagos',
                NO_PAYMENTS: 'No hay pagos relacionados con este cliente.',
                VIEW_OPERATIONS: 'Ver operaciones',
                TABLE_HEADERS: {
                  PAYMENT_DATE: 'Fecha de pago',
                  AMOUNT: 'Cantidad',
                  METHOD: 'Método',
                  OPERATIONS: 'Operaciones',
                },
                OPERATIONS: {
                  ATTRIBUTED_AMOUNT: 'Importe atribuido',
                  OPERATION: 'Operación',
                  CONCEPTS: 'Conceptos',
                  NO_CONCEPTS: 'No hay conceptos disponibles',
                  NO_OPERATIONS: 'No hay operaciones para este pago.',
                },
              },
            },
          },
          ACTIVITIES: {
            ACTIVITY_TITLE: 'Actividades',
            LABEL: {
              LEGEND: 'Claves',
              TYPE_ACTIVITY: 'Tipo de actividades',
              NO_ACTIVITY: 'No hay actividad',
              NO_ACTIVITY_TITLE: 'No existen aún actividades para este cliente',
              NO_ACTIVITY_SUBTITLE: 'Las actividades aparecerán aquí cuando estén disponibles',
              SUBJECT: 'Asunto',
              PRE_HEADER: 'Pre encabezado',
              MESSAGE: 'Mensaje',
              WITH_MESSAGE: 'Con mensaje',
              REMINDER: 'un recordatorio',
              VALID_UNTIL: 'Válido hasta',
              NOTIFICATION: 'Notificación',
              SEND_TO: 'enviado a',
              FROM: 'desde',
              DESTINATION_ERROR: 'Error de destino en la notificación',
              WITH_METHOD_PAYMENT: 'con el método de pago',
              HAS_CALLED: 'Ha sido llamado',
              SHOW_CALL: 'Mostrar llamada',
              VIEW_CONVERSATION: 'Ver conversación',
              CHAT_CONV_COMPLETED: 'completó una conversación de WhatsApp:',
              CHAT_CONV_TYPE_INBOUND: 'Entrante',
              CHAT_CONV_TYPE_OUTBOUND: 'Saliente',
              SHOW_AUDIO_CALL: 'Escuchar llamada',
              HIDE_AUDIO_CALL: 'Cerrar audio',
              SHOW_WITH_CLIENT: 'Llamada con cliente',
              CALL_INIT: 'Llamada iniciada',
              CALL_FINISH: 'Llamada finalizada',
              NO_TRANSCRIPTION: 'No hay transcripción disponible',
              THE_TELEPHONE: 'El teléfono',
              CATALOG: 'ha sido catalogado como',
              BLACKLISTED: 'Este número está en la lista negra, no se puede contactar',
              FEEDBACK_PAGE: 'la página de comentarios',
            },
            LEGENDS_DESCRIPTION: {
              payment_order_created: 'Se ha iniciado un intento de pago',
              payment_order_canceled: 'Ha ocurrido un error en el proceso',
              payment_order_captured: 'Se ha completado el pago',
              feedback_visited: 'Se ha visitado la página de comentarios',
              feedback_sent: 'Se ha enviado un comentario',
              paylink_notification_visited: 'Se ha visitado la página de pago',
              paylink_notification_received: 'Se ha recibido una notificación',
              paylink_notification_sent: 'Se ha enviado una notificación',
              paylink_notification_discarded: 'Notificación descartada',
              paylink_notification_read: 'Se ha leído la notificación',
              paylink_notification_login_visited: 'Se ha completado el inicio de sesión',
              paylink_notification_login_failed: 'Falló el inicio de sesión',
              outbound_call_hung_up: 'Se ha llamado al cliente',
              phone_contact_blacklisted: 'Número de contacto añadido a la lista negra',
              chat_conversation_completed: 'Se ha completado una conversación de WhatsApp',
            },
            EVENT_DESCRIPTION: {
              payment_order_created: 'ha iniciado un intento de pago',
              payment_order_canceled: 'ha cancelado el intento de pago',
              payment_order_captured: 'ha completado un pago',
              payment_order_refund_succeeded: 'ha recibido un reembolso',
              paylink_notification_error: 'ha encontrado un error con la notificación',
              paylink_notification_visited:
                ' ha visitado <b class="text-bluegray-700">la página de pagos</b> ',
              paylink_notification_login_visited: 'ha iniciado sesión',
              paylink_notification_login_failed: 'ha tenido un error durante el inicio de sesión',
              paylink_notification_sent: 'ha enviado una notificación desde',
              paylink_notification_discarded:
                'Notificación descartada. Se ha superado el límite de notificaciones por día y por canal para este expediente.',
              paylink_notification_received: 'ha recibido una notificación desde',
              paylink_notification_read: 'ha leído la notificación',
              feedback_sent: 'ha enviado un comentario',
              feedback_visited: 'ha visitado',
              outbound_call_hung_up: 'ha sido llamado',
              api: 'API',
              campaign: 'campaña',
              payment_agreement: 'acuerdo de pago',
              reminder: 'enlace de pago',
            },
            DOCU_NAME: {
              payment_order_created: 'Intento de pago',
              payment_order_canceled: 'Cancelación del intento de pago',
              payment_order_captured: 'Pago realizado',
              paylink_notification_error: 'Error con notificación',
              paylink_notification_visited: ' Ha visitado página de pagos ',
              paylink_notification_login_visited: ' Ha hecho log in',
              paylink_notification_login_failed: ' Ha tenido un error en el log in',
              paylink_notification_sent: 'Se ha enviado una notificación',
              paylink_notification_discarded: 'Notificación descartada',
              paylink_notification_received: 'Ha recibido notificación',
              paylink_notification_read: 'Ha leído la notificación',
              feedback_sent: 'Ha alegado',
              feedback_visited: 'Ha visitado feedback',
              outbound_call_hung_up: 'Ha sido llamado',
              api: 'API',
              campaign: 'campaña',
              payment_agreement: 'Acuerdo de pago',
              reminder: 'Enlace de pago',
            },
            PDF: {
              DOWNLOADING: 'Descargando archivo',
              PROCESSING: 'El archivo está siendo procesado, por favor espere un momento',
              CUSTOMER_DATA: 'Datos del Cliente',
              PENDING_AMOUNT: 'Importe pendiente',
              ORIGINAL_AMOUNT: 'Importe original',
              AVERAGE_PAYMENT_TIME: 'Tiempo medio de pago',
              CONTACTABILITY: 'Contactabilidad',
              CUSTOMER_DETAILS: 'Detalles del Cliente',
              NAME: 'Nombre',
              EMAIL: 'Correo electrónico',
              PHONES: 'Teléfonos',
              NIF: 'NIF',
              LOCATION: 'Ubicación',
              NO_DATA: 'No hay datos',
              DAYS: 'días',
              CLIENT_PAYMENTS: 'Pagos del cliente',
              METHOD: 'Método',
              DATE: 'Fecha',
              TOTAL_AMOUNT: 'Importe total',
              OPERATIONS: 'Operaciones',
              OPERATION_ID: 'ID de operación',
              ATTRIBUTED_AMOUNT: 'Importe atribuido',
              TITLE: 'Título',
              STATUS: 'Estado',
              DUE_DATE: 'Fecha de vencimiento',
              COLLECTOR_PROFILE: 'Perfil de cobro',
              DESCRIPTION: 'Descripción',
              NO_PAYMENTS_FOR_CLIENT: 'No existen pagos para este cliente',
              CLIENT_CASES: 'Expedientes del cliente',
              CASE_STATUS: 'Estado',
              OPERATION_AMOUNT: 'Importe',
              OPERATION_STATUS: 'Estado',
              OPERATION_TITLE: 'Título',
              OPERATION_DUE_DATE: 'Fecha de vencimiento',
              NO_CASES_FOR_CLIENT: 'No existen expedientes para este cliente',
              CLIENT_ACTIVITIES: 'Actividades del cliente',
              CATEGORY: 'Categoría',
              EVENT: 'Evento',
              EVENT_DATE: 'Fecha',
              MESSAGE_SUBJECT: 'Asunto',
              MESSAGE_TEMPLATE: 'Plantilla',
              MESSAGE_PREHEADER: 'PreHeader',
              MESSAGE_TEXT: 'Mensaje',
              NOTIFICATION_CHANNEL: 'Canal de notificación',
              NO_ACTIVITIES_FOR_CLIENT: 'No existen actividades para este cliente',
            },
            TYPE: {
              NOTIFICATION_AND_VISIT: 'Notificaciones y visitas',
              FEEDBACK: 'Comentarios',
              PAYMENT_ORDER: 'Pago',
              CHAT_CONVERSATION: 'Conversaciones WhatsApp',
            },
            TOAST: {
              PDF: 'PDF generado exitosamente',
              PDF_ERROR: 'Error en la generación del PDF',
            },
            TOOLTIP: {
              DOWNLOAD_PDF: 'Descargar PDF',
            },
          },
        },
      },
      OPERATIONS: {
        TITLE: 'Operaciones',
        ELEMENTS: {},
        COMPONENTS: {
          CREATE: {
            TITLE: 'Título de la operación',
            ID: 'ID de la operación',
            COLLECTOR: 'Perfiles de cobro',
            DUE_DATE: 'Fecha de Vencimiento',
          },
          PAYMENTS: {
            TITLE: 'Pagos',
            ON_DATE: 'el',
            PAID_AMOUNT: 'pagó',
            PAID_PARTIAL: 'pagó',
            REFUND_MESSAGE: 'se le devolvió',
            PAYMENT_OF: 'del pago {{reference}} ',
            ATTRIBUTED_AMOUNT: 'de los cuales',
            ATTRIBUTED_AMOUNT_SUFFIX: ' se han atribuido a esta operación',
            VIA: 'vía',
            PAYMENT_ON: 'el',
            CUSTOM_CONCEPT: 'Concepto personalizado',
            ORDER_NUMBER: 'Número de pedido',
            VIEW_OPERATIONS: 'Ver Operaciones',
            NO_PAYMENTS: 'No hay pagos registrados en esta operación',
          },
          CONCEPT_CARD: {
            ADD_CONCEPT_HEADER: 'Añadir concepto',
            EDIT_CONCEPT_HEADER: 'Editar concepto',
            DELETE_CONCEPT_HEADER: 'Eliminar concepto',
            DELETE_CONFIRMATION_MESSAGE: '¿Seguro deseas eliminar el concepto {{concept}}?',
            DELETE_ACCEPT_LABEL: 'Eliminar',
            DELETE_REJECT_LABEL: 'No',
            DELETE_ICON: 'pi pi-exclamation-triangle',
            OPERATION_UPDATED: 'Operación {{operationTitle}} Actualizada',
            ERROR_GENERIC: 'Ocurrió un error inesperado',
            ERROR: 'Error',
            TOTAL_LABEL: 'Total',
            CURRENCY_MODAL_HEADER: 'Concepto de moneda',
            AMOUNT: 'Cantidad',
            CONCEPT: 'Concepto',
            ADD_CONCEPT_BUTTON_LABEL: 'Añadir concepto',
            CONCEPTS_TITLE: 'Conceptos',
            TOTAL_AMOUNT: 'Total',
            CHANGE_CONCEPT_BUTTON_TOOLTIP: 'Editar concepto',
            DELETE_CONCEPT_BUTTON_TOOLTIP: 'Eliminar concepto',
            CAN_WRITE_ERROR_MESSAGE: 'No puedes editar esta operación',
          },
          GENERAL_INFO: {
            ID_OPERATION_LABEL: 'ID de operación',
            COLLECTION_PROFILE_LABEL: 'Perfil de cobros',
            TITLE_LABEL: 'Título',
            WALLET_LABEL: 'Cartera',
            EXPIRATION_DATE_LABEL: 'Fecha de vencimiento',
            DESCRIPTION_LABEL: 'Descripción',
            CREATION_DATE_LABEL: 'Fecha de creación',
            MODIFICATION_DATE_LABEL: 'Fecha de modificación',
            ERROR_UPDATE_OPERATION: 'Error al actualizar la operación',
            ERROR_UPDATE_OPERATION_MESSAGE: 'Error al actualizar la operación',
            EDIT: 'Editar',
          },
          SECTIONS: {
            CONCEPTS: 'Conceptos',
            PAYMENTS: 'Pagos',
            HISTORIC: 'Histórico',
            NO_NOTES_MESSAGE: 'No hay notas para esta operación',
            NOTE_DATE_LABEL: 'Fecha:',
            WRITE_NOTE_PLACEHOLDER: 'Escribe una nota',
            SAVE_BUTTON_LABEL: 'Guardar',
            CHANGE_STATUS_BUTTON_LABEL: 'Cambiar estado',
            CREATE_PAYMENT: 'Marcar como pagado (Cobrado)',
            EXTERNAL_ID_LABEL: 'ID Ext.',
            COPY_ID_TOOLTIP: 'Copiar ID',
            GENERAL_INFORMATION_TAB: 'Información general',
            MORE_INFORMATION_TAB: 'Más información',
            NOTES_TAB: 'Notas',
            EDIT_GENERAL_INFO_TOOLTIP: 'Editar información general',
            EDIT_STATUS_HEADER: 'Editar el estado de {{operationTitle}} con ID {{operationId}}',
            EDIT_GENERAL_INFO_HEADER: 'Editar la información de la operación',
            OPERATION_UPDATED_SUCCESS: 'La operación ha sido actualizada exitosamente',
            OPERATION_STATUS_CHANGED_SUCCESS:
              'El estado de la operación ha sido cambiado exitosamente',
            OPERATION_STATUS_CHANGED_ERROR: 'Hubo un error al cambiar el estado de la operación',
            OPERATION_CHARGED_SUCCESS: 'El estado de la operación ha sido cambiado a Cargado',
            OPERATION_CHARGED_HEADER: 'Estado de operación modificado',
            ERROR_UNEXPECTED: 'Ocurrió un error inesperado. {errorMessage}',
            ERROR_GENERIC: 'Por favor, intente de nuevo más tarde.',
            COPY_TEXT_SUCCESS: 'Este texto ha sido copiado',
            COPY_TEXT_HEADER: 'Copiado',
            ACTION_PERFORMED_SUCCESS: 'Acción realizada',
            ERROR_TITLE: 'Error',
            COLLECTION_PROFILE: 'Perfil de cobro',
            PORTFOLIO: 'Cartera',
            DESCRIPTION: 'Descripción',
            CREATION_DATE: 'Fecha de creación',
            MODIFICATION_DATE: 'Fecha de modificación',
            DUE_DATE: 'Fecha de vencimiento',
            KEY_LABEL: 'Clave',
            TYPE_LABEL: 'Tipo',
            VALUE_LABEL: 'Valor',
            NO_DATA_MESSAGE: 'No hay datos para mostrar',
          },
          HISTORIC: {
            TITLE: 'Histórico',
            LEGEND: 'Legend',
            NO_HISTORIC: 'No hay historial para mostrar en esta operación',
            LEGENDS: {
              OPERATION_CREATED: 'Operación creada',
              OPERATION_STATUS_CHANGED: 'Estado de operación cambiado',
              OPERATION_PORTFOLIO_ASSIGNED: 'Portfolio asignado a la operación',
              OPERATION_UPDATED: 'Operación actualizada',
              PAYMENT_CREATED: 'Pago realizado',
              PAYMENT_ORDER_CANCELED: 'Pago cancelado',
              PAYMENT_ORDER_REFUND_SUCCEEDED: 'Reembolso de pago exitoso',
              PAYLINK_NOTIFICATION_SENT: 'Notificación enviada',
              PAYLINK_NOTIFICATION_VISITED: 'Notificación visitada',
              PAYLINK_NOTIFICATION_READ: 'Notificación leída',
              PAYLINK_NOTIFICATION_RECEIVED: 'Notificación recibida',
              PAYLINK_NOTIFICATION_ERROR: 'Error en la notificación',
              PAYLINK_NOTIFICATION_ATTACHMENT_VISITED: 'Documento leído',
              FEEDBACK_SENT: 'Feedback enviado',
              PAYMENT_ORDER_CAPTURED: 'Pago capturado',
            },
            INPUT: {
              FEEDBACK: 'Feedback',
              PAYMENT_ORDER: 'Página de pago',
              PAYMENT: 'Pago',
              PAYLINK_NOTIFICATION: 'Notificación',
              RECEIPT: 'Recibo',
              OPERATION: 'Operación',
              ACTIVITY_TYPE: 'Tipo de actividad',
            },
            ACTIVITIES: {
              PAYMENT_ORDER_CANCELED: 'ha cancelado un intento de pago',
              PAYMENT_ORDER_REFUND_SUCCEEDED: 'Ha reembolsado',
              OPERATION_CREATED: 'Operación creada',
              OPERATION_STATUS_CHANGED: 'Estado cambiado',
              NO_COMMENTS: 'Sin comentarios',
              OPERATION_UPDATED: 'Operación actualizada',
              NOTE_ADDED: 'Nota añadida',
              TITLE_UPDATED: 'Título actualizado',
              DUE_DATE_UPDATED: 'Fecha de vencimiento actualizada',
              PORTFOLIO_ASSIGNED: 'El portfolio <b>{{alias}}</b> ha sido asignado a la operación',
              UPDATED_ITEMS: 'Conceptos actualizados ',
              PAGO_REGISTRADO_DE: 'Pago registrado desde',
              POR: 'por',
              HA_ALEGADO: 'ha reclamado',
              SIN_COMENTARIO: 'Sin comentario',
              EVENT_NAME: 'Notificación del evento: {{eventName}}',
              ATTACHMENT_VISITED: 'Adjunto visitado',
              NOTIFICATION_ERROR: 'Error en la notificación',
              NOTIFICATION_RECEIVED: 'Notificación recibida',
              EXPIRATION: 'Fecha de vencimiento',
              FROM: 'De',
              SUBJECT: 'Asunto',
              PRE_HEADER: 'Pre encabezado',
              MESSAGE: 'Mensaje',
              READ: 'Léido',
              RECEIVED: 'Recibido',
              SENT: 'Enviado',
              SENT_TO: 'Enviado a',
              NUMBER_ORDER: 'Número de pedido:',
              GATEWAY_NUMBER: 'Pasarela de pago:',
              REFUND: 'ha devuelto',
              HAS_READ: 'ha leído el documento adjunto',
              ERROR_NOTIFICATION: 'Hubo un error con la notificación',
              RECIVIED_NOTIFICATION: 'ha recibido una notificación',
              VALID_UNTIL: 'Válido hasta:',
              NOTIFICATION: 'Notificación',
              TEMPLATE_NOT_FOUND: 'Plantilla no encontrada',
              ASK_PAYMENT: 'ha solicitado un recibo de pago',
              EVENT_NAMES: {
                payment_order_created: 'ha iniciado un intento de pago',
                payment_order_canceled: 'ha cancelado el intento de pago',
                payment_order_captured: 'ha pagado',
                paylink_notification_error: 'Error en la notificación',
                paylink_notification_visited:
                  'ha visitado la página de pagos, desde la notificación',
                paylink_notification_login_visited: 'Inicio de sesión',
                paylink_notification_login_failed: 'Error en el inicio de sesión',
                paylink_notification_sent: 'Notificación enviada',
                paylink_notification_received: 'ha recibido una notificación',
                paylink_notification_read: 'Notificación leída',
                paylink_notification_discarded:
                  'Notificación descartada. Se ha superado el limite de notificaciones para este cliente',
                feedback_sent: 'ha enviado feedback',
                feedback_visited: 'ha visitado la página de feedback',
                api: 'API',
                campaign: 'Campaña',
                payment_agreement: 'Acuerdo de pago',
                reminder: 'Recordatorio',
              },
              LABELS: {
                causation: 'Desde',
                validUntil: 'Válido hasta',
                notification: 'Notificación',
                sentTo: 'enviado a',
                copy: {
                  subject: 'Asunto',
                  message: 'Mensaje',
                },
              },
            },
          },

          CREATE_OPERATION: {
            ADD_CONCEPT: 'Agregar concepto',
            CONCEPT_TITLE: 'Agregar concepto',
            CONCEPT_NAME_PLACEHOLDER: 'Nombre del concepto',
            AMOUNT_PLACEHOLDER: 'Importe',
            CONCEPTS_PER_CUSTOMER: 'Conceptos por cliente',
            TOTAL: 'TOTAL:',
            NEGATIVE_AMOUNT_ERROR: 'El monto total de los conceptos no puede ser negativo.',
            CUSTOMERS_ADDED: 'Clientes de la operación agregados',
            CREATE: 'Crear operación',
            TITLE: 'Crear operación',
            SUBTITLE:
              'Completa los datos, añade el cliente y los conceptos para generar la operación.',
            SECTION_DATA: 'DATOS DE LA OPERACIÓN',
            SECTION_CLIENT: 'CLIENTE DE LA OPERACIÓN',
            SECTION_CONCEPTS: 'CONCEPTOS',
            CLIENT_DESC: 'Busca un id externo de cliente para añadirlo, o crea uno nuevo.',
            EXTERNAL_ID_LABEL: 'External Id',
            EXTERNAL_ID_PLACEHOLDER: 'Ej. EXT-2026-014',
            TITLE_LABEL: 'Título de la operación',
            TITLE_PLACEHOLDER: 'Ej. Factura Q3 2026',
            DUE_DATE_LABEL: 'Fecha de vencimiento',
            COLLECTOR_LABEL: 'Perfiles de cobro',
            TOTAL_LABEL: 'Total operación',
            INFO_BANNER_TEXT:
              'El importe total se calcula automáticamente sumando los conceptos añadidos. Puedes editar el nombre e importe de cada concepto directamente en la fila.',
            CREATE_CUSTOMER_BTN: 'Crear cliente',
            ADD_ANOTHER_CONCEPT: 'Añadir otro concepto',
          },
          STATUS_CHANGE: {
            FORM: {
              LABEL: 'Cambiar estado',
              STATUS: 'Estado',
              MESSAGE: 'Mensaje',
              PAYMENT_DATE: 'Fecha de Pago',
              PAYMENT_METHOD: 'Método de Pago',
              PAYER: 'Pagador',
            },
          },
          EDIT_STATUS: {
            TITLE: 'Cambiar estado de la operación',
            CURRENT_STATUS: 'Estado actual',
            CURRENT_LABEL: 'estado actual',
            NEW_STATUS_LABEL: 'Nuevo estado',
            SELECT_PLACEHOLDER: 'Selecciona un estado',
            MESSAGE_LABEL: 'Mensaje',
            MESSAGE_PLACEHOLDER: 'Añade un motivo o nota interna para auditoría (opcional).',
            MESSAGE_HELP: 'Visible solo para el equipo. No se envía al cliente.',
            DISCARD_WARNING:
              'Al marcar como <strong>Descartado</strong> se detendrán las campañas activas sobre esta operación y no podrá reabrirse desde la ficha. Confirma antes de continuar.',
            CONFIRM_BTN: 'Cambiar estado',
            DISCARD_BTN: 'Descartar operación',
            CANCEL: 'Cancelar',
          },
          CREATE_PAYMENT: {
            TITLE: 'Registrar pago',
            FOR: 'Para',
            CASE_LABEL: 'expediente',
            KPI_PENDING_LABEL: 'Importe pendiente',
            KPI_DUE: 'Vence',
            SECTION_DETAILS: 'Detalles del pago',
            SUMMARY:
              'Se marcará <strong>{{title}}</strong> como pagada por <strong>{{amount}}</strong>, registrando un pago de <strong>{{payer}}</strong> el <strong>{{date}}</strong> mediante <strong>{{method}}</strong>.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Marcar como pagada',
          },
        },
        PAGES: {
          SEARCH: {
            COLLECTOR: 'Perfil de Cobro',
            STATUS: 'Estado',
            PAYMENT_METHOD: 'Método de Pago',
            DUE_DATE: 'Fecha de Vencimiento',
            PAYMENT_DATE: 'Fecha de Pago',
            TITLE: 'Título',
            CREATION_DATE: 'Fecha de Creación',
            MODIFICATION_DATE: 'Fecha de Modificación',
            SEARCH: {
              LABEL: 'Búsqueda',
              TOOLTIP:
                'Busca entre ID DE OPERACIÓN, TÍTULO, ID DE CLIENTE, CLIENTE para resultados similares.\n\nTambién puedes buscar varios elementos separados por comas.\n\nEjemplo: Factura 22/0001, Factura 22/0002, María García',
            },
          },
          LIST: {
            TITLE: 'Listado de operaciones',
          },
          OPERATION_LIST: {
            TITLE: 'Listado de operaciones',
            NEW: 'Nuevo operaciones',
            EDIT: 'Editar operaciones',
            CREATE: 'Crear operación',
            EXPORT: {
              CSV: '.csv',
              XLSX: '.xlsx',
            },
            TOOLTIP_ALL_SELECTED: "Operations with the status 'Collected' will not be selected",
            FORM: {},
            DELETE_OPERATION_DIALOG: {
              SINGLE_HEADER: 'Eliminar operación: <b>{{ title }} ({{ externalId }})</b>',
              MULTIPLE_HEADER: 'Eliminar los {{ count }} operaciones',
              SINGLE_CONFIRM: '¿Estás seguro de que deseas eliminar la operación {{ externalId }}?',
              MULTIPLE_CONFIRM: '¿Estás seguro de que deseas eliminar {{ count }} operaciones?',
              SUCCESS: {
                SINGLE: '{{ title }} eliminada',
                MULTIPLE: '{{ count }} operaciones eliminadas',
              },
              ERROR: {
                SINGLE: 'Hubo un error al eliminar {{ title }}',
                MULTIPLE: 'Hubo un error al eliminar {{ count }} operaciones',
              },
            },
            CHANGE_STATUS_DIALOG: {
              SINGLE_HEADER: 'Editar operación: <b>{{ title }} ({{ externalId }})</b>',
              MULTIPLE_HEADER: 'Editar las {{ count }} operaciones',
              TOAST: {
                ERROR: 'Ocurrió un error al cambiar el estado de las operaciones. {{ error }}',
                PAYMENT_SUCCESS: 'El pago se ha creado correctamente',
                STATUS_CHANGED_SUCCESS:
                  '{{ count }} operaciones cambiaron su estado a {{ status }}',
                STATUS_CHANGED_FAILED:
                  'Ocurrió un error al cambiar el estado de {{ count }} operaciones',
              },
              UNEXPECTED_ERROR: {
                SUMMARY: 'Error inesperado',
                DETAIL: 'Ocurrió un error inesperado. {{ error }}',
              },
            },
            TABLE: {
              DELETE_OP: 'Eliminar {{selectedOperations}}',
              CHANGE_STATUS_OP: 'Cambiar estado {{selectedOperations}}',
              MARK_AS_PAID_OP: 'Marcar como pagado {{selectedOperations}}',
              DOWNLOAD: 'Descargar',
              DOWNLOAD_PROCESS: 'Descargar {{process}} %',
              DOWNLOAD_TOOLTIP: 'Descarga todas las operaciones filtradas',
              HEADERS: {
                STATUS: 'ESTADO',
                COLLECTOR: 'PERFIL DE COBRO',
                OPERATION_ID: 'ID OPERACIÓN',
                TITLE: 'TÍTULO',
                DUE_DATE: 'VENCIMIENTO',
                CUSTOMER_ID: 'ID CLIENTE',
                CUSTOMER_NAME: 'NOMBRE Y APELLIDO DE CLIENTE',
                TOTAL_AMOUNT: 'IMP. TOTAL',
                PENDING_AMOUNT: 'IMP. PENDIENTE',
                PAYMENT_DATE: 'FECHA DE PAGO',
                PAYMENT_METHOD: 'MÉTODO DE PAGO',
                CREATION_DATE: 'FECHA CREACIÓN',
                UPDATE_DATE: 'FECHA ACTUALIZACIÓN',
                ACTIONS: 'ACCIONES',
              },
              MORE: {
                NO_RESULTS: 'No hay operaciones que mostrar',
              },
            },
          },
          PENDING_AMOUNT: 'Importe Pendiente',
          PENDING_AMOUNT_TOOLTIP: 'Importe pendiente de la factura',
          NO_PENDING_PAYMENTS: '✔ Sin pagos pendientes',
          ORIGINAL_AMOUNT: 'Importe Original',
          ORIGINAL_AMOUNT_TOOLTIP: 'Importe total de la operación',
          DUE_DATE: 'Fecha de Vencimiento',
          DUE_DATE_TOOLTIP: 'Fecha de vencimiento de la operación',
          CREATION_DATE: 'Fecha de Creación',
          CREATION_DATE_TOOLTIP: 'Fecha de creación de la operación',
          OPERATIONS_FILE: {
            TITLE: 'Detalles operación',
          },
        },
      },
      IMPORT: {
        TITLE: 'Listado de importaciones',
        ELEMENTS: {},
        PAGES: {
          UPLOAD: {
            TITLE: 'Importar fichero',
          },
          LIST: {
            TITLE: 'Listado de importaciones',
          },
          IMPORT_LIST: {
            TITLE: 'Listado de importaciones',
            NEW: 'Nueva importación',
            EDIT: 'Editar importación',
            SNAPSHOT_WARNING:
              'Se está operando en modo "fotocartera": cualquier operación actualmente en Paymefy que no esté en el fichero importado, se descartará.',
            ELEMENTS: {
              IMPORT: 'Importar',
            },
            TABLE: {
              HEADERS: {
                CHARGE_DATE: 'FECHA DE CARGA',
                STATUS: 'ESTADO',
                TOTAL_AMOUNT: 'IMPORTE TOTAL',
                CHARGED_AMOUNT: 'IMPORTE CARGADO',
                OP_NUMBER: 'Nº DE OPERACIONES',
                CHARGED_OP_NUMBER: 'Nº DE OPERACIONES CARGADAS',
                FILE_NAME: 'NOMBRE DE ARCHIVO',
                ACTIONS: 'ACCIONES',
                ERRORS: 'ERRORES',
              },
              VALUES: {
                ERRORS_STRING: '<b>"{{errorMessage}}"</b> en la columna <b>"{{errorColumn}}"</b>',
                NO_ERRORS: 'Todos los registros son correctos',
                NO_ERROR: 'No hay errores',
              },
              MORE: {
                NO_RESULTS: 'No hay importaciones que mostrar',
              },
              TOOLTIP: {
                DOWNLOAD: 'Descargar archivo de importación',
              },
            },
          },
          EDIT: {
            TITLE: 'Revisa el formato',
            FILTER: {
              TITLE: 'Filtrar formato',
              ALL: 'Todos',
              VALID: 'Correctos',
              INVALID: 'Incorrectos',
            },
            TABLE: {
              HEADERS: {
                STATUS: 'FORMATO',
                NOMBRE_CORTO: 'NOMBRE CORTO',
                NOMBRE_COMPLETO: 'NOMBRE COMPLETO',
                MOVIL: 'MÓVIL',
                EMAIL: 'CORREO',
                ES_EMPRESA: 'ES EMPRESA',
                NIF: 'NIF',
                CODIGO_CLIENTE: 'CÓDIGO CLIENTE',
                CODIGO_POSTAL: 'CÓDIGO POSTAL',
                TITULO: 'TÍTULO',
                CONCEPTO: 'CONCEPTO',
                IMPORTE: 'IMPORTE',
                CODIGO_OPERACION: 'CÓDIGO OPERACIÓN',
                CODIGO_TRANSACCION: 'CÓDIGO TRANSACCIÓN',
                FECHA_LIMITE: 'FECHA LÍMITE',
                CODIGO_IMPAGO_DEVOLUCION_SEPA: 'CÓDIGO IMPAGO',
                IDIOMA: 'IDIOMA',
                DIRECCION: 'DIRECCIÓN',
                CIUDAD: 'CIUDAD',
                PAIS: 'PAÍS',
                ALIAS: 'ALIAS',
                URL_FACTURA: 'URL FACTURA',
                ESTADO: 'ESTADO',
              },
              CELL: {
                STATUS: {
                  VALID: 'Correcto',
                  INVALID: 'Error',
                },
              },
            },
            MORE: {
              NO_RESULTS: 'No hay líneas que mostrar',
              TIME_LIMIT:
                'Las líneas importadas tendrán una vigencia de 5 días, tras los cuales la información será eliminada.',
              LOADING_RESULTS: 'Cargando líneas...',
            },
          },
          END: {
            TITLE: 'Finalizar importación',
            DESCRIPTION: {
              TITLE: 'Resumen',
              OPERATIONS_NUMBER_TITLE: 'Número de operaciones a importar:',
              OPERATIONS_NUMBER: '{{operations}} de {{operations_total}}',
              TOTAL_IMPORT: 'Importe total: ',
            },
          },
        },
      },
      SEGMENTS: {
        TITLE: 'Segmentos',
        ELEMENTS: {},
        PAGES: {
          SEGMENT_LIST: {
            TITLE: 'Listado de segmentos',
            NEW: 'Nuevo segmento',
            EDIT: 'Editar segmento',
            INFO_SEGMENTS: 'Información de segments',
            CREATE_NEW: 'Crear un nuevo segmento',
            ERROR: 'Error',
            ERROR_CREATING: 'Hubo un error al crear el segmento.',
            ERROR_UPDATING: 'Hubo un error al actualizar el segmento.',
            ERROR_DELETING: 'Hubo un error al eliminar {{name}}.',
            SUCCESS: 'Éxito',
            SEGMENT_CREATED: 'El segmento {{name}} se ha creado correctamente.',
            SEGMENT_UPDATED: 'El segmento {{name}} se ha actualizado correctamente.',
            SEGMENT_DELETED: 'El segmento {{name}} se ha eliminado correctamente.',
            DELETE: 'Eliminar Segmento',
            DELETE_CONFIRMATION: '¿Seguro que quieres eliminar a {{name}}?',
            TOOLTIP_IN_USE: 'Segmento en uso en campañas.',
            TOOLTIP_DEFAULT: 'Los segmentos por defecto no se pueden eliminar.',
            VIEW: 'Ver Segmento',
            DEFAULT_CHIP: 'Por defecto',
            DIALOG: `No se pueden <b>borrar</b> segmentos si ya <b>están en uso</b> en una campaña. Si quieres borrarlo, debes
            archivar la campaña que lo utiliza.`,
            FORM: {
              NAME: 'NOMBRE',
            },
            TABLE: {
              HEADERS: {
                NAME: 'NOMBRE',
                ACTIONS: 'ACCIONES',
              },
              ACTIONS: {
                EDIT: 'Editar',
                DELETE: 'Eliminar',
              },
              MORE: {
                NO_RESULTS: 'No hay segmentos que mostrar',
              },
            },
          },
        },
        COMPONENTS: {
          BASIC_SEGMENTATION: {
            ADD_CONDITION: 'Añadir condición',
          },
        },
      },
      PAYMENT_AGREEMENT: {
        TITLE: 'Acuerdos de pago',
        LINK_NOT_FOUND_TITLE: 'Acuerdo de pago no encontrado',
        LINK_NOT_FOUND_MSG: 'No se ha encontrado el acuerdo de pago del enlace compartido',
        DETAILS: {
          COPY_LINK_TOOLTIP: 'Copiar enlace',
          LINK_COPIED_TITLE: 'Copiado',
          LINK_COPIED_MSG: 'Enlace copiado al portapapeles',
        },
        ELEMENTS: {
          DOWNLOAD: {
            LABEL: 'Descargar',
          },
        },
        FORM: {
          PROFILE_OF_COLLECTION: 'Perfil de Cobro',
          OPERATION_EXTERNAL_ID: 'IDs externos de operación',
          CUSTOMER_EXTERNAL_ID: 'IDs externos de cliente',
          SEARCH_TOOLTIP_OP:
            'Busca por External ID de operación. También puedes buscar varios elementos separados por coma. Ejemplo: C1234, C1235, C1236',
          SEARCH_TOOLTIP_CUSTOMER:
            'Busca por External ID de cliente. También puedes buscar varios elementos separados por coma. Ejemplo: C1234, C1235, C1236',
          STATUS: 'Estado',
          SEARCH: 'Búsqueda',
          SELECT_PROFILE: 'Seleccionar Perfil',
          SELECT_STATUS: 'Seleccionar Estado',
          ENTER_SEARCH_PATTERN: 'Ingrese el patrón de búsqueda',
          BROKEN: 'Roto',
          FULFILLED: 'Cumplido',
          EXPIRED: 'Expirado',
          PROPOSAL: 'Propuesta',
          SIGNED: 'Firmado',
          BROKEN_DESCRIPTION: 'El acuerdo no se cumplió — uno o más pagos no fueron realizados.',
          FULFILLED_DESCRIPTION:
            'Todos los pagos se realizaron según lo acordado — el acuerdo se completó con éxito.',
          EXPIRED_DESCRIPTION:
            'El período del acuerdo finalizó sin cumplimiento total o renovación.',
          PROPOSAL_DESCRIPTION: 'Hay una propuesta de acuerdo pendiente de revisión o aceptación.',
          SIGNED_DESCRIPTION: 'El acuerdo ha sido firmado y está actualmente activo.',
        },
        BREAK: {
          ACTIONS: {
            BREAK: 'Romper acuerdo',
            BREAK_SELECTED: 'Romper acuerdos',
          },
          SELECTION: {
            SINGLE: '<strong>{{count}} acuerdo(s)</strong> seleccionado(s)',
            ALL: 'Todos los <strong>{{count}} acuerdos</strong> que coinciden con los filtros seleccionados',
            SELECT_ALL: 'Seleccionar todos los {{count}} resultados',
            CLEAR: 'Limpiar selección',
          },
          MODAL: {
            TITLE: 'Romper acuerdo de pago',
            SUBTITLE_SINGLE: 'Se romperá el acuerdo de pago seleccionado.',
            SUBTITLE_MASSIVE: 'Se romperán {{count}} acuerdos de pago.',
            REASON_LABEL: 'Motivo',
            REASON_PLACEHOLDER: 'Explica por qué se rompe este acuerdo',
            CANCEL: 'Cancelar',
            CONFIRM: 'Romper acuerdo',
          },
          TOAST: {
            SUCCESS_TITLE: 'Éxito',
            SUCCESS_BODY: 'La solicitud de rotura del acuerdo de pago se envió correctamente.',
            ERROR_TITLE: 'Error',
            ERROR_BODY: 'No se ha podido romper el acuerdo de pago. Inténtalo de nuevo.',
          },
        },
        PAGES: {
          LIST: {
            EMPTY_STATE: {
              TITLE: 'Sin resultados',
              DESCRIPTION: 'No se encontraron acuerdos de pago con los filtros aplicados.',
              CLEAR_FILTERS: 'Limpiar filtros',
            },
            NO_DATE: 'Sin fecha',
            COPY_CUSTOMER_ID: 'Copia id cliente',
            SHOW_INSTALMENTS: 'Mostrar cuotas',
            TABLE: {
              HEADERS: {
                COLLECTOR: 'PERFIL DE COBRO',
                CHARGE_DATE: 'FECHA DE INICIO',
                STATUS: 'ESTADO',
                TOTAL_AMOUNT: 'IMPORTE TOTAL',
                CHARGED_AMOUNT: 'IMPORTE COBRADO',
                OP_NUMBER: 'NÚMERO DE OPERACIONES',
                CHARGED_OP_NUMBER: 'CUOTAS PAGADAS',
                DETAILS: 'DETALLES',
                NEXT_PAY: 'PRÓXIMO PAGO',
                FILE_NAME: 'COLLECTOR',
                EXTERNAL_CLIENT_CODE: 'CÓDIGO EXTERNO CLIENTE',
                CLIENT: 'CLIENTE',
                TITLE: 'TÍTULO',
              },

              MORE: {
                NO_RESULTS: 'No hay acuerdos de pago que mostrar',
              },
            },
            PAGINATION: {
              TOTAL_RESULTS: 'Total resultados',
              RESULTS_PER_PAGE: 'Resultados por página',
            },
          },
        },
        INSTALLMENTS_DETAILS: {
          TITLE: 'Acuerdo de pago',
          SUMMARY: 'Resumen',
          STARTED_PREFIX: 'Iniciado',
          CLOSED_PREFIX: 'Cerrado',
          ID_LABEL: 'ID',
          OF: 'de',
          COMPLETED: 'completado',
          COLLECTED_LABEL: 'Cobradas',
          PENDING_LABEL: 'Pendientes',
          PROPOSED_DATE: 'Fecha propuesta acuerdo',
          TOTAL_AMOUNT: 'Importe Total',
          PAID_AMOUNT: 'Importe Pagado',
          DETAILS: 'Detalles',
          SIGN_DATE: 'Fecha de firma',
          START_DATE: 'Fecha inicio',
          CLOSE_DATE: 'Fecha de cierre',
          CLOSE_REASON: 'Motivo de cierre',
          NEXT_PAYMENT: 'Siguiente pago',
          AGREEMENT_ID: 'Id del acuerdo',
          OPERATIONS: 'Operaciones',
          OPERATION_HASH: 'Operación #',
          DUE_DATE: 'Fecha vencimiento',
          NO_SCHEDULED_DATE: 'Sin fecha programada',
          AMOUNT: 'Importe',
          GO_TO_OPERATION: 'Ir a la operación',
          INSTALMENTS: 'Cuotas',
          TOTAL_INSTALMENTS: 'Total de cuotas',
          INSTALMENT_HASH: 'Cuota #',
          SCHEDULED_DATE: 'Fecha programada',
          ATTEMPTS: 'Intentos',
          NO_ATTEMPTS: 'Sin intentos',
          SETTLEMENT_DATE: 'Liquidación',
          NO_SETTLEMENT_DATE: 'Sin fecha de liquidación',
          STATUS_COLLECTED: 'Cobrada',
          STATUS_FAILED: 'Fallida',
          STATUS_PENDING: 'Pendiente',
          CLOSE: 'Cerrar',
        },
      },
      REPORTS: {
        TITLE: 'Reportes',
        INFO: {
          CAMPAIGNS: 'Informe actualizado cada 12 horas',
          COLLECTORS: 'Informe actualizado a las 2 A.M. y a las 12 P.M.',
        },
        LABEL: {
          analysisMonth: 'Mes de análisis',
          comparisonMonth: 'Mes a comparar',
          ageRanges: 'Rangos de antigüedad',
          collectorId: 'Perfil de cobro',
          campaignId: 'Campaña',
          dateNotification: 'Mes de análisis',
          dateRange: 'Período',
          startDate: 'Mes de vencimiento inicial',
          dateRangeCollectors: 'Fecha',
          notificationsDateRange: 'Período',
          outboundDateRange: 'Date Range',
          campaigns: 'Campañas',
          dueDateRange: 'Período',
          creationMonth: 'Mes de creación de la deuda',
          filterCampaignId: 'Filtrar por campaña',
          filterCollectorId: 'Perfil de cobro',
          months: 'Número de meses a analizar',
          portfolioId: 'Filtrar por cartera',
          ignoreOperationStatus: 'Ignorar operaciones que estén en el estado',
          period: 'Período',
          Agent: 'Agente',
          agentId: 'Selecciona un agente',
          monthCreation: 'Mes de craeción de la deuda',
          campaignRestore: 'Filtrar por campaña',
          monthsToAnalyze: 'Número de meses a analizar',
        },
        TOOLTIP: {
          COLLECTORS_PERIOD: 'Período en el que se crean las operaciones',
          monthCreation: 'Se analizará la deuda creada durante el mes seleccionado',
          monthsToAnalyze:
            'Seleccionar el número de meses posteriores al mes de creación de la deuda por el que se quiere analizar la tasa de recobro',
          campaignId: 'Campaña analizada',
          dateNotification:
            'Mes para el cual se analizan las notificaciones (e interacciones) que genera la campaña',
          dateRange:
            'Se analizarán sólo las operaciones que hayan sido creadas durante el período seleccionado',
          startDate:
            'Se analiza la deuda con fecha de vencimiento igual o posterior al mes seleccionado',
          dateRangeCollectors: 'periodo en el que se crean las operaciones',
          notificationsDateRange:
            'Análisis de las notificaciones enviadas durante un periodo específico',
          outboundDateRange:
            'Se analizan todas las llamadas realizadas durante el periodo seleccionado',
          campaigns: '',
          dueDateRange: '',
          creationMonth: 'Se analizará la deuda creada durante el mes seleccionado',
          filterCampaignId: '',
          filterCollectorId: '',
          months:
            'Seleccionar el número de meses posteriores al mes de creación de la deuda por el que se quiere analizar la tasa de recobro',
          portfolioId: '',
          ignoreOperationStatus: '',
          collectorId: '',
          PORTFOLIO:
            'Se analizarán sólo las operaciones que hayan sido creadas durante el período seleccionado',
          COLLECTION:
            'Período durante el que se efectúan los pagos, o en el que se crean las operaciones (según el gráfico)',
          period: 'Se analizan todas las llamadas realizadas durante el periodo seleccionado',
        },
        DESCRIPTION: {
          CLIENTS: 'Análisis global de todo el conjunto de clientes gestionados hasta la fecha.',
          PANEL: 'Visión general del panel de métricas y estadísticas.',
          CAMPAIGNS:
            'Análisis del rendimiento y la conversión de las campañas para un mes determinado. La primera tabla ofrece una visión global de todas las campañas, y a partir de ahí se analiza en detalle la campaña seleccionada para el mes seleccionado.',
          COLLECTION_BY_PERIOD:
            'Análisis de la recuperación de deuda para un mes específico. Muestra cómo ocurre la recuperación en los meses posteriores a su creación y lo compara con la tasa de recuperación de meses anteriores.',
          PORTFOLIOS:
            'Análisis de la cartera global, es decir, todas las operaciones (recibos, facturas, etc.) creadas dentro de un período específico (rango de fechas).',
          COLLECTORS:
            'Análisis de la tasa de recuperación de las operaciones creadas durante un período para cada perfil de cobros existente.',
          NOTIFICATIONS: 'Análisis de las notificaciones enviadas durante un período específico.',
          OUTBOUND_CALLS:
            'Análisis de las llamadas realizadas por el agente de IA durante un período específico.',
          COLLECTION:
            'Análisis de los pagos realizados durante un período y de la tasa de recuperación de las operaciones creadas en ese mismo período.',
          CAMPAIGNS_BY_MONTH:
            'Análisis del rendimiento y la conversión de las campañas para un mes determinado. La primera tabla ofrece una visión global de todas las campañas, y a partir de ahí se analiza en detalle la campaña seleccionada para el mes seleccionado.',
          DUE_DATE_PERIOD: 'Análisis mensual de la deuda según su fecha de vencimiento.',
          DEBT_AGING: 'Análisis de la antigüedad de la deuda por fecha de vencimiento.',
        },

        BC: {
          PANEL: 'Análisis mensual',
          CLIENTS: 'Clientes',
          CAMPAIGNS_BY_MONTH: 'Campañas',
          COLLECTION: 'Recobro por periodo',
          NOTIFICATIONS: 'Notificaciones',
          COLLECTION_BY_PERIOD: 'Recobro por mes',
          COLLECTORS: 'Perfiles de cobro',
          WORKFLOWS: 'Recobro por mes',
          PORTFOLIOS: 'Cartera global',
          OUTBOUND_CALLS: 'Llamadas IA',
          DUE_DATE_PERIOD: 'Periodos de vencimiento',
          DEBT_AGING: 'Antigüedad de la deuda',
        },
        FILTERS: {
          CAMPAIGNS: 'CAMPAÑAS',
          COLLECTORS: 'PERFIL DE COBRO',
          PORTFOLIOS: 'CARTERAS',
          DATE: 'FECHA',
          DATE_NOTIFICATION: 'FECHA DE NOTIFICACIÓN',
          DATE_COLLECTION_CREATED: 'MES CREACIÓN DEUDA',
          PERIOD: 'PERIODO DE RECOBRO (EN MESES)',
          CAMPAIGN_PAYMENTS: 'RECUPERACIÓN POR CAMPAÑA',
          STATUS_OPERATION_IGNORE: 'IGNORAR ESTADO OPERACIÓN',
        },
        PAGES: {
          ROOT: {
            DESCRIPTIONS: {
              PANEL: 'Informes de Tenant',
              CLIENTS: 'Informes de clientes',
              CAMPAIGNS: 'Informes de campañas',
              COLLECTORS: 'Informes de perfiles de cobro',
              COLLECTION: 'Informes de recobro por periodo',
              WORKFLOWS: 'Informes de recobro por mes',
              PORTFOLIOS: 'Informes de cartera global',
            },
          },
        },
      },
      PAYMENT_METHOD: {
        FORM: {
          INPUT: {
            PAYMENT_METHOD: 'Método de pago',
          },
        },
        ADD: {
          TITLE: 'Nuevo método de pago',
          BUTTON: {
            BACK: 'Atrás',
          },
        },
        EDIT: {
          TITLE: 'Editar método de pago',
          ENABLED: 'Habilitado',
          BUTTON: {
            BACK: 'Atrás',
          },
        },
        LIST: {
          TITLE: 'Métodos de pago',
          BUTTON: {
            ADD: 'Nuevo método de pago',
          },
          INPUT: {
            SEARCH: 'Buscar',
          },
          TABLE: {
            HEADER: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              TYPE: 'Tipo',
              STATUS: 'Estado',
              ACTIONS: 'Acciones',
              COLLECTORS: 'Collectors asociados',
            },
            VALUES: {
              ENABLED: 'Activo',
              DISABLED: 'Inactivo',
            },
            BUTTON: {
              EDIT: 'Editar',
              DELETE: 'Eliminar',
            },
          },
        },
        REDSYS: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              TYPE: 'Tipo',
              STATUS: 'Estado',
              ACTIONS: 'Acciones',
              MERCHANT_CODE: 'Merchant code',
              MERCHANT_TERMINAL_ID: 'Merchant terminal id',
              MERCHANT_SECRET: 'Merchant secret',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: `
                <section>
                <p>Detalles Adicionales sobre Conceptos Personalizados de Pago</p>
                <p>Al configurar tus conceptos personalizados de pago, ten en cuenta lo siguiente:</p>
                <ul>
                    <li>Si utilizas la variable opcional <code>$PERSONALIZADO$</code>, debes asegurarte de incluir esta información en Paymefy. De lo contrario, la información no se imprimirá en el concepto.</li>
                    <li>En caso de multifactura, todos los códigos aparecerán separados por comas (<code>,</code>).</li>
                    <li>Concepto por defecto: <strong>título</strong>.</li>
                    <li>Límite de caracteres: <strong>125</strong>. Si se supera, el concepto será recortado.</li>
                    <li>Caracteres permitidos:
                        <ul>
                            <li>Caracteres de la <code>a</code> a la <code>z</code> (asegúrate de no incluir caracteres especiales o mayúsculas).</li>
                            <li>Números del <code>0</code> al <code>9</code>.</li>
                        </ul>
                    </li>
                </ul>
            </section>`,
                EXTRA: {
                  BIZUM: 'Bizum (Redsys)',
                },
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        INESPAY: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              COMPANY_TYPE: 'Tipo',
              ACTIONS: 'Acciones',
              IBAN: 'IBAN',
              API_KEY: 'API KEY',
              API_TOKEN: 'API TOKEN',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: `
                <section>
        <p>Información Actualizada sobre Conceptos Personalizados de Pago</p>
        <p>Considera las siguientes directrices al configurar tus conceptos personalizados de pago en Paymefy:</p>
        <ul>
            <li>Si utilizas <strong>variables opcionales</strong>, debes asegurarte de incluir esta información en Paymefy. De lo contrario, la información no se imprimirá en el concepto.</li>
            <li>Concepto por defecto: <em>iban de cuenta origen, external_id, nombre largo</em>.</li>
            <li>En caso de multifactura, todos los códigos aparecen separados por comas (<code>,</code>).</li>
            <li>Límite de caracteres: <strong>100</strong>. Si se supera, el concepto será recortado.</li>
            <li>Caracteres permitidos:
                <ul>
                    <li>Caracteres de la <code>a</code> a la <code>z</code>.</li>
                    <li>Números del <code>0</code> al <code>9</code>.</li>
                    <li>Otros caracteres permitidos: <code>+</code>, <code>?</code>, <code>/</code>, <code>-</code>, <code>:</code>, <code>(</code>, <code>)</code>, <code>.</code>, <code>,</code>, <code>'</code>.</li>
                </ul>
            </li>
        </ul>
    </section>
                `,
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        STRIPE: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              COMPANY_TYPE: 'Tipo',
              ACTIONS: 'Acciones',
              SECRET_KEY: 'Secret key',
              PUBLISHABLE_KEY: 'Publishable key',
              WEB_HOOK_SECRET: 'Web hook secret',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: `<section>
                <p>Información sobre Conceptos Personalizados de Pago</p>
                <p>Los conceptos personalizados de pago deben cumplir con las siguientes normativas:</p>
                <ul>
                    <li>Deben contener <strong>solo caracteres latinos</strong>.</li>
                    <li>La longitud debe ser de <strong>entre 5 y 22 caracteres</strong>, incluyendo ambos extremos.</li>
                    <li>Deben contener <strong>al menos una letra</strong>. Si se usa un prefijo y un sufijo, ambos deben contener al menos una letra.</li>
                    <li><strong>No deben contener</strong> ninguno de los siguientes caracteres especiales: <code>&lt;</code>, <code>&gt;</code>, <code>V</code>, <code>*</code>, <code>"</code>.</li>
                </ul>
            </section>`,
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        PAYCOMET: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              COMPANY_TYPE: 'Tipo',
              ACTIONS: 'Acciones',
              IBAN: 'IBAN',
              SWIFT_CODE: 'Código SWIFT',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: `<section>
                <p>Instrucciones para Conceptos Personalizados de Pago</p>
                <p>Al configurar conceptos personalizados de pago en Paymefy, ten en cuenta las siguientes directrices:</p>
                <ul>
                    <li>Para el uso de <strong>variables opcionales</strong>, es necesario incluir esta información en Paymefy. Si no se incluye, la información correspondiente no se mostrará en el concepto de pago.</li>
                    <li>El <strong>concepto por defecto</strong> se compone de: iban de cuenta origen, external_id, nombre largo.</li>
                    <li>En situaciones de <strong>multifactura</strong>, todos los códigos se listarán separados por comas (<code>,</code>).</li>
                    <li>Existe un <strong>límite de caracteres de 100</strong>. Si el concepto excede este límite, será necesario recortarlo.</li>
                    <li>Los <strong>caracteres permitidos</strong> incluyen:
                        <ul>
                            <li>Caracteres alfabéticos de la <code>a</code> a la <code>z</code>.</li>
                            <li>Números del <code>0</code> al <code>9</code>.</li>
                            <li>Además, se permiten los siguientes caracteres especiales: <code>+</code>, <code>?</code>, <code>/</code>, <code>-</code>, <code>:</code>, <code>(</code>, <code>)</code>, <code>.</code>, <code>,</code>, <code>'</code>.</li>
                        </ul>
                    </li>
                </ul>
            </section>`,
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        INGENICO: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              PSPID: 'Pspid',
              INTEGRATOR: 'Integrator',
              API_KEY: 'Api key',
              API_SECRET: 'Api secret',
              WEBHOOKS_KEY: 'Webhooks key',
              WEBHOOKS_KEY_SECRET: 'Webhooks key secret',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: ``,
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        MYMOID: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              APP_ID: 'App id',
              APP_SECRET: 'App secret',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: `
                <section>
                <p>Configuración de Conceptos Personalizados de Pago</p>
                <p>Al definir conceptos personalizados de pago para su uso en Paymefy, considera las siguientes directrices:</p>
                <ul>
                    <li>Al usar la variable opcional <code>$PERSONALIZADO$</code>, es crucial asegurarse de que esta información se haya ingresado en Paymefy; de lo contrario, no aparecerá en el concepto.</li>
                    <li>Para casos de <strong>multifactura</strong>, todos los códigos se mostrarán separados por comas (<code>,</code>).</li>
                    <li><strong>Concepto por defecto:</strong> No existe un concepto por defecto.</li>
                    <li>El <strong>límite de caracteres</strong> es de <strong>150</strong>. Si se supera este límite, el concepto será recortado.</li>
                    <li><strong>Mymoid</strong> no impone restricciones sobre los caracteres utilizados en los conceptos de pago.</li>
                </ul>
            </section>
        </body>`,
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        MONETICO: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              SOCIETE: 'Nombre empresa',
              TPE: 'Nº TPE',
              KEY: 'KEY',
              DEFAULT_ADDRESS: 'Dirección',
              DEFAULT_CITY: 'Ciudad',
              DEFAULT_POSTAL_CODE: 'Código postal',
              DEFAULT_COUNTRY: 'Código de país',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: '',
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        MONEI: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              TYPE: 'Tipo',
              STATUS: 'Estado',
              ACTIONS: 'Acciones',
              MERCHANT_CODE: 'Merchant code',
              MERCHANT_TERMINAL_ID: 'Merchant terminal id',
              MERCHANT_SECRET: 'Merchant secret',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        GREENPAY: {
          FORM: {
            INPUT: {
              NAME: 'Nombre',
              DESCRIPTION: 'Descripción',
              API_KEY: 'API KEY',
              ACCOUNT_ID: 'ACCOUNT ID',
              CUSTOM_CONCEPT: 'Concepto personalizado',
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el "Texto a mostrar" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: '',
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        ADYEN: {
          FORM: {
            INPUT: {
              TEXT: {
                INFO: '',
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        PAYU: {
          FORM: {
            INPUT: {
              TEXT: {
                INFO: '',
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
        PAYNOPAIN: {
          FORM: {
            INPUT: {
              TEXT: {
                MESSAGE:
                  'Utiliza estas etiquetas en el campo "Concepto de pago personalizado" para personalizar tus mensajes:',
                LABELS: {
                  NAME: 'Nombre largo',
                  CLIENT_ID: 'ID del cliente',
                  NIF: 'NIF',
                  TITLE: 'Título',
                  OPERATION_ID: 'ID operación',
                  PERSONALIZADO: '$PERSONALIZADO$',
                },
                INFO: '',
              },
            },
            BUTTON: {
              CANCEL: 'Cancelar',
              SAVE: 'Guardar',
            },
          },
        },
      },
      CREDIT_WALLET: {
        PAGE_TITLE: 'Créditos',
        EMPTY: {
          TITLE: 'Sin cartera de créditos',
          SUBTITLE: 'Este tenant todavía no tiene una cartera de créditos. Contacta con tu administrador para configurarla.',
          CTA: 'Volver',
        },
        ERRORS: {
          LOAD_FAILED: 'No se ha podido cargar la cartera de créditos. Inténtalo de nuevo.',
        },
        OVERCONSUMPTION_BANNER: {
          BODY: 'Has superado los créditos disponibles. El servicio sigue activo pero se están acumulando créditos extra que se facturarán a fin de mes.',
        },
        WALLET_SUMMARY: {
          PLAN_CREDITS: 'Saldo del plan',
          PURCHASED_CREDITS: 'Saldo de recargas',
          OVERCONSUMPTION: 'Sobreconsumo',
          RENEWS_ON: 'Se renueva el',
          INCLUDED: 'incluidos',
          NO_EXPIRY: 'no caduca',
          THIS_MONTH: 'acumulado este mes',
          TOGGLE_CREDITS: 'Créditos',
          TOGGLE_EUROS: 'Euros',
          CYCLE: 'Ciclo:',
          CYCLE_TYPE: 'Consumo por tipología:',
        },
        TABS: {
          CURRENT_MONTH: 'Mes en curso',
          HISTORY: 'Historial',
          PURCHASES: 'Registro de compras',
        },
        CONSUMPTION_BREAKDOWN: {
          TITLE: 'Consumo por tipología',
          EMPTY: 'No hay consumo registrado este mes.',
          TOTAL: 'Total consumido',
        },
        HISTORY: {
          TITLE: 'Consumo mensual acumulado',
          EMPTY: 'No hay historial de consumo disponible.',
          LEGEND: {
            EMAIL: 'Email + cert.',
            SMS: 'SMS + cert.',
            WHATSAPP: 'WhatsApp IA',
            CALLS: 'Llamadas IA',
          },
        },
        CREDIT_TYPES: {
          EMAIL: 'Email',
          CERTIFIED_EMAIL: 'Email certificado',
          SMS: 'SMS',
          CERTIFIED_SMS: 'SMS certificado',
          WHATSAPP: 'WhatsApp IA',
          OUTBOUND_CALL: 'Llamadas IA',
        },
        PLANS: {
          STARTER: 'Starter',
          PROFESSIONAL: 'Professional',
          BUSINESS: 'Business',
          ENTERPRISE: 'Enterprise',
        },
        MANAGEMENT: {
          SECTION_LABEL: 'Gestión de cartera de créditos',
          LOADING: 'Cargando cartera...',
          NO_WALLET_TITLE: 'Sin cartera de créditos',
          NO_WALLET_BODY:
            'Este tenant no tiene cartera de créditos. Crea una para activar los servicios basados en créditos.',
          CREATE_TITLE: 'Crear cartera de créditos',
          CREATE_SUBTITLE: 'Asigna un plan para activar los créditos de este tenant.',
          CREATE_SUBMIT: 'Crear cartera',
          PURCHASE_TITLE: 'Comprar créditos',
          PURCHASE_SUBMIT: 'Añadir créditos',
          PLAN_LABEL: 'Plan',
          CUSTOM_PLAN_CREDITS_LABEL: 'Créditos del plan personalizado',
          CUSTOM_PLAN_CREDITS_PLACEHOLDER: 'Ej. 500000',
          CREDITS_LABEL: 'Créditos a añadir',
          CREDITS_PLACEHOLDER: 'Ej. 500',
          REFERENCE_LABEL: 'Referencia de factura',
          REFERENCE_PLACEHOLDER: 'Ej. INV-2026-001',
          REFERENCE_HINT: 'Referencia interna para conciliación de facturación.',
          PLAN_CREDITS: 'Saldo de plan',
          PURCHASED_CREDITS: 'Saldo comprado',
          OVERCONSUMPTION: 'Sobreconsumo',
          RENEWS_ON: 'Se renueva el',
          CREATE_SUCCESS_TITLE: 'Cartera creada',
          CREATE_SUCCESS_BODY: 'La cartera de créditos se ha creado correctamente.',
          PURCHASE_SUCCESS_TITLE: 'Créditos añadidos',
          PURCHASE_SUCCESS_BODY: 'Los créditos se han añadido a la cartera correctamente.',
          ERRORS: {
            TITLE: 'Error',
            LOAD_FAILED: 'No se ha podido cargar la cartera de créditos. Inténtalo de nuevo.',
            CREATE_FAILED: 'No se ha podido crear la cartera de créditos. Inténtalo de nuevo.',
            PURCHASE_FAILED: 'No se han podido añadir los créditos. Inténtalo de nuevo.',
          },
        },
        PURCHASE_HISTORY: {
          TITLE: 'Historial de compras',
          EMPTY: 'No hay compras de créditos registradas.',
          COL_DATE: 'Fecha',
          COL_CREDITS: 'Créditos',
          COL_REFERENCE: 'Referencia',
        },
      },
    },
  },
};
